const ger = {
	translations: {
		// Geschäftstätigkeit nach der Aktivierung, Freigabe zur Überarbeitung (Anforderung #230)
		'Business change hygiene dropped': "Die Bestätigung zur Lebensmittelhygiene/Allergenschulung entfällt (die bisherige bleibt im Verlauf stehen).",
		'Business change hygiene required': "Die Bestätigung zur Lebensmittelhygiene/Allergenschulung wird neu verlangt — die Schüler:innen sehen den Hinweis im Unternehmensprofil.",
		'Business change hygiene kept': "Die bestehende Bestätigung zur Lebensmittelhygiene/Allergenschulung gilt weiter.",
		'Business change certificate renewed': "Der Firmenbuchauszug wird neu erzeugt.",
		'Business change lists follow': "Listen, Statistiken und die Expert:innen-Zuordnung zeigen ab sofort die neue Branche.",
		'Business change activation stays': "Die Aktivierung bleibt bestehen; Schüler:innen und Lehrkräfte sehen die Änderung unter „Nachrichten der Administration\".",
		'No changes to save': "Es gibt nichts zu speichern.",
		'Change business activity?': "Geschäftstätigkeit ändern?",
		'Business change what changes': "Das ändert sich:",
		'Business change consequences': "Folgen:",
		'Business change certificate failed': "Gespeichert — aber der Firmenbuchauszug konnte nicht neu erzeugt werden. Bitte unter „Dokumente\" prüfen oder später erneut speichern.",
		'Business change saved, certificate renewed': "Gespeichert, der Firmenbuchauszug wurde neu erzeugt.",
		'Release for revision': "Bearbeitung freigeben",
		'Release for revision explanation': "Die Schüler:innen können Geschäftstätigkeit (auch die Branche) und Markt- und Risikoanalyse wieder bearbeiten. Die Aktivierung bleibt bestehen, es wird nichts erneut geprüft.",
		'Released until (inclusive)': "Freigegeben bis einschließlich",
		'Until revoked': "Bis zum Zurücknehmen (ohne Ablaufdatum)",
		'Release': "Freigeben",
		'Please choose an end date': "Bitte ein Enddatum wählen oder „Bis zum Zurücknehmen\" ankreuzen.",
		'Released for revision': "Zur Überarbeitung freigegeben",
		'Revoke release?': "Freigabe zurücknehmen?",
		'Revoke release explanation': "Die Schüler:innen können Branche und Markt- und Risikoanalyse danach nicht mehr bearbeiten. Bereits Gespeichertes bleibt.",
		'Revoke release': "Freigabe zurücknehmen",
		'Release revoked': "Freigabe zurückgenommen",
		'Released for revision until further notice': "Für die Schüler:innen zur Überarbeitung freigegeben — bis zum Zurücknehmen.",
		'Released for revision until {{date}}': "Für die Schüler:innen zur Überarbeitung freigegeben bis einschließlich {{date}}.",
		'Release expired on {{date}}': "Gesperrt — die letzte Freigabe ist mit {{date}} abgelaufen.",
		'Locked for students since the activation': "Gesperrt — seit der Aktivierung können die Schüler:innen Branche und Markt- und Risikoanalyse nicht mehr ändern.",
		'Editing by the students': "Bearbeitung durch die Schüler:innen",
		'Editing by the students note': "Gilt für die Geschäftstätigkeit (samt Branche) und die Markt- und Risikoanalyse.",
		'Change release period': "Freigabe ändern",
		'Release editing for students': "Bearbeitung für Schüler:innen freigeben",
		'Released for revision by the administration until further notice': "Von der Verwaltung zur Überarbeitung freigegeben — bis auf Weiteres.",
		'Released for revision by the administration until {{date}}': "Von der Verwaltung zur Überarbeitung freigegeben bis {{date}}.",
		'Business activity changed': "Geschäftstätigkeit geändert",
		'Market and risk analysis changed during the release': "Markt- und Risikoanalyse während der Freigabe geändert",
		// Konto einer Lehrkraft löschen (Anforderung #239)
		'Teacher account deleted': 'Lehrkraft-Konto gelöscht',
		teacherRemovalNoSchool: 'keiner Schule zugeordnet',
		teacherRemovalCompanies: 'Zugeordnete Junior Companies:',
		teacherRemovalNoCompanies: 'keine',
		teacherRemovalItemSupervision: 'Zuordnungen zu Junior Companies',
		teacherRemovalItemRequests: 'offene Betreuungsanfragen',
		teacherRemovalKept:
			'Was der Junior Company, der Schule oder der Verwaltung gehört, bleibt — ohne Verweis auf die Person ({{count}} Einträge: z. B. Bewertungen im Konzept, Anfragen, Verlaufszeilen).',
		teacherRemovalOnlyTeacher:
			'{{name}} ist die einzige Lehrkraft der Junior Company „{{company}}“. Bitte zuerst im Profil der Junior Company eine andere betreuende Lehrkraft eintragen oder die Lehrkraft mit einem anderen Konto zusammenführen.',
		teacherRemovalSupervisionPasses:
			'{{name}} ist die betreuende Lehrkraft von „{{company}}“. Die Betreuung übernimmt danach {{successor}}.',
		teacherRemovalNotATeacher: 'Gelöscht werden können hier nur Konten von Lehrkräften.',
		// Konto einer Schüler:in löschen (Anforderung #226)
		'Student account deleted': 'Schüler:in-Konto gelöscht',
		'Delete account': 'Konto löschen',
		studentRemovalTitle: 'Konto endgültig löschen?',
		studentRemovalNoCompany: 'keiner Junior Company zugeordnet',
		studentRemovalDeletedHeading: 'Gelöscht wird:',
		studentRemovalItemAccount: 'das Konto samt Anmeldung, persönlichen Daten und Profilbild',
		studentRemovalItemDocuments: 'persönliche Nachweise (Elternbestätigung, Kursnachweis, Urkunde, Teilnahmebestätigung) samt Dateien',
		studentRemovalItemNotifications: 'Mitteilungen an die Person',
		studentRemovalItemCourse: 'Lernstrecken- und Quizfortschritt',
		studentRemovalItemConcept: 'Zuteilungen und Befreiungen im Skills4Retail-Konzept',
		studentRemovalItemInvitations: 'Einladungen an ihre E-Mail-Adresse',
		studentRemovalItemComments: 'Kommentare der Verwaltung zu dieser Person',
		studentRemovalItemSettings: 'weitere persönliche Einstellungen',
		studentRemovalKept:
			'Was der Junior Company oder der Verwaltung gehört, bleibt — ohne Verweis auf die Person ({{count}} Einträge: z. B. Berichte, Rechnungen, Anteilseigner:innen, Anfragen, Verlaufszeilen).',
		studentRemovalFinal: 'Das Löschen ist endgültig und lässt sich nicht rückgängig machen.',
		studentRemovalTypeLastName: 'Zum Bestätigen bitte den Nachnamen „{{lastName}}" eingeben:',
		studentRemovalConfirm: 'Endgültig löschen',
		studentRemovalDone: 'Das Konto von {{name}} wurde gelöscht.',
		studentRemovalBlockedTitle: 'Konto kann nicht gelöscht werden',
		studentRemovalLastStudent:
			'{{name}} ist die einzige Schüler:in der Junior Company „{{company}}". Bitte stattdessen die Junior Company löschen.',
		studentRemovalCeo:
			'{{name}} hat die Geschäftsführung von „{{company}}". Danach hat die Junior Company keine Geschäftsführung, bis die Schüler:innen sie unter „Mitarbeiter:innen" neu vergeben.',
		studentRemovalBelowTwo:
			'„{{company}}" ist aktiviert und hat danach nur noch {{count}} Schüler:in — die Voraussetzung „mindestens zwei Mitarbeiter:innen" ist dann nicht mehr erfüllt.',
		studentRemovalNotAStudent: 'Gelöscht werden können hier nur Konten von Schüler:innen.',
		// Nur-Lese-Zugang Alumni (Anforderung #213)
		'Read-only access': 'Nur-Lese-Zugang',
		'readOnlyAccessHint': 'Sie sehen die Datenbank bundesweit, aber nur lesend: ohne Kontaktdaten von Schüler:innen und Lehrkräften, ohne Dokumente und Exporte.',
		'ALUMNI': 'Alumni',
		'alumniRoleHint': 'Alumni (JA Alumni Austria) sehen bundesweit, was in der Datenbank neu ist — nur lesend, mit Namen, aber ohne Kontaktdaten von Schüler:innen und Lehrkräften, ohne Dokumente und Exporte. Kein Zugang zu Anforderungen, Einstellungen, Administration und Kommunikation.',
		'alumniResponsibilityHint': 'Bundesweit, nur lesend — kein Bundesland.',
		'invitedByRoleALUMNI': 'Alumni',
		'Invited person': 'Eingeladene Person',
		// ALUMNI-ENDE
		// Erinnerungen per E-Mail der Verwaltung (Profil + Administration, 14.10.2026)
		'Reminders': 'Erinnerungen',
		'Email reminders': 'Erinnerungen per E-Mail',
		'Assigned requirements': 'Zugewiesene Anforderungen',
		'Open reviews': 'Offene Prüfungen',
		'reminderAssignedHint': 'Übersicht der Ihnen zugewiesenen Anforderungen, die weder abgeschlossen noch verworfen sind: die Anzahl und die fünf dringendsten. Ist nichts offen, kommt keine Mail. Wer sie eingeschaltet hat, bekommt die wöchentliche Übersicht aus den Einstellungen nicht zusätzlich.',
		'reminderReviewsHintState': 'Was im eigenen Bundesland auf die Verwaltung wartet: Unternehmen zur Freigabe, ungeprüfte Einverständniserklärungen und Kursnachweise, unbeantwortete Anfragen. Jede Zeile der Mail führt auf die gefilterte Liste. Ist überall null, kommt keine Mail.',
		'reminderReviewsHintFederal': 'Was in ganz Österreich auf die Verwaltung wartet: Unternehmen zur Freigabe, ungeprüfte Einverständniserklärungen und Kursnachweise, Unterstützer:innen vor der Freigabe, unbeantwortete Anfragen. Jede Zeile der Mail führt auf die gefilterte Liste. Ist überall null, kommt keine Mail.',
		'Rhythm': 'Takt',
		'reminderFrequencyOFF': 'Aus',
		'reminderFrequencyDAILY': 'Täglich',
		'reminderFrequencyWEEKLY': 'Wöchentlich',
		'Weekday': 'Wochentag',
		'reminderWeekday1': 'Montag',
		'reminderWeekday2': 'Dienstag',
		'reminderWeekday3': 'Mittwoch',
		'reminderWeekday4': 'Donnerstag',
		'reminderWeekday5': 'Freitag',
		'reminderWeekday6': 'Samstag',
		'reminderWeekday7': 'Sonntag',
		'reminderWeekdayShort1': 'Mo',
		'reminderWeekdayShort2': 'Di',
		'reminderWeekdayShort3': 'Mi',
		'reminderWeekdayShort4': 'Do',
		'reminderWeekdayShort5': 'Fr',
		'reminderWeekdayShort6': 'Sa',
		'reminderWeekdayShort7': 'So',
		'reminderDailyShort': 'täglich',
		'reminderShortASSIGNED_TICKETS': 'Anforderungen',
		'reminderShortOPEN_REVIEWS': 'Prüfungen',
		'Time (Vienna)': 'Uhrzeit (Wiener Zeit)',
		'Additionally right away when newly assigned': 'Zusätzlich sofort bei neuer Zuweisung',
		'Next check': 'Nächster Zeitpunkt',
		'Last sent': 'Zuletzt verschickt',
		'No reminder sent yet': 'Noch keine Erinnerung verschickt',
		'Not saved yet': 'Noch nicht gespeichert',
		'Save reminders': 'Erinnerungen speichern',
		'Reminders saved': 'Erinnerungen gespeichert',
		'Reminders could not be saved.': 'Die Erinnerungen ließen sich nicht speichern.',
		'Reminders could not be loaded.': 'Die Erinnerungen ließen sich nicht laden.',
		'Loading reminders': 'Erinnerungen werden geladen …',
		'remindersOwnHint': 'Gilt nur für Ihr eigenes Konto. Die Bundesadministration kann die Erinnerungen aller Verwaltungskonten unter „Administration“ einstellen; jede Änderung steht im Verlauf des Kontos.',
		'remindersOtherHint': 'Sie stellen die Erinnerungen dieses Kontos ein. Die Person sieht sie unter „Mein Profil“; die Änderung steht im Reiter „Kommentare“.',
		'No reminders': 'Keine Erinnerungen',
		'Reminder changes': 'Erinnerungen geändert',
		'Course certificate status': 'Kursnachweis',
		// Einstellungen → Anfragen: Zuständig für Skills4Retail-Anfragen (#216)
		'Responsible for Skills4Retail requests':
			'Zuständig für Skills4Retail-Anfragen',
		'Account #{{val1}} (no longer a federal admin)':
			'Konto #{{val1}} (kein Bundesadmin mehr)',
		'Example: Viktoria Vidackovic is selected — a student asks about the third quiz in chapter 3 via the help button and chooses „Skills4Retail“. The request is assigned to Viktoria Vidackovic and booked to the project „Skills4Retail“; the state support of the student does not receive it.':
			'Beispiel: Viktoria Vidackovic ist ausgewählt — eine Schülerin fragt über den Hilfe-Knopf nach der dritten Quizfrage in Kapitel 3 und wählt „Skills4Retail“. Die Anfrage ist Viktoria Vidackovic zugewiesen und auf das Projekt „Skills4Retail“ gebucht; die Landesbetreuung der Schülerin bekommt sie nicht.',
		'Without a selection, Skills4Retail requests go to the responsible state support like every other request — the project is still set.':
			'Ohne Auswahl gehen Skills4Retail-Anfragen wie jede andere Anfrage an die zuständige Landesbetreuung — das Projekt wird trotzdem gesetzt.',
		'In the help form, students and teachers can choose „Skills4Retail“ as a fourth topic. Such requests are assigned automatically to the person selected here, so that one person handles all of them across the federal states. The assignment appears in the history of the request, and the person receives the usual message about a new request. Supporters do not see this topic.':
			'Im Hilfe-Formular können Schüler:innen und Lehrkräfte „Skills4Retail“ als viertes Anliegen wählen. Solche Anfragen werden automatisch der hier gewählten Person zugewiesen, damit eine Person sie über alle Bundesländer hinweg bearbeitet. Die Zuweisung steht im Verlauf der Anfrage, und die Person bekommt die gewohnte Mitteilung über eine neue Anfrage. Unterstützer:innen sehen dieses Anliegen nicht.',
		'Responsible person':
			'Zuständige Person',
		'Nobody — usual way via the federal state':
			'Niemand — gewohnter Weg über das Bundesland',
		'Project':
			'Projekt',
		'No project':
			'Kein Projekt',
		'Free · no account needed': 'Kostenlos · ohne Konto',
		'Skills4Retail — your online shop course': 'Skills4Retail – Marketing & E-Commerce',
		'The turbo for your Junior Company: how an online shop earns money, how customers find you, what you sell and where you get it, payment, shipping, marketing. Test yourself after every chapter.':
			'Der Turbo für eure Junior Company: wie ein Onlineshop Geld verdient, wie euch Kund:innen finden, was ihr verkauft und woher es kommt, Bezahlen, Versand, Marketing. Nach jedem Kapitel testest du dich selbst.',
		'Start the course': 'Kurs starten',
		// Die symbolische Kachel der Startseite, solange keine Junior Company eingetragen ist
		'The new school year starts here': 'Hier beginnt das neue Schuljahr',
		'No Junior Company is listed yet — yours could be the first.':
			'Noch ist keine Junior Company eingetragen — eure könnte die erste sein.',
		'Found your Junior Company': 'Junior Company gründen',
		// Der wechselnde Aufmacher der öffentlichen Startseite (components/NewsBanner)
		'Annual report · school year 2025/26': 'Jahresbericht · Schuljahr 2025/26',
		'Junior-Bilanz 2025/26': 'Junior-Bilanz 2025/26',
		'592 Junior Companies, 4,966 students at 185 schools in 9 federal states — and 281 companies that made it all the way to the certificate. The public edition shows what a school year of Junior moves.':
			'592 Junior Companies, 4.966 Schüler:innen an 185 Schulen in 9 Bundesländern — und 281 Unternehmen, die es bis zur Urkunde geschafft haben. Die öffentliche Fassung zeigt, was ein Schuljahr Junior bewegt.',
		'Read the report': 'Bilanz ansehen',
		'Public edition · without financial results · excl. Junior Mini Companies':
			'Öffentliche Fassung · ohne finanzielle Ergebnisse · exkl. Junior Mini Companies',
		News: 'Neuigkeiten',
		'AI-generated': 'KI-generiert',
		'10 chapters · 5 questions each · about 15 minutes per chapter':
			'10 Kapitel · je 5 Fragen · rund 15 Minuten pro Kapitel',
		'Thank you — your request has arrived.': 'Danke — Ihre Anfrage ist angekommen.',
		'It has the number #{{val1}}.': 'Sie trägt die Nummer #{{val1}}.',
		'We will look into it as soon as possible. You will find it — and the answer — under „My requests", and you will receive a message as soon as there is news.':
			'Wir sehen sie uns so rasch wie möglich an. Sie finden sie — und die Antwort darauf — unter „Meine Anfragen", und Sie bekommen eine Mitteilung, sobald es Neues gibt.',
		'To my requests': 'Zu meinen Anfragen',
		'Fehlerbehebung — etwas funktioniert nicht': 'Fehlerbehebung — etwas funktioniert nicht',
		'Anpassungsbedarf — etwas sollte anders sein': 'Anpassungsbedarf — etwas sollte anders sein',
		'Klärungsbedarf — etwas ist unklar': 'Klärungsbedarf — etwas ist unklar',
		'Skills4Retail — Fragen zum Konzept und zur Lernstrecke':
			'Skills4Retail — Fragen zum Konzept und zur Lernstrecke',
		'These details are sent along': 'Diese Angaben werden mitgeschickt',
		Role: 'Rolle',
		Browser: 'Browser',
		Window: 'Fenster',
		'Junior Company or school are added automatically, so that the report can be retraced.':
			'Junior Company bzw. Schule kommen automatisch dazu, damit sich die Meldung nachvollziehen lässt.',
		'Continue later': 'Später weiter',
		Discard: 'Verwerfen',
		'Discard draft?': 'Entwurf verwerfen?',
		'Text and attachments will be lost.': 'Text und Anhänge gehen dabei verloren.',
		'Saved as a draft — the help button brings it back.':
			'Als Entwurf gespeichert — über den Hilfe-Knopf geht es weiter.',
		'Your saved draft has been restored.': 'Ihr gespeicherter Entwurf wurde wiederhergestellt.',
		Student: 'Schüler:in',
		Teacher: 'Lehrkraft',
		Supporter: 'Unterstützer:in',
		'or drag it here or paste it with Ctrl+V': 'oder hierher ziehen bzw. mit Strg+V einfügen',
		'Only PNG, JPEG and PDF are possible.': 'Angenommen werden PNG, JPEG und PDF.',
		Screenshot: 'Bildschirmfoto',
		'Show larger': 'Vergrößert ansehen',
		'My requests': 'Meine Anfragen',
		'Your requests could not be loaded.': 'Ihre Anfragen konnten nicht geladen werden.',
		'You have not submitted any requests yet. Use the help button at the bottom right.':
			'Sie haben noch keine Anfrage gestellt. Der Hilfe-Knopf steht unten rechts.',
		'You have not submitted any requests yet.': 'Sie haben noch keine Anfrage gestellt.',
		'This request could not be loaded.': 'Diese Anfrage konnte nicht geladen werden.',
		'Your message could not be sent.': 'Ihre Nachricht konnte nicht gesendet werden.',
		'That did not work.': 'Das hat nicht geklappt.',
		'Withdraw request?': 'Anfrage zurückziehen?',
		'The request will be closed. You can always submit a new one.':
			'Die Anfrage wird geschlossen. Eine neue lässt sich jederzeit stellen.',
		Withdraw: 'Zurückziehen',
		'Thank you — the request is closed.': 'Danke — die Anfrage ist abgeschlossen.',
		Request: 'Anfrage',
		'Your answer': 'Ihre Antwort',
		'Add something': 'Etwas ergänzen',
		Send: 'Senden',
		'That solves it': 'Damit ist es erledigt',
		'Not yet solved': 'Noch nicht erledigt',
		'Your request has been answered': 'Ihre Anfrage wurde beantwortet',
		'Read the answer': 'Antwort lesen',
		'Question about your request': 'Rückfrage zu Ihrer Anfrage',
		'Answer now': 'Jetzt antworten',
		'Your request is closed': 'Ihre Anfrage ist abgeschlossen',
		'Your request will not be pursued': 'Ihre Anfrage wird nicht weiterverfolgt',
		'Reply to request': 'Antwort auf eine Anfrage',
		'Request still unanswered': 'Anfrage weiterhin unbeantwortet',
		'Request is waiting': 'Anfrage wartet',
		'Your request has been received': 'Ihre Anfrage ist eingegangen',
		'We will get back to you here.': 'Wir melden uns hier bei Ihnen.',
		'New request': 'Neue Anfrage',
		'To the requirements': 'Zu den Anforderungen',
		Help: 'Hilfe',
		'Help and feedback': 'Hilfe und Rückmeldung',
		'Submit a request': 'Anfrage stellen',
		'Hide the help button': 'Hilfe-Knopf ausblenden',
		'Hide — it comes back after {{val1}} page changes': 'Ausblenden — er kommt nach {{val1}} Seitenwechseln wieder',
		'How can we help?': 'Wie können wir helfen?',
		'What is it about?': 'Worum geht es?',
		'Something is not working': 'Etwas funktioniert nicht',
		'I would like something': 'Ich wünsche mir etwas',
		'I have a question': 'Ich habe eine Frage',
		'In short': 'Kurz gesagt',
		'What happened?': 'Was ist passiert?',
		'What did you do, what happened, and what did you expect?':
			'Was haben Sie gemacht, was ist passiert, und was hatten Sie erwartet?',
		'Attach a screenshot or PDF': 'Bildschirmfoto oder PDF anhängen',
		'up to {{val1}} files, {{val2}} MB each': 'bis {{val1}} Dateien, je {{val2}} MB',
		remove: 'entfernen',
		'We send these details along': 'Diese Angaben schicken wir mit',
		Page: 'Seite',
		View: 'Ansicht',
		'Plus your role, your Junior Company or school, browser and window size — so that we can retrace what you saw.':
			'Dazu Ihre Rolle, Ihre Junior Company bzw. Schule, Browser und Fenstergröße — damit wir nachvollziehen können, was Sie gesehen haben.',
		'Please do not include passwords. For questions about your company, your teacher is the first port of call.':
			'Bitte schreiben Sie keine Passwörter hinein. Für Fragen zu eurem Unternehmen ist zuerst eure Lehrkraft da.',
		'Send request': 'Anfrage senden',
		'Sending …': 'Wird gesendet …',
		'Thank you! Your request has been received under number #{{val1}}.':
			'Danke! Ihre Anfrage ist unter der Nummer #{{val1}} eingegangen.',
		'The request could not be sent.': 'Die Anfrage konnte nicht abgeschickt werden.',
		'Please say in one sentence what this is about.': 'Bitte sagen Sie in einem Satz, worum es geht.',
		'Please describe briefly what happened (at least {{val1}} characters).':
			'Bitte beschreiben Sie kurz, was passiert ist (mindestens {{val1}} Zeichen).',
		'„{{val1}}“ is larger than {{val2}} MB.': '„{{val1}}“ ist größer als {{val2}} MB.',
		'At most {{val1}} files are possible.': 'Es sind höchstens {{val1}} Dateien möglich.',
		'e.g. „Invoice will not open“': 'z. B. „Rechnung lässt sich nicht öffnen“',
		communication: 'Kommunikation',
		Rendered: 'Gerendert',
		'HTML source': 'HTML-Quelltext',
		'Text source': 'Quelltext',
		'Sample data': 'Beispieldaten',
		'No sample data.': 'Keine Beispieldaten.',
		'This event also triggers an internal message:': 'Zu diesem Ereignis gibt es auch eine interne Nachricht:',
		'This event also triggers an email:': 'Zu diesem Ereignis gibt es auch eine E-Mail:',
		'Switch to source to edit. The preview uses the sample data on the right.':
			'Zum Bearbeiten auf Quelltext umschalten. Die Vorschau nutzt die Beispieldaten rechts.',
		Change: 'Ändern',
		'Some entries are incomplete — the affected steps are marked with a dot.':
			'Es fehlen noch Angaben — die betroffenen Schritte sind mit einem Punkt gekennzeichnet.',
		Time: 'Uhrzeit',
		'Email templates': 'E-Mail-Vorlagen',
		'Internal messages': 'Interne Nachrichten',
		'Document templates': 'Dokumentvorlagen',
		Overview: 'Übersicht',
		Phases: 'Phasen',
		Channel: 'Kanal',
		Template: 'Vorlage',
		Email: 'E-Mail',
		Internal: 'Intern',
		Automatic: 'Automatik',
		'sent by the nightly reminder job': 'wird vom nächtlichen Erinnerungslauf versendet',
		'The axis shows the phases of a Junior Company, not calendar dates. Click a bar for the template details.':
			'Die Achse zeigt die Phasen einer Junior Company, keine Kalendertermine. Ein Klick auf einen Balken öffnet die Vorlage.',
		'No templates match the current filter.': 'Zur aktuellen Auswahl gibt es keine Vorlagen.',
		'In the handbook: Documents & certificates': 'Im Handbuch: Dokumente & Urkunden',
		Static: 'Statisch',
		'Live preview': 'Live-Vorschau',
		'The current template is rendered with real (neutralized) production data.':
			'Die aktuelle Vorlage wird mit echten (neutralisierten) Produktivdaten gerendert.',
		'No matching production data found.': 'Keine passenden Produktivdaten gefunden.',
		'Production data record': 'Produktivdatensatz',
		'View PDF': 'PDF ansehen',
		'Download PDF': 'PDF herunterladen',
		'Generating...': 'Wird erzeugt …',
		'PDF could not be generated': 'PDF konnte nicht erzeugt werden',
		'Communication templates could not be loaded': 'Kommunikationsvorlagen konnten nicht geladen werden',
		Search: 'Suchen',
		Subject: 'Betreff',
		Inactive: 'Inaktiv',
		Placeholders: 'Platzhalter',
		Edited: 'Bearbeitet',
		'Template could not be loaded': 'Vorlage konnte nicht geladen werden',
		'Back to overview': 'Zurück zur Übersicht',
		'Target group': 'Zielgruppe',
		Administration: 'Administration',
		'Triggered by': 'Ausgelöst durch',
		'Read more': 'Mehr lesen',
		Less: 'Weniger',
		'Last edited': 'Zuletzt bearbeitet',
		'Live templates': 'Scharf geschaltete Vorlagen',
		'These texts are actually sent to users. Edits take effect immediately.':
			'Diese Texte werden tatsächlich an Nutzer:innen versendet. Änderungen wirken sofort.',
		'Active (is being sent)': 'Aktiv (wird versendet)',
		'Insert placeholder': 'Platzhalter einfügen',
		'Edit template?': 'Vorlage bearbeiten?',
		'Changes to this template go live immediately. From the next trigger onward, the edited version is sent to real recipients.':
			'Änderungen an dieser Vorlage werden sofort scharf geschaltet. Ab dem nächsten Auslöser wird die bearbeitete Fassung an echte Empfänger:innen versendet.',
		'Edit now': 'Jetzt bearbeiten',
		'Activate template for real sending?': 'Vorlage scharf schalten?',
		'On saving, this template is switched live and will be sent to real recipients from the next trigger. Continue?':
			'Beim Speichern wird diese Vorlage scharf geschaltet und ab dem nächsten Auslöser an echte Empfänger:innen versendet. Fortfahren?',
		'Note for the change log (optional)': 'Notiz für den Änderungslog (optional)',
		'e.g. Wording adjusted': 'z. B. Formulierung angepasst',
		'Save and activate': 'Speichern und scharf schalten',
		'Template saved and activated': 'Vorlage gespeichert und scharf geschaltet',
		'Template could not be saved': 'Vorlage konnte nicht gespeichert werden',
		'Preview with sample data': 'Vorschau mit Beispieldaten',
		Record: 'Datensatz',
		'Refresh preview': 'Vorschau aktualisieren',
		Preview: 'Vorschau',
		'Preview could not be rendered': 'Vorschau konnte nicht erzeugt werden',
		'Saving...': 'Speichern …',
		'Change log': 'Änderungslog',
		'No changes yet.': 'Noch keine Änderungen.',
		dashboard: 'Dashboard',
		companyProfile: 'Unternehmensprofil',
		riskAnalysis: 'Markt- und Risikoanalyse',
		employees: 'Mitarbeiter:innen',
		documents: 'Dokumente',
		// Der Menuepunkt heisst nach dem, was dort steht: die Personen, die
		// Anteile gezeichnet haben - nicht die Anteile selbst.
		shares: 'Anteilseigner:innen',
		reports: 'Berichte',
		Reports: 'Berichte',
		experts: 'Experten',
		companies: 'Unternehmen',
		students: 'Schüler:innen',
		users: 'Benutzer:innen',
		invoices: 'Rechnungen',
		income: 'Einnahmen',
		emailNewsletter: 'E-Mail-Newsletter',
		newsPages: 'Nachrichtenseiten',
		stateAdmins: 'Administration',
		schools: 'Schulen',
		settings: 'Einstellungen',
		profile: 'Profil',
		exit: 'Abmelden',
		'Economic experts': 'Wirtschaftsexperten',

		// --- Gruppen der Einstellungen ---
		'Master data': 'Stammdaten',
		'Junior Companies': 'Junior Companies',
		Finances: 'Finanzen',
		'Deadlines & reminders': 'Fristen & Erinnerungen',
		System: 'System',

		// --- Unterstuetzer:innen-Modul ---
		supporters: 'Unterstützer:innen',
		supportRequests: 'Unterstützungsbedarf',
		handbook: 'Handbuch',
		presentations: 'Präsentationen',
		presentationsIntro: 'Vertonte Kurzpräsentationen der Plattform für Partner, etwa andere JA-Organisationen in Europa. Abspielen, vorführen oder als PDF weitergeben.',
		presentationOpen: 'Präsentation öffnen',
		presentationAll: 'Alle Präsentationen',
		presentationPlay: 'Abspielen',
		presentationPause: 'Pause',
		presentationRestart: 'Von vorn',
		presentationPrev: 'Zurück',
		presentationNext: 'Weiter',
		presentationVoice: 'Stimme',
		presentationMusic: 'Musik',
		presentationTempo: 'Tempo',
		presentationPdf: 'PDF herunterladen',
		presentationFullscreen: 'Vollbild',
		presentationKeys: 'Tasten: Leertaste abspielen/anhalten · ←/→ blättern · M Musik · S Stimme · F Vollbild',
		presentationLanguage: 'Sprache: {{language}}',
		presentationMinutes: 'rund {{count}} Minuten',
		presentationSlides: '{{count}} Folien',
		presentationNotFound: 'Diese Präsentation gibt es nicht.',
		tickets: 'Anforderungen & Anfragen',
		changelog: 'Entwicklungen',
		roles: 'Rollen',
		status: 'Status',
		firstName: 'Vorname',
		lastName: 'Nachname',
		email: 'E-Mail-Adresse',
		company: 'Unternehmen',
		// Anforderung #1: Bei Unterstuetzer:innen heisst das Feld "Funktion",
		// nicht "Position". Der Feldname in Daten und Schnittstelle bleibt
		// unveraendert - umbenannt wird nur, was zu sehen ist.
		position: 'Funktion',
		city: 'Ort',
		edit: 'Bearbeiten',
		delete: 'Löschen',
		name: 'Name',
		Bio: 'Kurzprofil',
		password: 'Passwort',
		repeatPassword: 'Passwort wiederholen',
		supporter: 'Unterstützer:in',
		myProfile: 'Mein Profil',
		myConnections: 'Meine Verbindungen',
		supporterRoleEXPERT: 'Wirtschaftsexpert:in',
		supporterRoleJURY: 'Jury-Mitglied',
		supporterRoleTRAINER: 'Trainer:in',
		possibleRoles: 'Mögliche Rollen als Unterstützer:in',
		supporterStatusAll: 'Alle',
		supporterStatusTileHint: 'Klicken, um die Liste auf diesen Status einzuschränken',
		supporterStatusINVITED: 'Eingeladen',
		supporterStatusPENDING_APPROVAL: 'Wartet auf Freigabe',
		supporterStatusACTIVE: 'Aktiv',
		supporterStatusUNAVAILABLE: 'Nicht verfügbar',
		supporterStatusARCHIVED: 'Archiviert',
		supporterStatusDELETED: 'Gelöscht',
		profileActive: 'Profil aktiv',
		profileActiveHint: 'Solange das Profil aktiv ist, sind Sie für Schulen sichtbar.',
		profileInactiveHint: 'Ihr Profil ist vorübergehend deaktiviert. Ihr Zugang bleibt bestehen.',
		unavailableUntil: 'Nicht verfügbar bis',

		// Befristete Pause (UI/UnavailableDialog). Der Dialog nennt immer beide
		// Daten — den letzten Tag der Abwesenheit und den Tag der Rückkehr:
		// „bis 14.08.“ allein lässt offen, ob der 14. noch dazugehört.
		pauseTitle: 'Profil auf „nicht verfügbar“ setzen',
		pauseLead:
			'Sie bleiben angemeldet und behalten alle Daten. Für Schulen sind Sie in dieser Zeit nicht auffindbar.',
		pauseLeadAdmin: 'Das Profil von {{name}} bleibt bestehen; für Schulen ist es in dieser Zeit nicht auffindbar.',
		pauseHowLong: 'Für wie lange?',
		pauseQuickOneWeek: '1 Woche',
		pauseQuickTwoWeeks: '2 Wochen',
		pauseQuickOneMonth: '1 Monat',
		pauseQuickThreeMonths: '3 Monate',
		pauseForDuration: 'Für einen Zeitraum',
		pauseUnit_days: 'Tage',
		pauseUnit_weeks: 'Wochen',
		pauseUnit_months: 'Monate',
		pauseUntilDate: 'Bis einschließlich',
		pauseOpenEnded: 'Ohne Enddatum',
		pauseOpenEndedHint: 'Das Profil bleibt so lange nicht verfügbar, bis es wieder aktiv gesetzt wird — von Hand.',
		pauseResult: 'Nicht verfügbar bis einschließlich {{last}} · automatisch wieder aktiv am {{back}}',
		pauseResultOpen: 'Kein Enddatum — das Profil wird nicht von selbst wieder aktiv.',
		pauseResultMissing: 'Bitte ein Enddatum ab heute wählen.',
		pauseEffectSearch: 'Das Profil erscheint nicht mehr in der Expert:innen-Suche der Schulen.',
		pauseEffectRequests: 'Neue Anfragen von Junior Companies sind in dieser Zeit nicht möglich.',
		pauseEffectRunning:
			'Laufende Zusammenarbeiten gehen weiter: Betreute Junior Companies sehen das Profil und die Kontaktdaten weiterhin.',
		pauseEffectAccess: 'Bereits offene, noch unbeantwortete Anfragen bleiben offen und werden weiter erinnert.',
		pauseEffectMail: 'Sie erhalten eine E-Mail — jetzt und noch einmal, sobald das Profil wieder aktiv ist.',
		pauseEffectMailAdmin:
			'Die Person erhält eine E-Mail — jetzt und noch einmal, sobald das Profil wieder aktiv ist.',
		pauseUntilNote: 'Nicht verfügbar bis einschließlich {{last}} · wieder aktiv am {{back}}',
		pauseOpenNote: 'Kein Enddatum hinterlegt — das Profil wird nicht von selbst wieder aktiv.',
		inviteSupporter: 'Unterstützer:in einladen',
		resendInvitation: 'Einladung erneut senden',
		withdrawInvitation: 'Einladung zurücknehmen',
		openInvitations: 'Offene Einladungen',
		approveSupporter: 'Freigeben',
		// Freigabe einer Selbstregistrierung (Anforderung #58): Zuständig ist die
		// Bundesebene, Maßstab eine kurze Recherche zur Person im Netz.
		approveSupporterTitle: 'Profil freigeben?',
		approveSupporterHint:
			'Prüfen Sie vorab kurz, ob die Person im Netz auffindbar und ihre Angabe plausibel ist. Nach der Freigabe ist das Profil für Schulen sichtbar und die Person wird per E-Mail informiert.',
		approveSupporterSearch: 'Person im Netz suchen',
		approveSupporterFederalOnly: 'Die Freigabe erfolgt durch die Bundesadministration.',
		deletePendingProfile: 'Registrierung löschen',
		deletePendingProfileHint:
			'Das Profil wird anonymisiert und verschwindet aus der Liste. Eine Benachrichtigung geht dabei nicht hinaus. Dieser Schritt lässt sich nicht rückgängig machen.',
		competences: 'Kompetenzen',
		availableCompetences: 'Verfügbare Kompetenzen',
		furtherCompetences: 'Weitere Kompetenzen',
		addOwnCompetence: 'Eigene Kompetenz hinzufügen...',
		noOwnCompetences: 'Keine eigenen Kompetenzen hinzugefügt.',
		targetGroups: 'Zielgruppen, die ich unterstützen möchte',
		schoolTypes: 'Schultypen',
		states: 'Bundesländer',
		relevantStatesHint:
			'Welche Bundesländer sind für Sie relevant? Sie können das später jederzeit in Ihrem Profil anpassen.',
		industries: 'Branchen',
		selectAll: 'Alle auswählen',
		all: 'Alle',
		// Junior Company Teilnahme der Unterstützer:innen (Anforderung #181)
		juniorAlumniTitle: 'Junior Company Teilnahme',
		juniorAlumniQuestion: 'Haben Sie selbst eines der von Junior Österreich angebotenen Programme absolviert?',
		juniorAlumniUnanswered: 'Noch nicht angegeben.',
		juniorAlumniSchool: 'Schule',
		juniorAlumniYear: 'Jahr der Teilnahme',
		juniorAlumniYearRange: 'Bitte ein Jahr zwischen {{min}} und {{max}} angeben.',
		juniorAlumniStates: 'Bundesländer der Teilnahme',
		juniorAlumniStatesHint: 'In welchem Bundesland bzw. welchen Bundesländern haben Sie teilgenommen?',
		juniorAlumniStatesRequired: 'Bitte mindestens ein Bundesland auswählen.',
		juniorAlumniIncomplete: 'Bitte die Angaben zur Junior Company Teilnahme vervollständigen.',
		trainingPortfolio: 'Trainings-Portfolio',
		addTraining: 'Neues Training hinzufügen',
		trainingTitle: 'Titel',
		trainingDuration: 'Dauer (Stunden)',
		trainingFormat: 'Format',
		formatONLINE: 'Online',
		formatPRESENCE: 'Präsenz',
		formatHYBRID: 'Hybrid',
		offers: 'Angebote',
		ourExperts: 'Unsere Expert:innen',
		matchingExperts: 'Passende Expert:innen',
		allExperts: 'Alle Expert:innen',
		ownExperts: 'Selbst erfasste Expert:innen',
		requestExpert: 'Expert:in anfragen',
		// Der Reiter „Passende Expert:innen" ist am 09.08.2026 zum Filter
		// geworden — eine Liste, die Passenden oben.
		Fit: 'Passgenauigkeit',
		onlyMatchingExperts: 'Nur passende',
		matchesYourCompany: 'Passt laut Profil zu eurer Junior Company.',
		notOpenForNewCompanies: 'Nimmt derzeit keine neuen Junior Companies an.',
		reachableVia: 'Erreichbar: {{modes}}',
		// Selbst erfasste Alteintraege: Hier wird nichts mehr angelegt.
		ownExpertsLegacyNote:
			'Diese Einträge habt ihr selbst erfasst — mit Angaben über eine Person, die davon zunächst nichts wusste. Neu anlegen lässt sich hier nichts mehr: Ladet die Person stattdessen über „Expert:in einladen" ein, dann trägt sie ihre Angaben selbst ein und stimmt selbst zu. Einträge, die niemand bestätigt hat, werden zum genannten Datum automatisch gelöscht.',
		expertRecordRemovedTitle: 'Selbst erfasster Eintrag gelöscht',
		expertRecordRemovedText:
			'Der Eintrag zu {{name}} wurde gelöscht: Die Person hat die Angaben über sie innerhalb von {{days}} Tagen nicht bestätigt. Wenn ihr weiter mit ihr arbeiten möchtet, ladet sie unter „Wirtschaftsexperten“ ein.',
		deletedOn: 'Wird am {{date}} gelöscht',
		// Umschalter zwischen Zeilen und Kachelraster (nur Sinnbilder — die
		// Woerter stehen als Kurzhinweis und fuer Vorlesewerkzeuge dahinter).
		viewMode: 'Darstellung',
		viewRows: 'Zeilen',
		viewTiles: 'Kacheln',
		requestSent: 'Anfrage gesendet',
		requestSentFor: 'Anfrage für {{company}} gesendet',
		// Erklaert die Leiste ueber den Reitern: Zusammengearbeitet wird mit einer
		// Junior Company, nicht mit der Lehrkraft.
		supporterCompanyScopeHint: 'Anfragen, Verbindungen und Vorschläge gelten immer für diese Junior Company.',
		// Steht nur bei Lehrkräften: Sie sehen denselben Bestand, aber keinen
		// Anfrage-Knopf. Ohne den Satz wirkt das wie ein Fehler (Anforderung #93).
		supporterRequestByStudentsHint:
			'Die Anfrage stellen die Schüler:innen der Junior Company selbst. Sie können hier mitstöbern und ihnen Expert:innen empfehlen.',
		contactDetails: 'Kontakt',
		endCollaboration: 'Zusammenarbeit beenden',
		endCollaborationTitle: 'Zusammenarbeit beenden?',
		endCollaborationText:
			'Die Zusammenarbeit mit {{company}} wird beendet. Die andere Seite wird darüber informiert. Eine neue Anfrage ist später jederzeit möglich.',
		collaborationEnded: 'Die Zusammenarbeit wurde beendet.',
		profileTab: 'Profil',
		collaboration: 'Zusammenarbeit',
		aboutPerson: 'Über diese Person',
		sendRequest: 'Anfrage senden',
		emailReadOnlyHint: 'Ihre Anmeldeadresse — sie lässt sich hier nicht ändern.',
		contactPreferences: 'Erreichbarkeit',
		contactPreferencesOwnHint:
			'Diese Angaben sehen Junior Companies schon vor einer Anfrage. Ihre Kontaktdaten selbst werden erst sichtbar, wenn Sie eine Anfrage angenommen haben.',
		contactModes: 'Bevorzugter Kontaktweg',
		contactTimes: 'Bevorzugte Zeiten',
		contactModeEMAIL: 'E-Mail',
		contactModePHONE: 'Telefon',
		contactModeVIDEO: 'Videocall',
		contactModeON_SITE: 'Persönliches Treffen',
		contactModeCHAT: 'Chat / Messenger',
		contactTimeWEEKDAY_MORNING: 'Werktags vormittags',
		contactTimeWEEKDAY_AFTERNOON: 'Werktags nachmittags',
		contactTimeWEEKDAY_EVENING: 'Werktags abends',
		contactTimeWEEKEND: 'Am Wochenende',
		contactTimeBY_ARRANGEMENT: 'Nach Vereinbarung',
		contactNote: 'Hinweis zur Kontaktaufnahme',
		contactNotePlaceholder: 'z. B. „Am besten per E-Mail, Rückruf innerhalb von zwei Tagen.“',
		noContactPreferences: 'Diese Person hat keine Angaben zur Erreichbarkeit gemacht.',
		contactHiddenHint: 'Die Kontaktdaten werden sichtbar, sobald eure Anfrage angenommen wurde.',
		makeRequest: 'Anfrage stellen',
		inviteExpert: 'Expert:in einladen',
		inviteExpertHint:
			'Ihr kennt jemanden, der euch begleiten könnte — aus der Familie, der Nachbarschaft, dem Praktikum? Ladet die Person direkt ein.',
		inviteForCompany: 'Für welche Junior Company?',
		inviteMessage: 'Persönliche Zeile (freiwillig)',
		inviteMessagePlaceholder:
			'z. B. „Wir haben beim Elternabend über unser Projekt gesprochen — wir würden uns über Ihre Unterstützung freuen.“',
		inviteExpertNotice:
			'Die Person bekommt eine E-Mail mit einem Link. Sobald sie ihr Profil aktiviert, arbeitet sie mit {{company}} zusammen — es braucht keine Freigabe durch Junior Achievement. Sichtbar ist ihr Profil zunächst nur für euch; ob sie darüber hinaus für alle Junior Companies auffindbar sein möchte, entscheidet sie selbst.',
		sendInvitation: 'Einladung senden',
		expertInvited: 'Einladung ist unterwegs',
		invitedByOwnCompany: 'Diese Person wurde von {{company}} eingeladen und steht deshalb nur euch zur Verfügung.',
		invitedByCompanyOnly:
			'Von der Junior Company {{company}} selbst eingeladen. Das Profil ist nur für sie sichtbar — die Person hat die allgemeine Auffindbarkeit nicht eingeschaltet.',
		invitedByCompanyOpen:
			'Von der Junior Company {{company}} selbst eingeladen. Die Person ist inzwischen für alle Junior Companies auffindbar.',
		visibleToAllCompanies: 'Für alle Junior Companies auffindbar',
		visibleToAllCompaniesOn:
			'Ihr Profil erscheint in der Expert:innen-Suche aller Junior Companies. Anfragen können Sie weiterhin einzeln annehmen oder ablehnen.',
		visibleToAllCompaniesOff:
			'Ihr Profil ist nur für {{company}} sichtbar — die Junior Company, die Sie eingeladen hat.',
		doesNotMatch: 'Passt laut Profil nicht zu eurer Junior Company: {{criteria}}. Anfragen könnt ihr trotzdem.',
		matchCriterionSTATE: 'Bundesland',
		matchCriterionINDUSTRY: 'Branche',
		matchCriterionSCHOOL_TYPE: 'Schultyp',
		logTab: 'Log-Verlauf',
		supporterCompanyLogHint:
			'Was zwischen euch und dieser Person passiert ist — Anfrage, Zusage, Ende — und was ihr euch dazu notiert.',
		supporterCompanyLogNoteHint:
			'Nur für eure Junior Company sichtbar. Die Expert:in bekommt davon keine Nachricht.',
		logForCompany: 'Für welche Junior Company?',
		// Steht in der Auswahl hinter Junior Companies, die diese Expert:in nie
		// angefragt haben — dort ist der Verlauf zu Recht leer.
		noRequestYet: 'Keine Anfrage',
		noCompanyForLog: 'Ohne zugeordnete Junior Company gibt es hier nichts zu notieren.',
		noCollaborationYet: 'Mit dieser Person besteht noch keine Zusammenarbeit.',
		collaborationHowItWorks:
			'So läuft es ab: Ihr stellt eine Anfrage, die Expert:in nimmt sie an oder lehnt sie ab. Erst nach einer Zusage seht ihr die Kontaktdaten.',
		requestPendingHint: 'Eure Anfrage ist unterwegs. Sobald sie angenommen wird, findet ihr hier die Kontaktdaten.',
		endCollaborationWhen: 'Wann ist das sinnvoll?',
		endCollaborationWhenText:
			'Wenn euer Projekt abgeschlossen ist oder ihr keine Unterstützung mehr braucht. Für eine Pause müsst ihr nichts beenden — meldet euch einfach, wenn es weitergeht.',
		endCollaborationEffect: 'Was passiert dabei?',
		endCollaborationEffect1: 'Die Expert:in bekommt eine E-Mail, dass die Zusammenarbeit beendet wurde.',
		endCollaborationEffect2: 'Ihr seht die Kontaktdaten danach nicht mehr.',
		endCollaborationEffect3: 'Nichts wird gelöscht — die Zusammenarbeit steht danach auf „Beendet“.',
		endCollaborationEffect4: 'Ihr könnt dieselbe Person später jederzeit erneut anfragen.',
		requestForCompany: 'Für welche Junior Company?',
		chooseCompany: 'Bitte wählen',
		connectionStatusREQUESTED: 'Angefragt',
		connectionStatusCONNECTED: 'Verbunden',
		connectionStatusDECLINED: 'Abgelehnt',
		connectionStatusENDED: 'Beendet',
		acceptRequest: 'Annehmen',
		declineRequest: 'Ablehnen',
		noSupportersFound: 'Keine Unterstützer:innen gefunden.',
		noConnectionsYet: 'Es liegen noch keine Anfragen vor.',
		openForNewCompanies: 'Offen für neue Junior Companies',
		deleteProfile: 'Profil löschen',
		deleteProfileHint:
			'Ihre personenbezogenen Daten werden anonymisiert. Dieser Schritt lässt sich nicht rückgängig machen.',
		consentTitle: 'Einwilligung',
		consentGivenAt: 'Erteilt am {{date}}',
		consentGivenAtUnknown: 'Zeitpunkt der Einwilligung nicht hinterlegt',
		profileDeletedTitle: 'Ihr Profil wurde gelöscht',
		profileDeletedText:
			'Sie haben Ihre Einwilligung am {{date}} widerrufen. Ihr Unterstützer:innen-Profil wurde daraufhin gelöscht und Ihre personenbezogenen Daten wurden anonymisiert; für Schulen und Schüler:innen sind Sie nicht mehr sichtbar.',
		profileDeletedAgain:
			'Wenn Sie künftig wieder als Unterstützer:in zur Verfügung stehen möchten, freuen wir uns über eine erneute Registrierung. Bei Fragen erreichen Sie uns unter info@junior.cc.',
		withdrawConsent: 'Einwilligung widerrufen',
		withdrawConsentHint:
			'Mit dem Widerruf entfällt die Grundlage für die Verarbeitung: Ihr Profil wird gelöscht, Ihre personenbezogenen Daten werden anonymisiert und offene Anfragen werden beendet. Die bis zum Widerruf erfolgte Verarbeitung bleibt rechtmäßig. Dieser Schritt lässt sich nicht rückgängig machen.',
		withdrawConsentConfirm:
			'Wollen Sie Ihre Einwilligung wirklich widerrufen? Ihr Profil wird damit gelöscht und Ihre Daten anonymisiert.',
		withdrawConsentDone:
			'Ihre Einwilligung wurde widerrufen. Ihr Profil ist gelöscht, Ihre Daten sind anonymisiert.',
		consentWithdrawnTitle: 'Ihre Einwilligung wurde widerrufen',
		consentWithdrawnText:
			'Ihr Unterstützer:innen-Profil wurde gelöscht, Ihre personenbezogenen Daten wurden anonymisiert und Ihr Zugang wurde beendet. Eine Bestätigung haben wir Ihnen per E-Mail geschickt.',
		cancelInvitation: 'Einladung zurückziehen',
		cancelInvitationHint: 'Die offene Einladung wird entfernt. Die Person kann sich damit nicht mehr registrieren.',
		openRecord: 'Datensatz öffnen',
		allStates: 'Alle Bundesländer',
		homeState: 'Heimat-Bundesland',
		editInvitation: 'Einladung bearbeiten',
		editInvitationHint:
			'Diese Person hat noch kein Profil. Bis zur Aktivierung stehen ihre Stammdaten an der Einladung und lassen sich hier korrigieren.',
		invitationEmailChangedHint:
			'Die E-Mail-Adresse wurde geändert. Beim Speichern geht die Einladung an die neue Adresse erneut hinaus; der bisherige Aktivierungslink verliert seine Gültigkeit.',
		invitationResentToNewAddress: 'Gespeichert. Die Einladung wurde an die neue Adresse verschickt.',
		// Herkunft einer offenen Einladung: Ohne diese Angaben war nicht zu sehen,
		// wer sie ausgesprochen hat und ob sie noch gilt.
		invitationOrigin: 'Herkunft der Einladung',
		invitationSource: 'Eingeladen über',
		invitationSourceADMIN_INVITE: 'Junior Achievement',
		invitationSourceSCHOOL_INVITE: 'Junior Company',
		invitationSourceSELF_REGISTRATION: 'Eigene Registrierung',
		invitedByRoleSTUDENT: 'Schüler:in',
		invitedByRoleTEACHER: 'Lehrkraft',
		invitedByRoleADMINISTRATOR: 'Landesadmin',
		invitedByRoleFEDERAL_ADMINISTRATOR: 'Bundesadmin',
		invitedByRoleSUPPORTER: 'Unterstützer:in',
		notRecorded: 'nicht erfasst',
		invitationResentButEmailFailed: 'Die Einladung wurde erneuert, die E-Mail konnte aber nicht zugestellt werden.',
		systemReminded: 'Das System hat {{count}}× erinnert',
		lastReminder: 'zuletzt am {{date}}',
		autoDeclinedHint: 'Ohne Antwort automatisch abgelehnt',
		systemRemindsHint: 'Das System erinnert die angefragte Person automatisch. Ihr müsst nicht nachfassen.',
		gdprConsent:
			'Ich willige ein, dass Junior Achievement Austria meine Profildaten für die Vermittlung an Junior Companies verarbeitet und sie den Schulen und Schüler:innen der Plattform anzeigt.',
		gdprConsentDetails:
			'Sichtbar werden dabei Name, Unternehmen, Position, Kurzbeschreibung, Fachgebiete und Foto — und zwar nur für angemeldete Schulen und Schüler:innen. Ihre privaten Kontaktdaten (E-Mail, Telefon, Adresse) bleiben verborgen, bis Sie eine Anfrage annehmen. Sie können diese Einwilligung jederzeit in Ihrem Profil widerrufen; die bis zum Widerruf erfolgte Verarbeitung bleibt davon unberührt.',
		activateProfile: 'Profil aktivieren',
		supporterRegistration: 'Als Unterstützer:in registrieren',
		passwordMinLength: 'Das Passwort muss mindestens 8 Zeichen haben.',
		passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein.',
		atLeastOneRole: 'Bitte wählen Sie mindestens eine Rolle.',
		emailAlreadyRegistered: 'Für diese E-Mail-Adresse besteht bereits ein Zugang.',
		alreadyRegistered: 'Sie haben bereits ein Profil?',
		wantToSupport: 'Sie möchten Junior Achievement unterstützen?',
		connectedCompanies: 'Verbundene Junior Companies',
		connectedCompaniesHint: 'Anfragen und laufende Betreuungen dieser Person, neueste zuerst.',
		noConnectedCompanies: 'Es gibt noch keine Anfrage einer Junior Company.',
		companiesAndNeeds: 'Unternehmen & Bedarfe',
		supportRequestResponses: 'Unterstützungsbedarfe',
		supportRequestResponsesHint: 'Zusagen und Absagen dieser Person zu ausgeschriebenen Unterstützungsbedarfen.',
		noSupportRequestResponses: 'Diese Person hat auf keinen ausgeschriebenen Bedarf geantwortet.',
		requestedOn: 'angefragt am',
		respondedOn: 'beantwortet am',
		endedOn: 'beendet am',
		eventDate: 'Termin',
		responseAccepted: 'Zusage',
		responseDeclined: 'Absage',
		logHistory: 'Verlauf',
		newLogEntry: 'Neuer Eintrag',
		supporterLogNoteHint:
			'Die Notiz bleibt in der Verwaltung, solange sie nicht ausdrücklich freigegeben wird. Eine Benachrichtigung geht nicht hinaus.',
		supporterLogNotePlaceholder: 'Was wurde besprochen, worauf ist zu achten?',
		visibleToSupporter: 'Für die Unterstützer:in sichtbar',
		internalOnly: 'Nur intern',
		noLogEntriesYet: 'Noch keine Einträge.',
		noteByAdmin: 'Notiz der Administration',
		noteBySupporter: 'Eintrag der Unterstützer:in',
		noteByMe: 'Mein Eintrag',
		supporterOwnNotesHint:
			'Halten Sie hier fest, was für die Zusammenarbeit wichtig ist. Die Administration sieht Ihre Einträge sofort. Notizen der Administration sehen Sie nur, wenn sie ausdrücklich freigegeben werden.',
		supporterOwnNotePlaceholder: 'Ihre Notiz …',
		supporterLogEventSUPPORTER_REGISTERED: 'Selbst registriert',
		supporterLogEventSUPPORTER_INVITE_ACCEPTED: 'Einladung angenommen, Profil angelegt',
		supporterLogEventSUPPORTER_APPROVED: 'Profil freigegeben',
		supporterLogEventSUPPORTER_STATUS_CHANGED: 'Status geändert',
		supporterLogEventSUPPORTER_ANONYMIZED: 'Profil gelöscht (anonymisiert)',
		supporterLogEventSUPPORTER_CONSENT_WITHDRAWN: 'Einwilligung widerrufen (Profil anonymisiert)',
		supporterLogEventSUPPORTER_ROLES_CHANGED: 'Rollen geändert',
		supporterLogEventSUPPORTER_COMPETENCES_CHANGED: 'Kompetenzen geändert',
		supporterLogEventSUPPORTER_TARGET_GROUPS_CHANGED: 'Zielgruppe geändert',
		supporterLogEventSUPPORTER_PROFILE_UPDATED: 'Profil geändert',
		supporterLogEventCONNECTION_REQUESTED: 'Junior Company hat angefragt',
		supporterLogEventCONNECTION_ACCEPTED: 'Anfrage angenommen',
		supporterLogEventCONNECTION_DECLINED: 'Anfrage abgelehnt',
		supporterLogEventCONNECTION_AUTO_DECLINED: 'Anfrage ohne Antwort automatisch abgelehnt',
		supporterLogEventCONNECTION_ENDED: 'Zusammenarbeit beendet',
		supporterLogEventCONNECTION_ENDED_BY_COMPANY: 'Zusammenarbeit von der Junior Company beendet',
		supporterLogEventSUPPORT_REQUEST_ACCEPTED: 'Zusage zu einem Unterstützungsbedarf',
		supporterLogEventSUPPORT_REQUEST_DECLINED: 'Absage zu einem Unterstützungsbedarf',
		specializations: 'Spezialisierungen',
		uploadPicture: 'Bild hochladen',
		changePicture: 'Bild ändern',
		avatarHint: 'JPG, PNG oder GIF, maximal 5 MB.',
		avatarWrongType: 'Bitte wählen Sie ein Bild im Format JPG, PNG oder GIF.',
		avatarTooLarge: 'Das Bild ist größer als 5 MB.',
		editPicture: 'Bild zuschneiden',
		avatarEditorHint:
			'Ziehen Sie das Bild in den Ausschnitt, ändern Sie die Größe mit dem Regler und drehen Sie es bei Bedarf.',
		// Titelbild einer Veranstaltung oder Neuigkeit — 16:9, weil die Karten
		// auf den Dashboards genau diesen Ausschnitt zeigen.
		'Cover image': 'Titelbild',
		'No cover image': 'Kein Titelbild',
		'Upload cover image': 'Titelbild hochladen',
		'Change cover image': 'Titelbild ändern',
		'Crop cover image': 'Titelbild zuschneiden',
		coverImageHint: 'JPG, PNG oder GIF, maximal 5 MB. Der Ausschnitt ist 16:9 (liegend).',
		coverEditorHint:
			'Ziehen Sie das Bild in den Ausschnitt, ändern Sie die Größe mit dem Regler und drehen Sie es bei Bedarf. Gespeichert wird der Ausschnitt im Format 16:9.',
		'Image set': 'Bild vorhanden',
		'The message was saved, but the cover image was not transferred.':
			'Die Nachricht wurde gespeichert, das Titelbild konnte aber nicht übertragen werden.',
		applyPicture: 'Übernehmen',
		rotateLeft: 'Nach links drehen',
		rotateRight: 'Nach rechts drehen',
		resetImage: 'Zurücksetzen',
		zoom: 'Größe',
		zoomIn: 'Größer',
		zoomOut: 'Kleiner',
		requestMessage: 'Wobei wünscht ihr euch Unterstützung?',
		requestMessagePlaceholder:
			'Wir würden uns über Unterstützung in folgenden Bereichen freuen: … (z. B. Preiskalkulation, Marketing, Vorbereitung auf den Verkaufstag)',
		requestMessageMissing: 'Bitte beschreibt es etwas genauer – noch {{count}} Zeichen.',
		requestMessageHint: 'Die Expert:in sieht euren Text zusammen mit eurer Geschäftsidee.',
		requestCompetencesLabel: 'Bei welchen Kompetenzen wünscht ihr euch Unterstützung? (optional)',
		requestNextStepHint:
			'So geht es weiter: Die Expert:in sieht eure Anfrage und sagt zu oder ab. Bei einer Zusage bekommt ihr eine Mitteilung und eine E-Mail mit den Kontaktdaten – dann seid ihr am Zug und meldet euch.',
		requestNextStepHintDays:
			'So geht es weiter: Die Expert:in sieht eure Anfrage und sagt zu oder ab. Bei einer Zusage bekommt ihr eine Mitteilung und eine E-Mail mit den Kontaktdaten – dann seid ihr am Zug und meldet euch innerhalb von {{days}} Tagen.',
		connectionBusinessIdea: 'Geschäftsidee',
		connectionRequestNeed: 'Dabei wünscht sich die Junior Company Unterstützung',
		connectionRequestCompetences: 'Angesprochene Kompetenzen',
		connectionNextStepTitle: 'Was passiert, wenn Sie zusagen?',
		connectionNextStepText:
			'Die Junior Company sieht dann Ihre Kontaktdaten und meldet sich innerhalb von {{days}} Tagen bei Ihnen – bevorzugt per {{modes}}, wie in Ihrem Profil angegeben. Bis zu Ihrer Zusage bleiben Ihre Kontaktdaten verborgen. Eine Absage ist völlig in Ordnung und hilft der Junior Company, rasch jemand anderen zu finden.',
		connectionNextStepTextNoModes:
			'Die Junior Company sieht dann Ihre Kontaktdaten und meldet sich innerhalb von {{days}} Tagen bei Ihnen. Bis zu Ihrer Zusage bleiben Ihre Kontaktdaten verborgen. Eine Absage ist völlig in Ordnung und hilft der Junior Company, rasch jemand anderen zu finden.',
		connectionContactConfirmed: 'Die Junior Company hat am {{date}} bestätigt, dass ihr in Kontakt seid.',
		listOr: '{{first}} oder {{last}}',
		supporterAcceptedTitle: 'Zusage von {{name}}',
		supporterAcceptedText:
			'Tolle Neuigkeiten: {{name}} unterstützt eure Junior Company „{{company}}“! Jetzt seid ihr am Zug – bitte meldet euch innerhalb von {{days}} Tagen, also bis {{until}}.',
		supporterAcceptedModes: 'Am besten erreicht ihr {{name}} per {{modes}}.',
		supporterAcceptedTip: 'Stellt euch kurz vor, erzählt, woran ihr arbeitet, und schlagt einen ersten Termin vor.',
		supporterAcceptedTeacherTitle: 'Wirtschaftsexpert:in hat zugesagt',
		supporterAcceptedTeacherText:
			'{{name}} hat die Anfrage der Junior Company „{{company}}“ angenommen. Die Schüler:innen sind gebeten, sich innerhalb von {{days}} Tagen – bis {{until}} – bei der Expert:in zu melden. Danach fragt die Junior Datenbank bei ihnen nach, ob der Kontakt zustande gekommen ist.',
		toExperts: 'Zu den Wirtschaftsexpert:innen',
		contactCheckTitle: 'Habt ihr {{name}} schon kontaktiert?',
		contactCheckText: '{{name}} hat am {{date}} zugesagt, eure Junior Company „{{company}}“ zu unterstützen.',
		contactCheckTextPromised: 'Ihr wolltet euch bis {{date}} bei {{name}} melden.',
		contactCheckQuestion: 'Habt ihr euch schon gemeldet?',
		contactCheckYes: 'Ja, wir sind in Kontakt',
		contactCheckNo: 'Noch nicht',
		contactCheckPromise: 'Wir werden {{name}} {{reach}} in den nächsten … Tagen kontaktieren:',
		contactCheckDays: '{{count}} Tage',
		contactCheckDay: '1 Tag',
		contactCheckSubmit: 'Zusagen',
		contactCheckAnsweredYes: 'Danke! {{by}} hat bestätigt, dass ihr mit {{name}} in Kontakt seid.',
		contactCheckAnsweredNo: 'Danke! Ihr meldet euch bis {{date}} bei {{name}} – dann fragen wir noch einmal nach.',
		contactCheckSomeone: 'Jemand aus eurem Team',
		notOpenForNewCompanies: 'Diese Expert:in nimmt derzeit keine neuen Junior Companies an.',
		personalData: 'Persönliche Daten',
		personalDataAndCompany: 'Persönliche Daten & Unternehmen',
		rolesAndCompetences: 'Rollen & Kompetenzen',
		targetAudience: 'Zielgruppe',
		targetAudienceHint:
			'Danach filtern Schulen und Junior Companies bei der Suche. Ohne Auswahl gilt keine Einschränkung — das Profil erscheint dann bei allen Treffern.',
		currentStatus: 'Aktueller Status',
		currentlySet: 'aktuell',
		statusExplained: 'Was die Status bedeuten',
		sectionPerson: 'Person',
		sectionCompany: 'Beruflich',
		profileAndAvailability: 'Kurzprofil & Verfügbarkeit',
		openForNewCompaniesHint:
			'Ist der Haken gesetzt, können Junior Companies neue Anfragen an diese Person stellen.',
		rolesHint: 'Mindestens eine Rolle ist nötig. Sie bestimmt, wofür die Person angefragt wird.',
		supporterRoleHintEXPERT: 'Begleitet Junior Companies fachlich und erscheint in der Suche der Schulen.',
		supporterRoleHintJURY: 'Bewertet Junior Companies bei Wettbewerben und Messen.',
		supporterRoleHintTRAINER: 'Hält Trainings und Workshops für Schüler:innen und Lehrkräfte.',
		furtherCompetencesHint:
			'Frei erfasste Kompetenzen außerhalb des Katalogs. Ein Klick auf den Eintrag entfernt ihn.',
		addCompetence: 'Hinzufügen',
		removeCompetence: 'Entfernen',
		selectedCount: '{{count}} ausgewählt',
		noRestriction: 'Keine Einschränkung',
		clearSelection: 'Auswahl aufheben',
		staleTargetValues: 'Diese Werte stehen nicht in den gepflegten Listen. Ein Klick auf den Eintrag entfernt ihn.',
		removeStaleValue: 'Entfernen',
		unsavedChanges: 'Nicht gespeicherte Änderungen',
		supporterStatusHintINVITED:
			'Die Einladung ist verschickt, die Person hat ihr Profil aber noch nicht angelegt. Für Schulen nicht sichtbar.',
		supporterStatusHintPENDING_APPROVAL:
			'Die Person hat sich selbst registriert und wartet auf die Freigabe durch die Administration. Bis dahin für Schulen nicht sichtbar.',
		supporterStatusHintACTIVE:
			'Das Profil ist freigegeben. Wirtschaftsexpert:innen erscheinen damit in der Suche der Schulen und können von Junior Companies angefragt werden.',
		supporterStatusHintUNAVAILABLE:
			'Vorübergehend nicht verfügbar, etwa wegen Urlaub oder Auslastung. Der Zugang bleibt bestehen, das Profil erscheint aber nicht in der Suche.',
		supporterStatusHintARCHIVED:
			'Von der Administration archiviert: für Schulen unsichtbar, die Daten bleiben aber erhalten und lassen sich jederzeit wieder aktiv setzen.',
		supporterStatusHintDELETED:
			'Die personenbezogenen Daten wurden auf Wunsch anonymisiert (DSGVO). Dieser Schritt lässt sich nicht rückgängig machen.',
		setActive: 'Aktiv setzen',
		setUnavailable: 'Auf nicht verfügbar setzen',
		archiveProfile: 'Profil archivieren',
		registrationPending: 'Vielen Dank! Ihr Profil wird von der Administration geprüft und danach freigeschaltet.',
		companyExperts: 'Unternehmensexperten',
		uploadBP: 'Businessplan hochladen',
		companyEmployees: 'Mitarbeiter:innen',
		companyTeachers: 'Weitere Lehrer:innen',
		news: 'Neuigkeit',
		event: 'Veranstaltung',
		'Notify via email to all users': 'zusätzlich Email an alle Nutzer senden',
		genders: 'Genders',
		'School Types': 'Schultypen',
		'VAT Rates Revenues': 'Steuersätze für Einnahmen',
		'VAT Rates Expenditure': 'Steuersätze für Ausgaben',
		'Work Areas': 'Arbeitsbereiche',
		'Type of Offers': 'Art der Angebote',
		'Shareholder Shares': 'Aktionärsanteile',
		'Max. Share Amounts': 'Max. Aktien Gesamtvolumen',
		'Share Amounts': 'Anteile',
		CEO: 'Geschäftsführung',
		'Not CEO': 'Keine Geschäftsführung',
		'Crop image': 'Bild zuschneiden',
		'Junior Insurance': 'Versicherungsbeitrag',
		'Reports deadline': 'Fristen für Berichtsabgabe',
		'Invoices overdue time': 'Fälligkeit der Rechnungen',
		'Bank Data': 'Bankdaten',
		'No news yet': 'Noch keine Nachrichten',
		'No shares yet': 'Noch keine Aktionäre',
		'No reports yet': 'Noch keine Berichte',
		'Supervision Teacher': 'Betreuungslehrer:in',
		Report: 'Geschäftsbericht',
		Registration: 'Anmeldung',
		Activation: 'Aktivierung',
		'BUSINESS ACTIVITIES': 'GESCHÄFTSTÄTIGKEITEN',
		'Basic Info': 'Basisinformation',
		'Company name': 'Name der Firma',
		Companies: 'Unternehmen',
		'The company name can only be changed by the JAA administration.':
			'Der Firmenname kann nur durch die JAA Administration geändert werden.',
		Note: 'Hinweis',
		'Company type': 'Unternehmensform',
		state: 'Bundesland',
		save: 'Speichern',
		contacts: 'Kontakte',
		// CompanyEmailDescriptionAttention: `Wichtig: Die angegebene E-Mail-Adresse muss vor der Freischaltung durch JAA verifiziert werden.`,
		CompanyEmailDescription: `<highlight>Hinweis:</highlight> Die Firmenkontakt-E-Mail-Adresse muss <highlight>vor der Einreichung zur Genehmigung des Unternehmens</highlight> verifiziert werden. Sie sollte für die Kommunikation mit externen Stakeholdern und Kunden verwendet werden und immer auf der Website sowie in Rechnungen angegeben sein. Für die Einrichtung können kostenlose Anbieter wie <highlight>gmx.at</highlight>, <highlight>gmail.com</highlight> oder <highlight>icloud.com</highlight> verwendet werden.`,
		phone: 'Telefon',
		phoneDesc: `Die Unternehmens-Telefonnummer kann für die Kontaktaufnahme mit externen Partnern verwendet werden und erscheint ggf. auf eurer Website oder in Rechnungen.`,
		School: 'Schule',
		schoolDesc:
			'Die JUNIOR Company wird an Eurem Schulstandort gemeldet. Bitte wählt eine bereits registrierte Schule oder gebt einen neuen Schulstandort an.',
		teacherDesc:
			'Bitte wählt eine/n bereits registrierte/n JUNIOR Lehrer:in aus. Ist Euer/Eure Lehrer:in noch nicht bei uns angemeldet: hier neuen teacher anmelden!',
		'Business Activity': 'Geschäftstätigkeit',
		branch: 'Branche',
		'Company email': 'Firmen-E-Mail',
		description: 'Beschreibung',
		typeOffers: 'Angebotsart',
		descriptionNote:
			'Die JUNIOR Company wird an Eurem Schulstandort gemeldet. Bitte wählt eine bereits registrierte Schule oder gebt einen neuen Schulstandort an.',
		typeOffersNote:
			'Bitte wählt eine/n bereits registrierte/n JUNIOR Lehrer:in aus. Ist Euer/Eure Lehrer:in noch nicht bei uns angemeldet: hier neuen teacher anmelden!',
		descriptionPlaceholder: 'Geben Sie eine kurze Firmenbeschreibung ein',
		'Business Idea': 'Kurzbeschreibung der Geschäftsidee',
		'Your Business Idea': 'Kurzbeschreibung eurer Geschäftsidee',
		// Wofür der Text gebraucht wird — er steht nicht nur im Profil, sondern
		// wird wörtlich weiterverwendet.
		'Business idea purpose': 'Für den Firmenbuchauszug und die Präsentation im JAA-Portal.',
		'We are the...': 'Wir sind die...',
		'Symbols Left': 'Zeichen übrig',
		Characters: 'Zeichen',
		Symbols: 'Symbole',
		'Characters left': 'noch {{left}} von {{max}} Zeichen',
		'Characters over limit': '{{over}} Zeichen über der Grenze von {{max}} — bitte kürzen',
		'Character limit': 'Höchstens {{max}} Zeichen',
		// Ohne diesen Satz merkt niemand, dass beim Einfügen etwas fehlt.
		'Pasted text shortened':
			'Der eingefügte Text war zu lang und wurde um {{cut}} Zeichen gekürzt — mehr als {{max}} Zeichen sind nicht möglich.',
		'Our...': 'Unsere...',
		'Select Branch': 'Branche auswählen',
		'Company Employee': 'Mitarbeiter:innen',
		'Go back': 'Geh zurück',
		'Add Expert': 'Experte hinzufügen',
		'Company Documents': 'Unternehmensdokumente',
		'Document name': 'Dokumentname',
		EMPLOYEE: 'ANGESTELLTER',
		Date: 'Datum',
		'Company Shares': 'Anteilseigner:innen',
		Shareholder: 'Anteilseigner:in',
		'Shareholder details': 'Anteilseigner:in',
		'Shares sold': 'Gezeichnete Anteile',
		'Signed on': 'Gezeichnet am',
		'Consent document hint':
			'Die hochgeladene Erklärung zur Zeichnung des Anteils. Sie liegt auch bei den Dokumenten der Junior Company.',
		'Download consent document': 'Einverständniserklärung herunterladen',
		'Delete shareholder': 'Anteilseigner:in löschen',
		'The shareholder and the uploaded consent document will be deleted.':
			'Die Anteilseigner:in und die hochgeladene Einverständniserklärung werden gelöscht. Der bereits ausgestellte Anteilschein bleibt bei den Dokumenten stehen.',
		'Shareholder has been removed successfully.': 'Die Anteilseigner:in wurde gelöscht.',
		'No shareholders yet': 'Noch keine Anteilseigner:innen',
		'Shareholders admin hint':
			'Wer Anteile dieser Junior Company gezeichnet hat. Angelegt und gelöscht wird das in der Junior Company selbst; ein Klick auf den Eintrag zeigt Kontaktdaten und Einverständniserklärung.',
		'No shareholders yet hint':
			'Sobald die Junior Company Anteile verkauft, stehen die Käufer:innen hier — mit Anteil, Kontaktdaten und Einverständniserklärung.',
		shareholdersDesc:
			'Alle Kapitalgeber:innen müssen mit Vor- und Nachname sowie einer gültigen Adresse registriert werden. Sobald diese Daten vollständig eingegeben sind, erhält der/die Kapitalgeber:in ein persönliches Zertifikat über die Beteiligung an eurer Junior Company per E-Mail. Bitte überpüft daher, dass alle Daten bei der ersten Eingabe gleich korrekt sind, spätere Änderungen sind nur über euren Landesbetreuer möglich.',
		Important: 'Wichtig',
		salutation: 'Anrede',
		'Title Prefixed': 'Titel vor.',
		'First Name': 'Vorname',
		'Last Name': 'Nachname',
		'Title Suffixed': 'Titel nach.',
		gender: 'Geschlecht',
		'Company Share': 'Unternehmensanteile',
		'Select the amount': 'Wähle den Betrag',
		'Warrant Upload': 'Optionsschein Upload',
		'Please upload the warrant!': 'Bitte laden Sie den Optionsschein hoch!',
		'Shareholder Phone': 'Aktionärstelefon',
		Street: 'Straße',
		'House number': 'Hausnummer',
		'Zip Code': 'PLZ',
		City: 'Stadt',
		'Type First Name': 'Geben Sie den Vornamen ein',
		'Type Last Name': 'Geben Sie den Nachnamen ein',
		'Enter Title': 'Geben Sie einen Titel ein',
		'Select Gender': 'Wähle Geschlecht',
		SHAREHOLDER: 'Aktionär',
		'Market and Risk Analysis': 'Markt- und Risikoanalyse',
		'Market Description': 'Marktbeschreibung',
		'To market description': 'Zu Marktbeschreibung',
		'Target group(s)': 'Zielgruppe/n',
		'Product usage': 'Produktnutzen',
		'Add usage...': 'Vorteile hinzufügen',
		'To product benefit': 'Zu Produktnutzen',
		'Describe your target group(s) as precisely as possible with their specific characteristics, such as age group, life situation, interests, whereabouts, etc.':
			'Beschreibt Eure Zielgruppe(n) möglichst genau mit ihren speziellen Eigenschaften wie z.B. Altersgruppe, Lebenssituation, Interessen, Aufenthaltsorte, usw.',
		'What added value does your offer bring to the target group, what needs does it serve? For what benefit does the customer pay the purchase price?':
			'Welchen Mehrwert bringt Euer Angebot der Zielgruppe, welche Bedürfnisse werden damit bedient? Für welchen Nutzen zahlt der Kunde den Kaufpreis?',
		'Customer contact, sales strategy': 'Kundenkontakt, Verkaufsstrategie',
		'Where is/are your target group(s) to be found? How do you promote your offer to the respective target group? Which communication channels do you use?':
			'Wo ist/sind Eure Zielgruppe(n) anzutreffen? Wie bewerbt Ihr Euer Angebot passend zur jeweiligen Zielgruppe? Welche Kommunikationskanäle nutzt ihr?',
		'Add contact & Strategy': 'Kontakt & Strategie hinzufügen',
		'Sales forecast': 'Umsatzprognose',
		'Enter your expected sales figures for your up to 5 most important offers and their respective prices. This will give you a forecast of your sales for the entire project year.':
			'Tragt hier Eure erwarteten Verkaufszahlen für Eure bis zu 5 wichtigsten Angebote und deren jeweiligen Preis ein. Damit erhaltet Ihr eine Prognose Eures Umsatzes für das gesamte Projektjahr.',
		'Product / Service': 'Produkt / Dienstleistung',
		'Product name': 'Produktname',
		'Price (€) / unit': 'Preis (€) / Einheit',
		'Expected sales (number)': 'Erwartete Verkäufe (Anzahl)',
		'Expected turnover (€)': 'Erwarteter Umsatz (€)',
		'Add new forecast': 'Neue Prognose hinzufügen',
		'The total amount of estimated annual sales is €.': 'Die Gesamtsumme des geschätzten Jahresumsatzes beträgt €.',
		'Risk and strategy': 'Risiken & Strategie',
		'Enter here possible risks affecting your company and describe a strategy for dealing with the risk in each case. Risks can arise, for example, in connection with your production, with the target group, with suppliers or with the competition.':
			'Tragt hier mögliche Risiken ein, die Euer Unternehmen betreffen, und beschreibt jeweils eine Strategie für den Umgang mit dem Risiko. Risiken können z.B. im Zusammenhang mit Eurer Produktion, mit der Zielgruppe, mit Lieferant:innen oder der Konkurrenz entstehen.',
		Risk: 'Risiko',
		'Avoidance strategy': 'Vermeidungsstrategie',
		'Add avoidance strategy': 'Vermeidungsstrategie hinzufügen',
		'Add new Risk': 'Neues Risiko hinzufügen',
		'Date of Birth': 'Geburtsdatum',
		age: 'Alter',
		birthdayAgeHint:
			'Das Alter wird benötigt, um die elterliche Einverständniserklärung zu beurteilen, für anonymes Reporting und für die Ausstellung der Urkunde.',
		studentCount: 'Anzahl Schüler:innen',
		'Letter has been sent to confirm email changes.':
			'Nachricht wurde versendet, um die E-Mail Änderung zu bestätigen.',
		'Your email': 'E-Mail',
		'Change email': 'Ändern Sie die E-Mail',
		'Profile has been updated successfully.': 'Profil wurde erfolgreich aktualisiert.',
		'Avatar photo': 'Avatarfoto',
		'Upload profile photo': 'Profilfoto hochladen',
		'Parental Confirmation': 'Elternbestätigung',
		'Course Certificate': 'Kursnachweis',
		'Course certificate': 'Kursnachweis',
		active: 'aktiv',
		'Requirement name': 'Bezeichnung der Voraussetzung',
		'Requirement name (German)': 'Bezeichnung der Voraussetzung (Deutsch)',
		'Requirement name (English)': 'Bezeichnung der Voraussetzung (Englisch)',
		'Course link': 'Kurs-Link',
		Requests: 'Anfragen',
		'Company types': 'Company-Typen',
		'Minimum of 2 students as employees': 'Mindestens 2 Schüler:innen als Mitarbeiter:innen',
		'Minimum of 1 business expert assigned': 'Mindestens 1 Wirtschaftsexpert:in zugewiesen',
		'Course certificate updated': 'Kursnachweis aktualisiert',
		'To the course': 'Zum Kurs',
		'Need to upload course certificate': 'Bitte Kursnachweis hochladen',
		'Course certificate was rejected, upload new please !':
			'Kursnachweis wurde abgelehnt, bitte einen neuen hochladen!',
		'The course certificate must be uploaded': 'Der Kursnachweis muss hochgeladen werden',
		'This requirement was added after your company was activated and is therefore not required of you.':
			'Diese Voraussetzung ist erst nach eurer Freischaltung dazugekommen und wird von euch deshalb nicht verlangt.',

		// Einstellungen: Dokumentvorlagen
		'All PDF documents the application generates: certificates, invoices, confirmations. Each template can be viewed with real data — up to ten records to leaf through. The templates themselves are part of the application and cannot be edited here.':
			'Alle PDF-Dokumente, die die Anwendung erzeugt: Urkunden, Rechnungen, Bestätigungen. Jede Vorlage lässt sich mit echten Daten ansehen — bis zu zehn Datensätze zum Durchblättern. Die Vorlagen selbst stecken in der Anwendung und sind hier nicht änderbar.',
		'Example: the participation certificate — pick a real company, look at the PDF, download it if needed.':
			'Beispiel: die Teilnahmeurkunde — eine echte Company auswählen, das PDF ansehen, bei Bedarf herunterladen.',

		// Einstellungen: Reiter
		'Checklist & requirements': 'Checkliste & Voraussetzungen',
		Taxes: 'Steuern',
		'Bank details': 'Bankverbindung',

		// Voraussetzungen: Texte der Checkliste (Schüler:innen-Sicht)
		'Your company profile and your risk analysis must be filled in completely':
			'Euer Unternehmensprofil und eure Risikoanalyse müssen vollständig ausgefüllt sein',
		'Your company needs at least two registered students as employees':
			'Euer Unternehmen braucht mindestens zwei registrierte Schüler:innen als Mitarbeiter:innen',
		'Your company needs at least one business expert':
			'Euer Unternehmen benötigt zumindest eine:n Wirtschaftsexpert:in',
		'All parental consent forms must be available signed and checked by the administration':
			'Alle Einverständniserklärungen der Eltern müssen unterschrieben vorliegen und von der Administration geprüft sein',
		'All employees confirmed, pending invitations deleted':
			'Alle Mitarbeiter:innen bestätigt, ausstehende Einladungen gelöscht',
		'Every employee must have been assigned a function':
			'Jede(r) Mitarbeiter:in muss eine Funktion zugewiesen bekommen haben',
		'The official email address of your company must be verified':
			'Die offizielle E-Mail-Adresse eures Unternehmens muss verifiziert werden',
		'To the risk analysis': 'Zur Risikoanalyse',
		'To the employees': 'Zu den Mitarbeiter:innen',
		'To the business experts': 'Zu den Wirtschaftsexpert:innen',
		'To your profile': 'Zu deinem Profil',
		'To the company profile': 'Zum Unternehmensprofil',

		// Voraussetzungen: Konfiguration
		'Configure requirements': 'Voraussetzungen konfigurieren',
		'Every item of the checklist above with its setting. Switched off, it disappears from the students’ checklist and is no longer required for submission.':
			'Jeder Punkt der Checkliste oben mit seiner Einstellung. Abgeschaltet verschwindet er aus der Checkliste der Schüler:innen und wird für das Einreichen nicht mehr verlangt.',
		'Example: if no experts are needed in a given year, switch off that item — it then disappears from the checklist.':
			'Beispiel: Braucht es in einem Jahr keine Expert:innen, diesen Punkt abschalten — er fällt dann aus der Checkliste.',
		'A switched-off requirement is no longer checked before submission. It disappears from the checklist above at once — including for companies that are currently filling it in.':
			'Eine abgeschaltete Voraussetzung wird vor dem Einreichen nicht mehr geprüft. Sie verschwindet sofort aus der Checkliste oben — auch bei Companies, die gerade dabei sind, sie zu erfüllen.',
		'Switched off and therefore not shown to students':
			'Abgeschaltet und daher nicht sichtbar für die Schüler:innen',
		'These conditions must be met before a Junior Company can be submitted for review and activated. Which of them apply is set in the card below.':
			'Diese Bedingungen muss eine Junior Company erfüllen, bevor sie zur Prüfung eingereicht und aktiviert werden kann. Welche davon gelten, wird in der Karte darunter eingestellt.',
		'Additional requirement': 'Zusatzbedingung',
		activated: 'aktiviert',
		deactivated: 'deaktiviert',

		// Einstellungen: Verweis auf die ausgelöste Vorlage
		'Related template': 'Zugehörige Vorlage',
		'Related templates': 'Zugehörige Vorlagen',
		'switched off': 'abgeschaltet',

		// Einstellungen: Untermenü
		'Settings sections': 'Abschnitte der Einstellungen',

		// Einstellungen: Checkliste & Voraussetzungen
		'Checklist as students see it': 'Checkliste, wie die Schüler:innen sie sehen',
		'A student sees this list when clicking "Submit for review". Submitting is only possible once every item is met.':
			'Eine Schüler:in bekommt diese Liste zu sehen, wenn sie ihre Company zur Prüfung einreicht. Einreichen ist erst möglich, wenn jeder Punkt erfüllt ist.',
		'Applies to': 'Gilt für',
		'Example: the LinkedIn certificate for the Gen AI course. Switched on, it becomes an extra item in the checklist above; switched off, students never see it.':
			'Beispiel: die LinkedIn-Urkunde für den Gen-AI-Kurs. Eingeschaltet wird daraus ein zusätzlicher Punkt in der Checkliste oben; ausgeschaltet bekommen die Schüler:innen ihn nicht zu sehen.',
		'Without a company type ticked the condition has no effect — it then applies to no company at all.':
			'Ohne angehakte Unternehmensform bleibt die Bedingung wirkungslos — sie gilt dann für keine einzige Company.',
		'The condition only applies to the company types ticked here.':
			'Die Bedingung gilt nur für die hier angehakten Unternehmensformen.',

		// Einstellungen: Unternehmenspräsentation
		'From which stage of processing a Junior Company appears on the public overview page. The stages build on one another: everything from the selected stage onwards is shown.':
			'Ab welchem Bearbeitungsstand eine Junior Company auf der öffentlichen Übersichtsseite erscheint. Die Stände bauen aufeinander auf: Gezeigt wird alles ab dem gewählten Stand.',
		'Example: "From submission for review onwards" shows companies awaiting a decision as well as activated ones — but not those still being edited.':
			'Beispiel: „Ab Einreichung zur Prüfung" zeigt die Companies, die auf eine Entscheidung warten, und zusätzlich die bereits aktivierten — nicht aber die, die noch in Bearbeitung sind.',
		'Affects the public overview page only. Inside the application every role keeps seeing the companies it is entitled to see.':
			'Betrifft nur die öffentliche Übersichtsseite. Innerhalb der Anwendung sieht jede Rolle weiterhin die Companies, die ihr zustehen.',
		'Publish companies from this stage onwards': 'Veröffentlichen ab diesem Bearbeitungsstand',
		'Only after activation': 'Erst ab Aktivierung',
		'From submission for review onwards': 'Ab Einreichung zur Prüfung',
		'From registration onwards': 'Ab Registrierung',
		'Only the company types ticked here appear on the public overview page.':
			'Nur die hier angehakten Unternehmensformen erscheinen auf der öffentlichen Übersichtsseite.',
		'Please select at least one company type': 'Bitte mindestens eine Unternehmensform wählen',
		'Please select': 'Bitte wählen',

		// Einstellungen: Fälligkeit der Rechnungen
		'Number of days after the invoice date from which an invoice counts as overdue. It controls the status shown in the dashboard and in the invoice list, and it starts the payment reminders.':
			'Anzahl Tage nach Rechnungsdatum, ab der eine Rechnung als überfällig gilt. Steuert die Statusanzeige im Dashboard und in der Rechnungsliste und setzt die Zahlungserinnerungen in Gang.',
		'Example: 30 — an invoice issued on 1 March counts as overdue from 31 March.':
			'Beispiel: 30 — eine am 1. März gestellte Rechnung gilt ab 31. März als überfällig.',
		'Takes effect immediately for all existing invoices: lowering the number can mark many invoices as overdue at once.':
			'Wirkt sofort auf alle bestehenden Rechnungen: Eine Verkleinerung kann schlagartig viele Rechnungen als überfällig markieren.',
		'What happens once the deadline has passed': 'Was nach Ablauf der Frist passiert',
		'The invoice is listed as "Overdue" in the dashboard, in the invoice list and in the company overview.':
			'Die Rechnung wird im Dashboard, in der Rechnungsliste und in der Company-Übersicht als „Überfällig" geführt.',
		'First payment reminder {{days}} days after the invoice date — but never before the invoice is actually overdue.':
			'Erste Zahlungserinnerung {{days}} Tage nach Rechnungsdatum — frühestens jedoch, wenn die Rechnung tatsächlich überfällig ist.',
		'First payment reminder as configured under "Invoicing Reminders" — but never before the invoice is actually overdue.':
			'Erste Zahlungserinnerung wie unter „Erinnerungen zu Rechnungen" eingestellt — frühestens jedoch, wenn die Rechnung tatsächlich überfällig ist.',
		'Repeated every {{days}} days for as long as the invoice remains unpaid.':
			'Wiederholung alle {{days}} Tage, solange die Rechnung offen bleibt.',
		'Repeated at the interval configured under "Invoicing Reminders".':
			'Wiederholung in dem Takt, der unter „Erinnerungen zu Rechnungen" eingestellt ist.',
		'Every student of the company receives the reminder by email; the company and its supervising teacher additionally get a message inside the application.':
			'Jede Schüler:in der Company bekommt die Erinnerung per E-Mail; die Company und die betreuende Lehrkraft zusätzlich als Nachricht in der Anwendung.',
		'Invoices are checked once a night at 3:00 a.m. A reminder therefore goes out in the night after the deadline has passed at the earliest, and each invoice is only reminded once per run.':
			'Geprüft wird einmal pro Nacht um 3:00 Uhr. Eine Erinnerung geht also frühestens in der Nacht nach Fristablauf hinaus, und je Lauf wird eine Rechnung nur einmal erinnert.',

		'click for open file': 'zum Öffnen der Datei anklicken',
		ParentalDesc:
			'Die Unternehmens-E-Mail-Adresse kann für den Kontakt mit externen Stakeholdern verwendet und z.B. auf der Unternehmenswebsite, Rechnungen, etc. veröffentlicht werden. Wenn euer Unternehmen noch keine E-Mail-Adresse hat, können ihr diese bei Anbietern wie gmx.at, gmail.com oder icloud.com kostenlos einrichten.',
		'Residential address': 'Wohnadresse',
		'Your contact data will only be used for our communication with you and will not be passed on to third parties!':
			'Ihre Kontaktdaten werden nur für unsere Kommunikation mit Ihnen verwendet und nicht an Dritte weitergegeben!',
		'Main function': 'Hauptfunktion',
		'Your main work area': 'Ihr Hauptarbeitsgebiet',
		'Work area': 'Zusätzlicher Arbeitsbereich',
		'Your work area': 'Ihr Arbeitsbereich',
		'2nd work area': '2. Arbeitsbereich',
		'3rd work area': '3. Arbeitsbereich',
		'Passsword has been changed successfuly.': 'Passwort wurde erfolgreich geändert.',
		'Change PW section': 'PW-Abschnitt ändern',
		'New password': 'Neues Kennwort',
		'Old password': 'Altes Passwort',
		'Repeat new password': 'Wiederhole das neue Passwort',
		'Change Password': 'Passwort ändern',
		'My Profile': 'Mein Profil',
		'The expert was': 'Der Experte war',
		updated: 'Aktualisiert',
		created: 'erstellt',
		successfully: 'erfolgreich',
		'Update economic expert': 'Wirtschaftsexperte aktualisieren',
		'Add economic expert': 'Wirtschaftsexperte hinzufügen',
		Company: 'Unternehmen',
		'Function, position': 'Funktion, Position',
		update: 'Aktualisieren',
		Cancel: 'Abbrechen',
		'Add Employee': 'Mitarbeiter:in hinzufügen',
		'Invitation was sent successfully': 'Einladung wurde erfolgreich gesendet',
		'CEO Updated': 'Geschäftsführer aktualisiert',
		You: 'Du',
		Employee: 'Mitarbeiter:in',
		Director: 'Direktor',
		'Assign managing director (CEO)': 'Geschäftsführung (CEO) zuweisen',
		'Invite new employee by Email': 'Neue Mitarbeiter:in per E-Mail einladen',
		'Employee Email': 'Mitarbeiter-E-Mail',
		'Teacher added successfully': 'Lehrer erfolgreich hinzugefügt',
		'Invite deleted successfully': 'Einladung erfolgreich gelöscht',
		'Teacher deleted from your company successfully': 'Lehrer erfolgreich aus Ihrem Unternehmen gelöscht',
		'Invite Teacher': 'Lehrer einladen',
		Student: 'Schüler:in',
		Teacher: 'Lehrer:in',
		Pending: 'Ausstehend',
		Invited: 'Eingeladen',
		'The employee was deleted successfully': 'Die Mitarbeiter:in wurde erfolgreich gelöscht.',
		'Employee successfully deleted': 'Mitarbeiter:in erfolgreich gelöscht',
		Remove: 'Entfernen',
		'Select teacher': 'Lehrer auswählen',
		Verified: 'Verifiziert',
		Send: 'Senden',
		'Teacher Email': 'Lehrer-E-Mail',
		'Or invite new teacher by Email': 'Oder laden Sie einen neuen Lehrer per E-Mail ein',
		'You can create first report after Company activation':
			'Sie können den ersten Bericht nach der Aktivierung des Unternehmens erstellen',
		'Risk Analysis Form': 'Formular zur Risikoanalyse',
		'Go To Reports': 'Gehe zu Berichten',
		'Go To Shares': 'Gehe zu Aktien',
		'Go To News': 'Gehe zu Nachrichten',
		// Ueberschrift des Blocks auf dem Dashboard der Lehrkraft
		'Events and news': 'Veranstaltungen & Neuigkeiten',
		'Sign In': 'Zur Anmeldung',
		'Do not have account yet?': 'Sie haben noch kein Konto?',
		SignUp: {
			noun: 'Registrierung',
			verb: 'Registrieren'
		},
		Password: 'Passwort',
		'Your password': 'Passwort',
		'Forgot password?': 'Passwort vergessen?',
		'Recover Pass': 'Passwort wiederherstellen',
		'A letter with a link to reset the password is sent to the e-mail':
			'Ein Brief mit einem Link zum Zurücksetzen des Passworts wird an die E-Mail gesendet',
		'Back to': 'Zurück zu',
		page: 'Seite',
		Recover: 'Wiederherstellen',
		'Password changed successfully !': 'Das Passwort wurde erfolgreich geändert !',
		'Successfully updated': 'Erfolgreich aktualisiert',
		'Password Recovery': 'Passwort-Wiederherstellung',
		'Set password for your new account': 'Passwort für Ihr neues Konto festlegen',
		'Create a new password': 'Erstelle ein neues Passwort',
		'Expert Activation': 'Expertenaktivierung',
		'Account confirmation is in progress. Loading...': 'Die Kontobestätigung ist in Bearbeitung. Wird geladen...',
		'account successfully activated': 'Konto erfolgreich aktiviert',
		'Token is not founded': 'Token ist nicht gegründet',
		'Account confirmation': 'Account Bestätigung',
		Dashboard: 'Armaturenbrett',
		'Go to': 'Gehe zu',
		'Registration was successful. Please sign in': 'Die Registrierung war erfolgreich. Bitte einloggen',
		'Registration was successful. Please confirm email':
			'Die Registrierung war erfolgreich. Bitte E-Mail bestätigen',
		'Registration was successful.': 'Die Registrierung war erfolgreich.',
		'as student account': 'als Schüler:innenkonto',
		'Have account?': 'Sie haben bereits ein Konto?',
		Role: 'Rolle',
		'Repeat password': 'Passwort wiederholen',
		'I agree that the above data will be collected and stored by Junior Achievement Austria for the duration of this school year for the purpose of fulfilling and processing the Junior Project. These data will not be passed on to third parties by Junior Achievement Austria and will be removed from the database after the end of the school year.':
			'Ich bin damit einverstanden, dass die oben angeführten Daten zur Erfüllung und Abwicklung des Junior Projektes für die Dauer dieses Schuljahres von Junior Achievement Austria erfasst und gespeichert werden. Diese werden von Junior Achievement Austria nicht an Dritte weitergegeben und nach dem Ablauf des Schuljahres aus der Datenbank entfernt.',
		'Step 2': 'Schritt 2',
		'Provide your personal details': 'Geben Sie Ihre persönlichen Daten an',
		'Select salutation': 'Anrede auswählen',
		'Select gender': 'Wähle Geschlecht',
		Back: 'Zurück',
		Continue: 'Weitermachen',
		Submit: 'Einreichen',
		'Create Company': 'Unternehmen Erstellen',
		'Choose company Type': 'Wählen Sie den Unternehmenstyp',
		'Classical Junior Company for 15-19 year old students. Duration 1 school year (2 semesters)':
			'Klassische Junior Company für 15-19 jährige Schüler:innen. Dauer: 1 Schuljahr (2 Semester)',
		'Simplified Junior Company for 7th-9th grade. Duration 1 semester. Simplified Accounting.':
			'Vereinfachte Junior Company für die 7.-9. Schulstufe. Dauer: 1 Semester. Vereinfachte Buchführung.',
		'Shortened Junior Company for 9th-13th grade students. Can be done in 1 semester.':
			'Verkürzte Junior Company für die 9.-13. Schulstufe. Kann in 1 Semester durchgeführt werden.',
		Create: 'Erstellen',
		'Provide us company data': 'Stellen Sie uns Firmendaten zur Verfügung',
		'Company state': 'Bundesland',
		'Type Short Company Description': 'Kurze Firmenbeschreibung eingeben',
		'Hello, welcome back': 'Hallo, willkommen zurück',
		'Edit My Profile': 'mein Profil bearbeiten',
		'Supervision MaleTeacher in': 'Lehrer an der Schule',
		'Supervision FemaleTeacher in': 'Lehrerin an der Schule',
		'Supervised Companies': 'Betreute Unternehmen',
		'Participating Students': 'Teilnehmende Schüler:innen',
		'Full list': 'Volle Liste',
		'All School Companies': 'Alle Unternehmen in dieser Schule',
		'Go To Companies': 'Gehe zu Unternehmen',
		'No companies yet': 'Noch keine Unternehmen',
		'All Students In School': 'Alle Schüler:innen in dieser Schule',
		'No students yet': 'Noch keine Schüler:innen',
		'ASSIGNED COMPANIES': 'Mir zugeordnete Unternehmen',
		'Search companies...': 'Firmen suchen ...',
		'Search messages...': 'Nachrichten suchen ...',
		'Search templates...': 'Vorlagen suchen ...',
		'Assigned Students': 'Mir zugeordnete Schüler:innen',
		'Search for a student': 'Schüler:innen Suche',
		'Registration Date': 'Registrierungsdatum',
		Certificate: 'Zertifikat',
		Insurance: 'Versicherungsbeitrag',
		'Business Plan': 'Businessplan (optional)',
		'Search for documents...': 'Dokumente suchen',
		Type: 'Typ',
		COMPANY: 'Unternehmen',
		'Contacts updated': 'Kontakte aktualisiert',
		'Change contacts': 'Kontakte ändern',
		Select: 'Auswahl',
		'Change School': 'Schule wechseln',
		'General Info': 'Allgemeine Information',
		Customise: 'Anpassen',
		'Quick Lists': 'Schnelllisten',
		'Last Companies': 'Letzte Unternehmen',
		'Last Students': 'Letzte Schüler:innen',
		'Last Teachers': 'Letzte Lehrkräfte',
		'Available widgets': 'Verfügbare Widgets',
		'Max number of widgets is 8': 'Maximale Anzahl von Widgets ist 8',
		'Widgets updated': 'Widgets aktualisiert',
		Members: 'Mitglieder',
		member: 'Mitglied',
		SCHOOL: 'Schule',
		'Company Name': 'Name der Firma',
		Balance: 'Saldo',
		Registered: 'Registriert',
		'Download list as': 'Liste herunterladen als:',
		'Download selection as': 'Auswahl herunterladen als:',
		'Files (ZIP)': 'Dateien (ZIP)',
		documentsZipTooMany:
			'Die Auswahl umfasst {{count}} Dokumente – als ZIP gehen höchstens {{max}}. Bitte über „Art des Dokuments“ oder „Unternehmen“ eingrenzen.',
		documentsExportFailed: 'Die Datei konnte nicht erstellt werden. Bitte erneut versuchen.',
		'Create School': 'Schule anlegen',
		'Update School': 'Schule aktualisieren',
		'Find a school': 'Eine Schule finden',
		Result: 'Ergebnis',
		from: 'von',
		'Find a user': 'Einen Benutzer finden',
		Amount: 'Betragen',
		'Days Left': 'Tage Übrig',
		'Search a invoice': 'eine Rechnung suchen',
		// Rechnungsübersicht: Kacheln Gesamt / Bezahlt / Offen
		'Invoices, total': 'Gesamt',
		'Invoices, paid': 'Bezahlt',
		'Invoices, open': 'Offen',
		invoicesCountOf: '{{n}} von {{total}} Rechnungen',
		invoicesOverdueNote: 'davon {{n}} überfällig',
		invoicesCreditNote: 'davon {{n}} Gutschriften über {{amount}}',
		invoicesCreditNoteOne: 'davon 1 Gutschrift über {{amount}}',
		invoicesCardHint: 'Klicken, um danach zu filtern — nochmal klicken hebt den Filter auf',
		// Storno (Anforderung #91): eigene Kachel, nicht im Gesamtbetrag
		'Invoices, cancelled': 'Storniert',
		invoicesCancelledCount: '{{n}} stornierte Rechnungen',
		invoicesCancelledCountOne: '1 stornierte Rechnung',
		invoicesCancelledNote: 'nicht in den Summen enthalten',
		// Guthaben aus einem Storno: Was bezahlt war und noch auf keiner neuen
		// Rechnung angerechnet ist (Anforderung #91).
		invoicesOpenCreditNote: 'nicht in den Summen enthalten · {{amount}} Guthaben aus {{n}} bezahlten',
		invoicesOpenCreditNoteOne: 'nicht in den Summen enthalten · {{amount}} Guthaben aus 1 bezahlten',
		'Credit from cancellation': 'Guthaben aus Storno',
		invoiceCreditOpenHint:
			'Diese Rechnung war bezahlt. Der Betrag bleibt als Guthaben stehen und wird auf die nächste Rechnung zu diesem Bericht angerechnet.',
		invoiceCreditAppliedHint: 'Guthaben aus einer stornierten Rechnung wurde auf diese Rechnung angerechnet.',
		'Invoice credit applied': 'Guthaben angerechnet',
		'Invoice credit transferred': 'Guthaben übernommen',
		'Invoice credit open': 'Guthaben offen',
		'Total Invoice Amount': 'Totaler Rechnungsbetrag',
		'Paid Invoices, %': 'Bezahlte Rechnungen, %',
		'Paid Invoices': 'Bezahlte Rechnungen',
		'Overdue Invoices': 'Überfällige Rechnungen',
		'TEMPLATE NAME': 'VORLAGENAME',
		'MODIFIED DATE': 'GEÄNDERT DATUM',
		'Email Templates': 'E-Mail-Vorlagen',
		Templates: 'Vorlagen',
		'Create Template': 'Vorlage erstellen',
		'New email template': 'Neue E-Mail-Vorlage',
		'Template name': 'Vorlagenname',
		'Email body': 'Nachrichtentext',
		'Events & News': 'Veranstaltungen & Neuigkeiten',
		// Veranstaltungen & Neuigkeiten: Kartenliste und Dialoge
		Message: 'Nachricht',
		'News entries': 'Beiträge',
		'Message type': 'Nachrichtenart',
		'Edit message': 'Nachricht bearbeiten',
		Duplicate: 'Duplizieren',
		'Duplicate message': 'Nachricht duplizieren',
		'The copy starts with today and one month ahead — the period of the original is not carried over.':
			'Die Kopie beginnt mit heute und einem Monat im Voraus — der Zeitraum der Vorlage wird nicht übernommen.',
		'The event date of the original is in the past and was not carried over — please enter the new date.':
			'Der Termin der Vorlage liegt in der Vergangenheit und wurde nicht übernommen — bitte den neuen Termin eintragen.',
		'Sort by': 'Sortieren nach',
		'Newest first': 'Neueste zuerst',
		'Oldest first': 'Älteste zuerst',
		'Start date (newest)': 'Startdatum (neueste)',
		'Start date (oldest)': 'Startdatum (älteste)',
		'Title A–Z': 'Titel A–Z',
		'No messages found.': 'Keine Nachrichten gefunden.',
		'No message belongs to the selected company.': 'Zur gewählten Junior Company gibt es keine Mitteilung.',
		'Show all': 'Alle ansehen',
		'Delete message?': 'Nachricht löschen?',
		'The message will no longer be shown to anyone. This cannot be undone.':
			'Die Nachricht wird niemandem mehr angezeigt. Das lässt sich nicht rückgängig machen.',
		'Visible to all users': 'Für alle Nutzer:innen sichtbar',
		// Zielgruppe in der Klammer hinter dem Titel (Zeitachse)
		'for everyone': 'für alle',
		'only for': 'nur für',
		'Check and send': 'Prüfen & Senden',
		Chronological: 'Chronologisch',
		'All messages': 'Alle Nachrichten',
		'Period shown': 'Zeitraum',
		// Zeitachse: Balken = Anzeigedauer, Raute = Termin (Anforderung zur Gantt-Ansicht)
		timelineBarHint:
			'Die Länge eines Balkens zeigt, wie lange die Nachricht den Benutzer:innen auf ihrem Dashboard angezeigt wird. Die Raute markiert den Termin der Veranstaltung. Liegt er außerhalb des gezeigten Zeitraums, steht am Rand ein Pfeil in seine Richtung.',
		'outside the period shown': 'außerhalb des gezeigten Zeitraums',
		months: 'Monate',
		today: 'heute',
		'No messages in this period.': 'In diesem Zeitraum liegt keine Nachricht.',
		of: 'von',
		selected: 'ausgewählt',
		'No entries': 'Keine Einträge',
		Filter: 'Filter',
		'Reset filters': 'Filter zurücksetzen',
		Reset: 'Zurücksetzen',
		Close: 'Schließen',
		Loading: 'Wird geladen',
		Reach: 'Reichweite',
		'people receive this message': 'Personen erhalten diese Nachricht',
		'Date and time': 'Datum & Zeit',
		Address: 'Adresse',
		History: 'Verlauf',
		'The period decides when the message is visible. The status follows from it.':
			'Der Zeitraum bestimmt, wann die Mitteilung sichtbar ist. Daraus ergibt sich auch der Status.',
		'Display period': 'Anzeigezeitraum',
		'Decides when the message appears for students and teachers. The status follows from it.':
			'Bestimmt, wann die Nachricht bei Schüler:innen und Lehrkräften erscheint. Daraus ergibt sich auch der Status.',
		'Shown from': 'Anzeige ab',
		'Shown until': 'Anzeige bis',
		Shown: 'Angezeigt',
		'Event date': 'Veranstaltungstermin',
		'When it actually takes place — independent of how long it is announced.':
			'Wann sie tatsächlich stattfindet — unabhängig davon, wie lange sie angekündigt wird.',
		'Event start': 'Beginn',
		'Event end': 'Ende',
		optional: 'freiwillig',
		'The display period ends before the event takes place.':
			'Der Anzeigezeitraum endet, bevor die Veranstaltung stattfindet.',
		'The event takes place before the message is shown.':
			'Die Veranstaltung findet statt, bevor die Nachricht angezeigt wird.',
		'Prefilled with today and one month ahead — adjust as needed.':
			'Vorbelegt mit heute und einem Monat im Voraus — bei Bedarf anpassen.',
		'Where does it take place? A street address, a link, or both — nothing is required.':
			'Wo findet es statt? Eine Anschrift, ein Link oder beides — nichts davon ist Pflicht.',
		'Street and number': 'Straße und Hausnummer',
		'Postal code': 'PLZ',
		Country: 'Land',
		'City or town': 'Ort',
		'Location (previous entry)': 'Ortsangabe (bisher)',
		'Also for Teams, Zoom or a registration page.': 'Auch für Teams, Zoom oder eine Anmeldeseite.',
		'The log starts with its introduction — what happened before is not recorded.':
			'Der Verlauf beginnt mit seiner Einführung — was davor geschah, ist nicht festgehalten.',
		'The history cannot be loaded right now.': 'Der Verlauf lässt sich gerade nicht laden.',
		'No changes recorded yet.': 'Noch keine Änderungen festgehalten.',
		Created: 'Angelegt',
		Unknown: 'Unbekannt',
		changed: 'geändert',
		empty: 'leer',
		'Reach cannot be determined right now': 'Reichweite lässt sich gerade nicht ermitteln',
		'No restriction — all users': 'Keine Einschränkung — alle Nutzer:innen',
		'How this message is delivered':
			'Nach dem Speichern erscheint die Nachricht für die gewählten Zielgruppen unter „Veranstaltungen & Neuigkeiten“ und als Benachrichtigung in der Junior Datenbank. Ein E-Mail-Versand findet nicht statt.',
		'Next step': 'Weiter',
		'An empty field places no restriction.': 'Ein leeres Feld bedeutet: keine Einschränkung.',
		'This message reaches': 'Diese Nachricht erreicht',
		'all users': 'alle Nutzer:innen',
		'Not set': 'nicht gesetzt',
		Period: 'Zeitraum',
		'The message was created': 'Die Nachricht wurde erstellt',
		'The message was updated': 'Die Nachricht wurde aktualisiert',
		'Create message': 'Nachricht erstellen',
		Edit: 'Bearbeiten',
		'Target groups': 'Zielgruppen',
		Place: 'Adresse',
		All: 'Alle',
		'Start date': 'Startdatum',
		'End date': 'Endtermin',
		'External Link': 'externer Link',
		'Add event': 'Ereignis hinzufügen',
		Title: 'Titel',
		'Select state or states': 'auswählen Bundesland',
		'User roles': 'Benutzertypen',
		'Select role or roles': 'Rolle oder Rollen auswählen',
		'Select type or types': 'Typ oder Typen auswählen',
		'Organization name': 'Organisationsname',
		'Administrator email': 'Administrator-E-Mail',
		'Add Administrator': 'Administrator hinzufügen',
		Administrators: 'Administratoren',
		'Admin was successfully': 'Admin wurde erfolgreich',
		'Invitation Pending': 'Einladung ausstehend',
		'The expert was deleted successfully': 'Der Experte wurde erfolgreich gelöscht',
		'The expert is confirmed': 'Der Experte ist bestätigt',
		Accepted: 'Akzeptiert',
		'Companies Pending, %': 'Firmen ausstehend, %',
		Resolve: 'Beschließen',
		'Show Invoices': 'Rechnungen anzeigen',
		'Customize Multi Widget': 'Multi-Widget anpassen',
		'First Slot': 'Erster Slot',
		'Second Slot': 'Zweiter Slot',
		'Third Slot': 'Dritter Slot',
		'Fourth Slot': 'Vierter Slot',
		'Customize Companies Widget': 'Firmen-Widget anpassen',
		New: 'Neu',
		Overdue: 'Überfällig',
		Unpaid: 'Unbezahlt',
		teachers: 'Lehrer:innen',
		Turnover: 'Umsatz',
		'Confirm Company Profile': 'Firmenprofil bestätigen',
		Documentation: 'Dokumentation',
		'Business activity empty': 'Geschäftstätigkeit leer',
		'Type of offers empty': 'Art der Angebote leer',
		'Business idea empty': 'Geschäftsidee leer',
		'Company Description': 'Firmen Beschreibung',
		'Company description empty': 'Firmenbeschreibung leer',
		'Add Admin Comment': 'Admin-Kommentar hinzufügen',
		'Your Comment about Company (Only administrators will see this comment)':
			'Ihr Kommentar zum Unternehmen (Nur Administratoren sehen diesen Kommentar)',
		'Type comment about company': 'Kommentar zum Unternehmen eingeben',
		'Activate Company': 'Unternehmen aktivieren',
		'Annual financial statements': 'Jahresabschluss',
		Expenditures: 'Ausgaben',
		'Profit/Loss': 'Gewinn/Verlust',
		'To successfully complete the Junior Basic Company the following final accounting must be done.':
			'Um die Junior Basic Company erfolgreich abzuschließen muss die folgende Endabrechnung gemacht werden.',
		Revenue: 'Einnahmen',
		'Total gross revenue': 'Summe brutto-einnahmen',
		'All income from your sales WITHOUT income from the sale of Junior Basic Company shares.':
			'Alle Einnahmen aus euren Verkäufen OHNE Einnahmen aus dem Verkauf von Anteilen der Junior Basic Company.',
		Expenses: 'Ausgaben',
		'Total salary expenses': 'Gehaltsausgaben gesamt',
		'All expenditures for wages of employees of your Junior Basic Company.':
			'Alle Ausgaben für Löhne der Mitarbeiter:innen eurer Junior Basic Company.',
		'Material expenses': 'Materialausgaben',
		'All expenses for the materials you needed to make your products.':
			'Alle Ausgaben für das Material, das ihr zum Herstellen eurer Produkte benötigt habt.',
		'Other expenses': 'Sonstige Ausgaben',
		'Other expenses such as transportation or travel expenses, company Christmas party, etc.':
			'Andere Ausgaben wie z.B. für Transport- oder Reisekosten, Firmenweihnachtsfeier etc.',
		'Total gross expenses': 'Summe Brutto-Ausgaben',
		Validate: 'Weiter',
		Next: 'Vor',
		'Profit/Loss was submitted': 'Gewinn/Verlust wurde eingereicht',
		'Your income minus expenses result in the profit or loss. Important a loss is written as a minus number!':
			'Eure Einnahmen minus Ausgaben ergeben den Gewinn bzw. Verlust. Wichtig: ein Verlust wird als Minuszahl geschrieben!',
		'insurance contribution': 'Versicherungsbeitrag',
		'Insurance premium for all activities of your Junior Company.':
			'Versicherungsbeitrag für sämtliche Aktivitäten euer Junior Company.',
		'Net profit/loss': 'Reingewinn/-verlust',
		'Profit/loss minus insurance contribution gives the net profit/loss.':
			'Gewinn/Verlust abzüglich Versicherungsbeitrag ergibt den Reingewinn/-verlust.',
		'Date of submission (cannot be changed)': 'Datum der Eingabe (kann nicht geändert werden)',
		Previous: 'Zurück',
		'Calculation of profit loss before taxes': 'Berechnung des Gewinnverlusts vor Steuern',
		'Calculation of corporate income tax': 'Berechnung der Körperschaftsteuer',
		'Calculation of net profit/loss': 'Berechnung des Nettogewinns/-verlusts',
		'Calculation of levies to Junior': 'Berechnung der Abgaben an Junior',
		'Calculation of profit/loss before taxes was updated':
			'Berechnung des Gewinns/Verlustes vor Steuern wurde aktualisiert',
		'To successfully complete the Junior Compact Company the following final financial statement must be made.':
			'Um die Junior Compact Company erfolgreich abzuschließen muss die folgende Endabrechnung gemacht werden.',
		'Total Income': 'Summe Einnahmen',
		'Total revenue.': 'Summe Einnahmen',
		'All income from your sales and other income WITHOUT income from the sale of Junior Compact Company shares!':
			'Alle Einnahmen aus euren Verkäufen und sonstige Einnahmen OHNE Einnahmen aus dem Verkauf von Anteilen der Junior Compact Company!',
		'Salary expenses': 'Gehaltsausgaben',
		'All expenses for wages of employees of your Junior Compact Company ("Entrepreneur`s Wages").':
			'Alle Ausgaben für Löhne der Mitarbeiter:innen Eurer Junior Compact Company ("UnternehmerInlohn").',
		'All expenses for materials you needed to produce your products, including sales taxes.':
			'Alle Ausgaben für Material, das Ihr zum Herstellen Eurer Produkte benötigt habt inkl. darin enthaltene Umsatzsteuern.',
		'Other expenses such as transportation or travel expenses, company Christmas party, ....':
			'Andere Ausgaben wie z.B. für Transport- oder Reisekosten, Firmenweihnachtsfeier, ...',
		'Sum of expenses': 'Summe der Ausgaben',
		'Calculation of profit/loss before taxes': 'Berechnung Gewinn/Verlust vor Steuern',
		'Profit/Loss (before tax)': 'Gewinn/Verlust (vor Steuern)',
		'Preliminary profit/loss before deduction of taxes.': 'Vorläufiger Gewinn/Verlust vor dem Abzug der Steuern.',
		'- 13% Salary-related social security contributions': '- 13% Gehaltsabhängige Sozialabgaben',
		'Salary-related social security contributions': 'Gehaltsabhängige Sozialabgaben',
		'Depending on the amount of salaries or entrepreneur wages paid, 13% social contributions must be paid.':
			'Abhängig von der Höhe der ausbezahlten Gehälter bzw. UnternehmerInnenlöhne müssen 13% Sozialabgaben entrichtet werden.',
		'Insurance contribution': 'Versicherungsbeitrag',
		'Insurance contribution for all activities of your Junior Company.':
			'Versicherungsbeitrag für sämtliche Aktivitäten euer Junior Company.',
		'Profit/loss (before corporate income tax)': 'Gewinn/Verlust (vor KöSt.)',
		'Preliminary profit/loss before deduction of corporate income tax, which is due only in case of profit.':
			'Vorläufiger Gewinn/Verlust vor dem Abzug der KöSt, die nur im Falle eines Gewinnes anfällt.',
		'Calculation of corporate income tax was updated': 'Berechnung der Körperschaftsteuer wurde aktualisiert',
		'25% corporate income tax': '25% Körperschaftssteuer',
		'Corporate income tax': 'Körperschaftssteuer',
		'Corporate income is taxed at a fixed rate of 25%.':
			'Das Einkommen der Körperschaften wird mit einem fixen Steuersatz iHv. 25% besteuert.',
		'Founder`s bonus (20% of corporate income tax)': 'Gründerbonus (20% der KöSt.)',
		'This represents a tax relief of 20% of the corporate income tax exclusively for junior companies.':
			'Dieser stellt eine steuerliche Entlastung iHv. 20% der KöSt. exklusiv für Junior Companies dar.',
		'Reduced corporate income tax': 'Reduzierte Körperschaftssteuer',
		'The calculated amount represents the deductible corporate income tax.':
			'Der errechnete Betrag stellt die abzüführende Körperschaftssteuer dar.',
		'Calculation of net profit/loss was updated': 'Berechnung des Nettogewinns/-verlusts wurde aktualisiert',
		'Calculation of net profit/loss (to be distributed)': 'Berechnung Reingewinn/-verlust (zu verteilen)',
		'The reduced corporate income tax is to be deducted from the provisional profit.':
			'Die reduzierte Körperschaftssteuer ist vom vorläufigen Gewinn abzuziehen.',
		'Net profit / Net loss': 'Reingewinn / Reinverlust',
		'This amount represents your profit/loss after deduction of taxes.':
			'Dieser Betrag stellt euren Gewinn/Verlust nach Abzug der Steuern dar.',
		'Calculation of levies to Junior was submitted': 'Umlageberechnung an Junior wurde eingereicht',
		'Levies to be transferred to Junior Austria': 'Abgaben an Junior Österreich zu überweisen',
		'According to this schedule, levies are to be remitted to the account indicated in the invoice.':
			'Laut dieser Aufstellung sind Abgaben auf das in der Rechnung angeführtes Konto zu überweisen.',
		'+ 13% salary-related social security contributions': '+ 13% Gehaltsabhängige Sozialabgaben',
		'= Taxes to be transferred to Junior Austria': '= Abgaben an Junior Österreich zu überweisen',
		'Revenues and sales': 'Einnahmen und Verkäufe',
		'Expenses and input tax deduction': 'Aufwendungen und Vorsteuerabzug',
		'Salary-related taxes (employee share)': 'Gehaltsabhängige Abgaben (Dienstnehmeranteil)',
		'Advance return for sales tax': 'Umsatzsteuer Voranmeldung (UVA)',
		'Calculation half-year result': 'Berechnung Halbjahresergebnis',
		'Financial report first semester': 'Finanzbericht erstes Semester',
		'Revenues was deleted': 'Einnahmen wurden gelöscht',
		'Revenues and sales was updated': 'Umsätze und Verkäufe wurden aktualisiert',
		'Deadline by DD.MM.YYYY': 'Frist bis TT.MM.JJJJ',
		'Income from the sale of company shares does not count towards your sales!':
			'Einnahmen aus dem Verkauf von Unternehmensanteilen zählen nicht zu Euren Umsätzen!',
		'Here you can create new groups of turnovers, with different VAT rates.':
			'Hier könnt ihr neue Gruppen an Umsätzen anlegen, mit unterschiedlichen Umsatzsteuersätzen.',
		'Turnovers in € incl. VAT': 'Umsätze in € inkl. USt.',
		'VAT rate': 'Umsatzsteuersatz',
		'Turnover total': 'Umsätze gesamt',
		'of which': 'davon',
		'% VAT in €': '%-ige Umsatzsteuer in €',
		'Create new entry': 'Neuen Eintrag anlegen',
		'Junior tax-exempt revenues': 'Junior Abgabenfreie Einnahmen',
		'These revenues do not count towards the calculation of junior corporate tax and do not include VAT - e.g. sponsorship.':
			'Diese Einnahmen zählen nicht zur Berechnung der Junior Körperschaftsteuer und enthalten keine Umsatzsteuer – bspw. Sponsoring.',
		'Total in €': 'Summe in €',
		'For VAT-exempt revenue from sponsorship, the company must provide a consideration in the form of advertising or public relations. Describe here what consideration you will provide for each sponsorship received.':
			'Für USt-freie Einnahmen aus Sponsoring muss das Unternehmen eine Gegenleistung in Form von Werbung oder Öffentlichkeitsarbeit erbringen. Beschreibt hier, welche Gegenleistung Ihr für jedes erhaltene Sponsoring erbringen werdet.',
		'Describe returns...': 'Retouren beschreiben...',
		'Material expenses were deleted': 'Materialaufwand wurde gelöscht',
		'Other expenses were deleted': 'Andere Ausgaben wurden gelöscht',
		'Expenses and input tax deduction was updated': 'Aufwand und Vorsteuerabzug wurde aktualisiert',
		'Enter the total of your material and other expenses and the input tax (sales tax) included in them. The input tax is offset against the sales tax collected on your sales and reduces the tax payment.':
			'Gebt hier die Summe Eurer Material- und sonstigen Ausgaben sowie die darin enthaltene Vorsteuer (Umsatzsteuer) an. Die Vorsteuer wird mit der eingenommen Umsatzsteuer eurer Verkäufe gegengerechnet und vermindert die Abgabenzahlung.',
		'Sales tax rate': 'Umsatzsteuersatz',
		'Material expenses in € incl. <%> VAT.': 'Materialausgaben in € inkl. % USt.',
		'% sales tax in €': '%-ige Umsatzsteuer in €',
		'Other expenses in € incl. <%> VAT.': 'Sonstige Ausgaben in € inkl. % USt.',
		'Other expenses not subject to sales tax': 'Sonstige umsatzsteuerfreie Ausgaben',
		'Please enter an accurate list of VAT-exempt expenses here.':
			'Bitte tragt hier eine genaue Liste der umsatzsteuerfreien Ausgaben ein.',
		'Salary-related taxes was updated': 'Gehaltsbezogene Steuern wurden aktualisiert',
		'Total gross salaries (in €)': 'Summe der Bruttogehälter (in €)',
		'minus 5% social security contribution (in €)': 'minus 5% Sozialversicherungsabgabe (in €)',
		'= Calculation basis (in €)': '= Berechnungsgrundlage (in €)',
		'minus 10% wage tax (in €)': 'minus 10% Lohnsteuer (in €)',
		'= Net wages (in €)': '= Nettolöhne (in €)',
		'Salary-related taxes (employer`s contribution)': 'Gehaltsabhängige Abgaben (Arbeitgeberanteil)',
		'of which 6% social security contribution (in €)': 'davon 6% Sozialversicherungsabgabe (in €)',
		'Statement of revenues and expenses were updated': 'Ertrags- und Aufwandsrechnung wurde aktualisiert',
		'Statement of revenues': 'Aufstellung der Einnahmen',
		'Sales in € incl.': 'Umsatz in € inkl.',
		'% VAT.': '% MwSt.',
		'Total gross sales in €': 'Umsätze brutto gesamt in €',
		'Total sales tax': 'Umsatzsteuer gesamt',
		'Turnover net total in €': 'Umsätze netto gesamt in €',
		'Material expenses in € incl.': 'Materialkosten in € inkl.',
		'Other expenses in € incl.': 'Sonstige Ausgaben in € inkl.',
		'Total gross costs in €': 'Kosten brutto gesamt in €',
		'Input tax total in €': 'Vorsteuer gesamt in €',
		'Total net costs in €': 'Kosten netto gesamt in €',
		'Advance return of the value added tax (UVA)': 'Umsatzsteuer Voranmeldung (UVA)',
		'Statement of expenses': 'Spesenabrechnung',
		'List of tasks': 'Aufstellung der Ausgaben',
		'Calculation half-year result was submitted': 'Berechnung Halbjahresergebnis wurde vorgelegt',
		'The semi-annual report was successfully submitted and cannot be changed now. Date':
			'Der Halbjahresbericht wurde erfolgreich eingereicht und kann nun nicht mehr verändert werden. Datum',
		'Statement of income/expenses': 'Einnahmen-/Ausgaben-Rechnung',
		'Sales net in €': 'Umsätze netto in €',
		'less material and other costs net in €': 'abzügl. Material- und sonstige Kosten netto in €',
		'less personnel costs incl. all taxes in €': 'abzügl. Personalkosten inkl. aller Abgaben in €',
		'less other expenses not subject to sales tax in €': 'abzügl. sonstige umsatzsteuerfreie Ausgaben in €',
		'less junior insurance in €': 'abzügl. Junior-Versicherung in €',
		'Half-year result total in €': 'Halbjahresergebnis gesamt in €',
		'Calculation half-year expenses': 'Berechnung Halbjahresausgaben',
		'Sales taxes collected in €': 'Eingenommene Umsatzsteuern in €',
		'less input taxes in €': 'abzügl. Vorsteuern in €',
		'Wage and salary contributions in €': 'Lohn- und Gehaltsabgaben in €',
		'plus junior insurance in €': 'zuzügl. Junior-Versicherung in €',
		'Total charges in €': 'Abgaben gesamt in €',
		'Submit half-yearly financial statements': 'Halbjahresabschluss einreichen',
		'Payload or credit': 'Zahllast oder Guthaben',
		'Income/Expense statement ': 'Gewinn- und Verlustrechnung (GuV)',
		'Calculation of contributions 2nd half': 'Berechnung der Abgaben 2. HJ',
		'Financial report second semester': 'Finanzbericht zweites Semester',
		'1st Semiannual Advance return of the value added tax (UVA)':
			'1. Halbjahresvoranmeldung der Mehrwertsteuer (UVA)',
		'2nd Semiannual Advance return of the value added tax (UVA)':
			'2. Halbjahresvoranmeldung der Mehrwertsteuer (UVA)',
		'= Sales tax calculation': '= Umsatzsteuerberechnung',
		'Income/Expense statement was updated': 'Ertrags-/Aufwandsrechnung wurde aktualisiert',
		'Income/Expense statement for whole year': 'Einnahmen-/Ausgaben-Rechnung für das ganze Jahr',
		'Total net income for the year in €': 'Gesamtjahresergebnis in €',
		'thereof 10% corporate income tax in €': 'davon 10% Körperschaftsteuer in €',
		'Payload or credit was updated': 'Nutzlast oder Guthaben wurde aktualisiert',
		'Calculation of contributions 2nd half was submitted': 'Beitragsberechnung 2. Hälfte wurde eingereicht',
		'Calculated corporate income tax': 'Berechnete Körperschaftsteuer',
		'Result VAT return in €': 'Ergebnis Umsatzsteuererklärung in €',
		'Total contributions in €': 'Gesamtbeiträge in €',
		'Submit yearly financial statements': 'Jahresabschluss einreichen',
		'School deleted successfully': 'Schule erfolgreich gelöscht',
		'No business plan yet': 'Noch kein Businessplan',
		'No risk analysis yet': 'Noch keine Risikoanalyse',
		'Go To Students': 'Zu den Schüler:innen',
		'Privacy Statement': 'Zur Datenschutzerklärung',
		'Confirm email': 'Bitte bestätigen Sie Ihre E-Mail',
		'Need to confirm email': 'E-Mail muss bestätigt werden',
		'Mr.': 'Herr',
		'Ms.': 'Frau',
		'Mrs.': 'Frau',
		Miss: 'Frau',
		Male: 'Männlich',
		Gender: 'Geschlecht',
		Female: 'Weiblich',
		Divers: 'Vielfältig',
		Products: 'Produkte',
		Service: 'Dienstleistungen',
		'Services & Products': 'Produkte & Dienstleistungen',
		'Clothing & Accessories': 'Bekleidung & Accessories',
		'Office Supplies': 'Bürobedarf',
		Electronics: 'Elektronik',
		Vehicles: 'Fahrzeuge',
		Vienna: 'Wien',
		'Lower Austria': 'Niederösterreich',
		Burgenland: 'Burgenland',
		Styria: 'Steiermark',
		'Upper Austria': 'Oberösterreich',
		Salzburg: 'Salzburg',
		Tyrol: 'Tirol',
		Vorarlberg: 'Vorarlberg',
		Carinthia: 'Kärnten',
		'Parental confirmation updated': 'Elternbestätigung aktualisiert',
		'Managing director': 'Geschäftsführung',
		Procurement: 'Einkauf',
		Finance: 'Finanzen',
		'Human Resources / Administration': 'Human Resources / Administration',
		'Marketing / Communication': 'Marketing / Kommunikation',
		'Production / Services': 'Produktion / Leistungserstellung',
		Other: 'Sonstige',
		'Technology / IT': 'Technologie / IT',
		Sales: 'Verkauf',
		'Avatar successfully updated': 'Avatar erfolgreich aktualisiert',
		'Avatar successfully deleted': 'Avatar erfolgreich gelöscht',
		consent: 'Ich habe die <1>Datenschutzerklärung</1> gelesen und willige in die Datenverarbeitungen ein',
		'Approve expert': 'Experte genehmigen',
		'Disapprove expert': 'Experten ablehnen',
		'The expert was rejected': 'Der Experte wurde abgelehnt',
		'Тhe expert is approved': 'Тder Sachverständige ist anerkannt',
		'Not Activated': 'Nicht aktiviert',
		// Status im Unternehmensprofil der Lehrkraft: eingereicht, aber noch nicht
		// entschieden
		'In review': 'In Prüfung',
		Reviewed: 'Bewertet',
		'Not Reviewed': 'Nicht überprüft',
		'You have no notifications at this time': 'Sie haben derzeit keine Mitteilungen',
		'New messages about your company will appear here.':
			'Neue Mitteilungen zu Ihrem Unternehmen erscheinen an dieser Stelle.',
		Today: 'Heute',
		Yesterday: 'Gestern',
		unread: 'ungelesen',
		'To all messages': 'Alle Mitteilungen',
		'Repeat password does not match with Password': 'Die Passwörter stimmen nicht überein',
		'Checklist confirm account': 'Benutzerkonto',
		'Select or add your school': 'Wähle bzw. füge deine Schule hinzu',
		'Select or add your teacher': 'Wähle bzw. füge deine Lehrkraft hinzu',
		'Confirm Email': 'E-Mail Bestätigung',
		Hello: 'Hallo',
		'Add Employees': 'MA hinzufügen',
		'Add Experts': 'Exp. hinzufügen',
		'Risk Analysis': 'Markt- und Risikoanalyse',
		Check: 'Prüfung',
		'Create Share': 'Verkauf von Anteilen',
		'Semester Report': 'Finanz-Bericht',
		'Pay Invoice': 'Abgaben entrichten',
		'Document Type': 'Art des Dokuments',
		'Request sent successfully': 'Anfrage erfolgreich gesendet',
		'View profile': 'Profil anzeigen',
		'Request to assign': 'Zuordnung anfordern',
		'Company status': 'Unternehmensstatus',
		'Clear all': 'Alles löschen',
		Messages: 'Mitteilungen',
		'General Profit': 'Allgemeiner Gewinn',
		'Overdue Reports': 'Überfällige Berichte',
		'Search reports': 'Berichte suchen...',
		'Report type': 'Berichtstyp',
		'Clear All': 'Alles löschen',
		'You can sell the company shares after activating the company':
			'Sie können die Unternehmensanteil nach der Aktivierung des Unternehmens verkaufen',
		Position: 'Arbeitsbereich',
		'Your parental': 'Einverständnis der Eltern',
		'Refresh status': 'Status aktualisieren',
		'Resend activation email': 'Bestätigungsmail erneut senden',
		confirmEmail:
			'Eine Bestätigungsmail wurde an <highlight>{{email}}</highlight> geschickt. Bitte klicken Sie den Bestätigungslink in dieser E-Mail, um das Benutzerkonto zu aktivieren. Bitte prüfen Sie auch Ihren Spam-Ordner.',
		'Get certificate template': 'Zertifikatvorlage abrufen',
		'The file is too large. Current file size': 'Die Datei ist zu groß. Aktuelle Dateigröße',
		'Max file size is': 'Die maximale Dateigröße beträgt',
		'School Name': 'Schulname',
		Number: 'Nummer',
		'Add Teacher': 'Lehrer hinzufügen',
		'Please confirm your email': 'Bitte bestätigen Sie Ihre E-Mail',
		Register: 'Registrieren',
		'Deadline by': 'Abschluss bis',
		// Kopf eines abgegebenen Berichts: Datum der Abgabe statt der Frist
		'Submitted on {{date}}': 'Eingereicht am {{date}}',
		'Create new school': 'Schule bearbeiten',
		STUDENT: 'Schüler:innen',
		TEACHER: 'Lehrer:innen',
		'Functional and working area': 'Funktions - und Arbeitsbereich',
		'Risk analysis form successfully updated': 'Risikoanalyseformular erfolgreich aktualisiert',
		'You need to activate the company to unlock this feature':
			'Sie müssen das Unternehmen aktivieren, um diese Funktion freizuschalten',
		Share: 'Anteil',
		'Add Shareholder': 'Anteilseigner:in hinzufügen',
		'Company approved': 'Unternehmen genehmigt',
		'Company not yet approved': 'Unternehmen noch nicht genehmigt',
		'Submit for approval': 'Zur Genehmigung einreichen',
		'Expert already confirmed.': 'Experte hat es bereits bestätigt.',
		'The letter is not valid.': 'Der Brief ist ungültig.',
		'The registration link has expired.': 'Der Registrierungslink ist abgelaufen.',
		'The email does not seem to be associated with any user.':
			'Die E-Mail scheint keinem Benutzer zugeordnet zu sein',
		'The email does not seem to be associated with any expert.':
			'Die E-Mail scheint keinem Experten zugeordnet zu sein.',
		'Company submitted for approval': 'Unternehmen zur Genehmigung eingereicht',
		'Check Confirmed': 'Check bestätigt',
		Reject: 'Ablehnen',
		'Reject Company': 'Unternehmen ablehnen',
		'Regenerate company certificate': 'Firmenbuchauszug regenerieren',
		'Reject Parental Confirmation': 'Elternbestätigung ablehnen',
		'Download template': 'Formular download',
		'Approve school': 'Schule verifizieren',
		'The school has been approved': 'Die Schule wurde genehmigt',
		'Verify teacher': 'Lehrer bestätigen',
		'Teacher status': 'Lehrerstatus',
		Yes: 'Ja',
		No: 'Nein',
		'The shareholder was created successfully': 'Der Aktionär wurde erfolgreich geschaffen',
		'Need review': 'Überprüfung erforderlich',
		'Analysis & Plan': 'Analyse & Plan',
		'Emp. / consent': 'MA / Einverst.',
		'Employees and parental consent': 'Mitarbeiter:innen / davon mit Einverständnis der Eltern',
		'Parental consent': 'Einverständnis Eltern',
		'Fed. State': 'Bundesland',
		'Pass Recovery': 'PW Wiederherstellung',
		'Account already activated.': 'Benutzerkonto wurde bereits aktiviert.',
		Assign: 'Auswählen',
		'Market and Riskanalysis': 'Markt- und Risikoanalyse',
		Example: 'Beispiel',
		Activated: 'Aktiviert',
		'No main work area yet': 'Noch kein Hauptarbeitsbereich',
		'Need to upload parental confirmation': 'Bitte Elternbestätigung hochladen',
		'This icon shows incomplete steps, such as missing parental confirmation, unassigned working area, or pending employee invitation.':
			'Dieses Symbol kennzeichnet unvollständige Schritte, wie fehlende Elternbestätigung, nicht zugewiesenen Aufgabenbereich oder ausstehende Mitarbeiter-Einladung.',
		Payee: 'Beneficiary',
		Beneficiary: 'Begünstigter',
		Merge: 'Zusammenführen',

		// --- Lehrkräfte zusammenführen -------------------------------------
		// Zwei Konten derselben Lehrkraft zu einem machen: Das eine wird
		// aufgelöst, seine betreuten Junior Companies hängen danach am anderen.
		// Wie bei den Schulen sagen die Texte beides beim Namen, weil das
		// aufgelöste Konto endgültig gelöscht wird.
		'Merge teachers': 'Lehrkräfte zusammenführen',
		'Merge teachers?': 'Lehrkräfte zusammenführen?',
		'Merge teacher': 'Mit anderer Lehrkraft zusammenführen',
		mergeTeachersIntro:
			'Hat dieselbe Lehrkraft zwei Konten — etwa nach dem Wechsel der E-Mail-Adresse —, lassen sich die beiden zu einem machen. Eines der Konten wird dabei aufgelöst.',
		'This account is dissolved': 'Dieses Konto wird aufgelöst',
		'This account remains': 'Dieses Konto bleibt bestehen',
		'Supervised Junior Companies move along': 'Betreute Junior Companies wechseln mit',
		'Search teacher by name': 'Lehrkraft suchen — Vor- oder Nachname',
		'Please choose the account that remains': 'Bitte das Konto auswählen, das bestehen bleibt',
		'No school assigned': 'Keine Schule hinterlegt',
		'Supervises no Junior Company': 'Betreut keine Junior Company',
		supervisedCompaniesNote: 'Betreute Junior Companies ({{total}}):',
		'+ {{total}} more': '+ {{total}} weitere',
		mergeTeachersConfirmText:
			'„{{from}}" wird endgültig gelöscht. Alle betreuten Junior Companies gehören danach zu „{{to}}".',
		mergeTeachersWarning:
			'Das aufgelöste Konto wird endgültig gelöscht — mit seiner Anmeldung, seinen offenen Zuordnungsanfragen und seinen Benachrichtigungen. Rückgängig machen lässt sich das nicht.',
		mergeTeachersDone: 'Die Konten wurden zusammengeführt. Es bleibt „{{to}}".',

		// --- Schulen zusammenführen ---------------------------------------
		// Doppelt angelegte Schulen zu einer machen: Die eine wird aufgelöst,
		// ihre Lehrkräfte hängen danach an der anderen. Die Texte sagen beides
		// beim Namen — welche Schule verschwindet und was mit den Personen
		// passiert —, weil der Vorgang nicht rückgängig zu machen ist.
		'Merge schools': 'Schulen zusammenführen',
		'Merge schools?': 'Schulen zusammenführen?',
		'Merge school': 'Mit anderer Schule zusammenführen',
		mergeSchoolsIntro:
			'Ist dieselbe Schule doppelt angelegt, lassen sich die beiden Einträge zu einem machen. Eine der Schulen wird dabei aufgelöst.',
		'This school is dissolved': 'Diese Schule wird aufgelöst',
		'This school remains': 'Diese Schule bleibt bestehen',
		'Teachers, companies and students move along':
			'Lehrkräfte wechseln mit — samt ihren Unternehmen und Schüler:innen',
		'Search school by name, place or postal code': 'Schule suchen — Name, Ort oder PLZ',
		'Please choose the school that remains': 'Bitte die Schule auswählen, die bestehen bleibt',
		'No teachers are assigned to this school.': 'Dieser Schule ist keine Lehrkraft zugeordnet',
		'One teacher moves to the remaining school.': '1 Lehrkraft wechselt zur bleibenden Schule',
		teachersMoveNote: '{{count}} Lehrkräfte wechseln zur bleibenden Schule',
		mergeSchoolsConfirmText:
			'„{{from}}" wird endgültig gelöscht. Alle zugeordneten Lehrkräfte gehören danach zu „{{to}}".',
		mergeSchoolsWarning:
			'Die aufgelöste Schule wird endgültig gelöscht. Rückgängig machen lässt sich das nicht — nur neu anlegen.',
		mergeSchoolsDone: 'Die Schulen wurden zusammengeführt. Es bleibt „{{to}}".',
		'School has been created successfully.': 'Schule wurde erfolgreich erstellt.',
		'School has been updated successfully.': 'Schule wurde erfolgreich aktualisiert.',
		'Company profile has been updated successfully.': 'Firmenprofil wurde erfolgreich aktualisiert.',
		'User profile has been updated.': 'Benutzerprofil wurde aktualisiert.',
		'Annual deadline': 'Jahresfrist',
		'Semiannual deadline': 'Halbjahresfrist',
		Deadline: 'Termin',
		'The parental confirmation was rejected successfully': 'Die Elternbestätigung wurde erfolgreich abgelehnt',
		'The course certificate was rejected successfully': 'Der Kursnachweis wurde erfolgreich abgelehnt',
		'The company was rejected successfully': 'Das Unternehmen wurde erfolgreich abgelehnt',
		'The letter was sent successfully': 'Bestätigungsmail wurde versendet',
		'No need review': 'Keine Überprüfung erforderlich',
		'Review status': 'Überprüfungsstatus',
		Submitted: 'Bereitgestellt',
		Open: 'Offen',
		Checked: 'Geprüft',
		OK: 'OK',
		'Parental rejected': 'Abgelehnt',
		'Company was created successful.': 'Unternehmen wurde erfolgreich erstellt.',
		'Company comment is updated': 'Firmenkommentar wird aktualisiert',
		'Not Verified': 'Nicht verifiziert',
		'not yet activated by the state administration': 'noch nicht von der Landesadministration freigeschaltet',
		'Wait for an invitation from an existing company':
			'Warten Sie auf eine Einladung von einem bestehenden Unternehmen',
		'Teacher registered successful.': 'Lehrer erfolgreich registriert.',
		'Wait invitation': 'Warte Einladung',
		'Wait Invitation': 'Einladung Warten',
		'Email successfully changed': 'E-Mail erfolgreich geändert',
		'Email change confirmation': 'Bestätigung der E-Mail-Änderung',
		Rejected: 'Abgewiesen',
		'Parental confirmation was rejected, upload new please !':
			'Elternbestätigung wurde abgelehnt, bitte neu hochladen!',
		'Status was updated': 'Status wurde aktualisiert',
		'Invoice created, you can find it in documents': 'Rechnung erstellt, Sie finden sie in den Dokumenten',
		'Change payment': 'Zahlungseingang',
		'Change pay': 'Lohn ändern',
		'Teacher Status': 'Lehrerstatus',
		'Number of Students': 'Schüler:innen',
		'Number of companies': 'Unternehmen',
		'Company Reminders': 'Aktivierungserinnerung',
		'1st reminder [x] days after company set-up started and not finished and no login':
			'Erste Erinnerung [x] Tage nach Firmenbeginn und noch nicht abgeschlossen und kein Login',
		'1st reminder [x] days after company profile has been submitted for approval and no login':
			'Erste Erinnerung [x] Tage nachdem das Firmenprofil zur Genehmigung eingereicht wurde und kein Login',
		'Financial Reporting Reminders': 'Erinnerungen an die Finanzberichterstattung',
		'Junior Company': 'Junior-Unternehmen',
		'1st reminder [x] days before deadline': 'Erste Mahnung [x] Tage vor Fristablauf',
		'Reminder frequency each [x] day(s)': 'Erinnerungshäufigkeit jeden [x] Tag(e)',
		'Junior Basic Company and Junior Compact Company': 'Junior Basic Company und Junior Compact Company',
		'Invoicing Reminders': 'Rechnungserinnerungen',
		'1st reminder [x] days after invoice has been issued': 'Erste Mahnung [x] Tage nach Rechnungsstellung',
		'Options was updated': 'Optionen wurde aktualisiert',
		days: 'Tage',
		details: 'Einzelheiten',
		school: 'Schule',
		Administrator: 'Landesadmin',
		'Federal Administrator': 'Bundesadmin',
		B: 'S',
		A: 'B',
		'St.': 'BL',
		D: 'F',
		'Comp.': 'Untern.',
		'All states': 'Alle',
		'Customize Widget': 'Widget Konfiguration',
		VAT: 'Ust.',
		'Debit note': 'Zahllast',
		'Credit note': 'Gutschrift',
		Semiannual: 'Halbjahresbericht',
		Annual: 'Jahresbericht',
		Paid: 'Bezahlt',
		'If the invoice amount matches the payment, the invoice status changes to paid. If there is a difference, the balance is not equal to zero.':
			'Entspricht der eingegangene Betrag dem Rechnungsbetrag, wechselt die Rechnung auf „Bezahlt“. Bei einer Differenz bleibt ein offener Saldo stehen.',

		// --- Zahlungseingang erfassen --------------------------------------
		// Kopfkarte des Fensters: zu welcher Rechnung gebucht wird, und die
		// drei Beträge, aus denen sich der einzutragende Wert ergibt.
		'Invoice amount': 'Rechnungsbetrag',
		'Already paid': 'Bereits bezahlt',
		'Open balance': 'Offener Saldo',
		'Amount received in €': 'Eingegangener Betrag in €',
		'Please enter an amount': 'Bitte einen Betrag eingeben',
		'No more than the invoice amount': 'Nicht höher als der Rechnungsbetrag',

		'Change status': 'Status ändern',
		'To be checked': 'Zu überprüfen',
		'Widget settings updated successfully': 'Widget-Einstellungen erfolgreich aktualisiert',
		'Email or password is not correct': 'E-Mail oder Passwort ist nicht korrekt',
		'The new password should differ from the old one': 'Das neue Passwort sollte sich vom alten unterscheiden',
		'Emp.': 'MA',
		'Pa.C': 'Elt.E',
		FS: 'BL',
		'Rep.': 'Ber.',
		'Bal.': 'Sal.',
		'Rev.': 'Ein.',
		'Exp.': 'Aus.',
		'Res.': 'Erg.',
		'Cha.': 'Abg.',
		'Please wait': 'Warten Sie mal',
		'Wrong result': 'Falsches Ergebnis',
		'Report was successfully submitted.': 'Bericht wurde erfolgreich eingereicht.',
		Total: 'Gesamt',
		Active: 'Aktiv',
		Verification: 'In Prüfung',
		Waitlist: 'Warteliste',
		'Add employee': 'Mitarbeiter hinzufügen',
		'Employee status': 'MA Status',
		Invoice: 'Rechnung',
		'Business plan': 'Businessplan',
		'Parental confirmation': 'Bestätigung der Eltern',
		'Consent document': 'Einverständniserklärung',
		'Participation document': 'Teilnahmedokument',
		'Company certificate': 'Firmenbuchauszug',
		'Shareholder certificate': 'Anteilschein',
		ANNUAL: 'Jahresbericht',
		SEMIANNUAL: 'Halbjahresbericht',
		'Invoice payment reminder': 'Zahlungserinnerung',
		'Assign Request': 'Anfrage zuweisen',
		'The report has been submitted, the invoice was created. Please pay the invoice.':
			'Der Bericht wurde eingereicht, die Rechnung wurde erstellt. Bitte bezahlen Sie die Rechnung.',
		'Your request was accepted. Company': 'Deine Anfrage wurde angenommen. Gesellschaft',
		'Your request was rejected. Company': 'Ihre Anfrage wurde abgelehnt. Gesellschaft',
		'wants to be assigned as teacher in your company.': 'möchte als Lehrer in Ihrem Unternehmen eingesetzt werden.',
		'Company Confirmation': 'Firmenbestätigung',
		'has submitted company for business approval': 'hat das Unternehmen zur Geschäftsgenehmigung eingereicht',
		'Congratulation!': 'Herzlichen Glückwunsch!',
		'Great Job, you have been awarded for participation in Junior Company Program - download your certificate':
			'Tolle Arbeit, Sie wurden für die Teilnahme am Junior Company Program ausgezeichnet - laden Sie Ihr Zertifikat herunter',
		Payment: 'Zahlung',
		'You company has paid the invoice': 'Ihr Unternehmen hat die Rechnung bezahlt',
		'You company has to make a payment invoice': 'Ihr Unternehmen muss eine Zahlungsrechnung erstellen',
		'New User': 'Neuer Benutzer',
		'joined successfully to company !': 'trat erfolgreich in das Unternehmen ein!',
		'Congratulation, you have successfully submitted the': 'Herzlichen Glückwunsch, Sie haben den',
		'Fin. Report': 'Bericht erfolgreich eingereicht',
		'Teacher Confirmation': 'Lehrerbestätigung',
		'Congratulation, your account was confirmed by an admin':
			'Herzlichen Glückwunsch, Ihr Konto wurde von einem Administrator bestätigt',
		'Congratulation, your parental confirmation has been approved by an admin':
			'Herzlichen Glückwunsch, Ihre elterliche Bestätigung wurde von einem Administrator genehmigt',
		'Company Activation': 'Unternehmensaktivierung',
		'Congratulation, your company has been approved by an admin':
			'Herzlichen Glückwunsch, Ihr Unternehmen wurde von einem Administrator genehmigt',
		'Report was rejected': 'Bericht wurde abgelehnt',
		'Company report was rejected. Please check and submit report again.':
			'Der Firmenbericht wurde abgelehnt. Bitte überprüfen Sie den Bericht und senden Sie ihn erneut.',
		Employees: 'Mitarbeiter:innen',
		'Rep.Typ': 'Bericht',
		Revenues: 'Einnahmen',
		Expanses: 'Ausgaben',
		Charges: 'Abgaben',
		Reported: 'Berichtet am',
		// Ausgeschriebene Spaltenüberschriften der Listen (Anforderung #79)
		'E-Mail': 'E-Mail',
		// Fenster "Unternehmensprofil" der Lehrkraft (Anforderung #78): der
		// Firmenbuchauszug ist ein eigenes Dokument und gehoert nicht in die Beschriftung
		'This report has been submitted and can no longer be edited. If something needs to be corrected, the administration can reset it.':
			'Dieser Bericht wurde eingereicht und kann nicht mehr bearbeitet werden. Muss etwas berichtigt werden, kann die Administration ihn zurücksetzen.',
		'View Detail': 'Details ansehen',
		Branch: 'Branche',
		// Bei JBC und JCC heißt der eine Abschluss so, obwohl er als SEMIANNUAL
		// gespeichert ist (Anforderung #87)
		Jahresabschluss: 'Jahresabschluss',
		'Deadline (d)': 'Frist (T)',
		'Invoice Number': 'Rechnungsnummer',
		Credit: 'Guthaben',
		Cancelled: 'Storniert',
		'Cancel invoice': 'Rechnung stornieren',
		'Reason for cancellation': 'Grund des Stornos',
		'The invoice was cancelled': 'Die Rechnung wurde storniert',
		invoiceCancelHeading: 'Rechnung {{no}} über {{amount}} stornieren?',
		invoiceCancelExplain:
			'Die Rechnung bleibt mit ihrer Nummer bestehen, zählt aber nicht mehr zu den offenen Posten und wird in den Kennzahlen eigens ausgewiesen. Der Bericht wird zur Neubearbeitung freigegeben — die eingetragenen Zahlen bleiben stehen. Beim erneuten Einreichen entsteht eine neue Rechnung mit neuer Nummer. Eine bereits erfasste Zahlung bleibt als Guthaben am stornierten Beleg stehen und wird auf die neue Rechnung angerechnet. Der Storno lässt sich nicht rückgängig machen.',
		// Nur wenn auf die Rechnung schon gezahlt wurde: Wer storniert, soll
		// unmittelbar sehen, dass das Geld nicht verloren geht (Anforderung #91).
		invoiceCancelCreditNote:
			'Auf diese Rechnung wurden bereits {{amount}} gezahlt. Der Betrag bleibt als Guthaben bestehen und wird beim nächsten Einreichen auf die neue Rechnung zu diesem Bericht angerechnet.',
		'View Report': 'Bericht öffnen',
		'Reject report': 'Bericht ablehnen',
		'The report was reopened and the invoice cancelled':
			'Der Bericht ist wieder offen, die Rechnung wurde storniert',
		reportRejectedWithCredit:
			'Der Bericht ist wieder offen, die Rechnung wurde storniert. {{amount}} bleiben als Guthaben und werden auf die neue Rechnung angerechnet.',
		'Not approved': 'Nicht approved',
		'Company Rejected': 'Unternehmen abgelehnt',
		'Submit Report': 'Bericht senden',
		'Please submit report before deadline !': 'Bericht bitte vor Fristablauf einreichen!',
		'Edit Userprofile': 'Benutzerprofil bearbeiten',
		'Download parental consent': 'Elternbestätigung herunterladen',
		'Download parental consent (not uploaded yet!)': 'Elternbestätigung herunterladen (noch nicht hochgeladen!)',
		'Parental consent verfied': 'Elternbestätigung (verfiziert)',
		'Parental consent (need verifying)': 'Elternbestätigung (muss überprüft werden)',
		'New Employee': 'Neuer Angestellter',
		'has invited': 'hat',
		'to work in the company.': 'zur Mitarbeit im Unternehmen eingeladen.',
		'New Teacher': 'Neuer Lehrer',
		'has invited the teacher': 'hat die Lehrkraft',
		'to the enterprise.': 'zum Unternehmen eingeladen.',
		'New Expert': 'Neuer Experte',
		'has registered': 'hat',
		'as a economic experts.': 'als Wirtschaftsexpert:in eingetragen.',
		'Expert Confirmation': 'Expertenbestätigung',
		'Business expert': 'Wirtschaftsexpert:in',
		'agrees with the GDPR.': 'ist mit der Verarbeitung der personenbezogenen Daten gemäß DSGVO einverstanden.',
		'Great, you have dealt with the market and risk analysis.':
			'Super, ihr habt euch mit der Markt- und Risikoanalyse befasst.',
		'Your business plan has been successfully uploaded.': 'Euer Businessplan wurde erfolgreich hochgeladen.',
		'has uploaded the parent/guardian consent form.':
			'hat die Einverständniserklärung der Eltern bzw. Erziehungsberechtigten hochgeladen.',
		'has submitted the company for verification and activation by JA Austria.':
			'hat das Unternehmen zur Überprüfung und Aktivierung durch JA Austria eingereicht.',
		'The parental/guardian consent form of':
			'Die Einverständniserklärung der Eltern bzw. Erziehungsberechtigten von',
		'has been verified and confirmed.': 'wurde überprüft und bestätigt.',
		'The declaration of consent of the parents or legal guardians of':
			'Die Einverständniserklärung der Eltern bzw. Erziehungsberechtigten  von',
		'was rejected.': 'wurde abgewiesen.',
		'Congratulations! Your company has been successfully verified by JA Austria. For the legitimation of your business, we have issued a company register extract':
			'Gratulation! Euer Unternehmen wurde erfolgreich durch JA Austria überprüft. Für die Freischaltung eurer Geschäfte haben wir ein Firmenbuchauszug',
		'for you. For the sale of your company shares, the signed warrants':
			'für euch ausgestellt. Für den Verkauf eurer Unternehmensanteile müssen die unterzeichneten Optionsscheine',
		'must be uploaded up to a max. amount of': 'bis zu einer max. Summe von',
		'in the Share section.': 'im Bereich Anteil hochgeladen werden.',
		'Do not forget to prepare your financial report by':
			'Vergesst nicht, euren Finanzbericht rechtzeitig zu erstellen.',
		'Your company has been reviewed by JA Austria and unfortunately could not be approved for business yet.':
			'Euer Unternehmen wurde durch JA Austria überprüft und konnte leider noch nicht für eine Geschäftstätigkeit freigegeben werden.',
		'Please do not forget to prepare your financial report by deadline.':
			'Bitte vergisst nicht auf euren Finanzbericht, der bis deadline zu erstellen ist.',
		'Congratulations, your financial report has arrived at JA Austria! On the basis of your data, a compilation of the levies has been prepared, which you can find in the "Documents" section. An open invoice':
			'Gratulation, euer Finanzbericht ist bei JA Austria eingelangt! Auf Basis eurer Angaben wurde eine Zusammenstellung der Abgaben erstellt, Ihr findet diese im Bereich "Unterlagen". Eine offene Rechnung',
		'must be paid by bank transfer within': 'ist innerhalb von',
		'days.': 'mittels Überweisung zu begleichen.',
		'Attention. Your financial report has been put on hold after submission and needs to be resubmitted after revision.':
			'Achtung! Euer Finanzbericht wurde nach der Einreichung zurückgestellt und muss  nach einer Überarbeitung neu eingereicht werden.',
		Congratulations: 'Gratulation',
		'You have successfully completed the JA Austria programme. You can find your certificate in the "Documents" section':
			'Du hast das JA Austria Programm erfolgreich abgeschlossen. Sie finden Ihr Teilnahmezertifikat im Bereich "Dokumente" oder hier',
		'You can find your certificate in the "Documents" section':
			'Du findest dein Teilnahmezertifikat im Bereich „Dokumente" oder hier',
		'Consent of parent or guardian': 'Einverständnis Erziehungsberechtigte(r)',
		'is a required field': 'erforderlich',
		'is must be less than 10000 characters': ' muss kleiner oder gleich 10000 sein',
		'is must be greater than 200 characters': ' muss größer oder gleich 200 sein',
		'Total fin. result': 'Gesamtergebnis',
		'Wage and Salary contributions': 'Lohn- und Gehaltsabgaben',
		'Salary-dependent contributions (employee share)': 'Gehaltsabhängige Abgaben (Dienstnehmeranteil)',
		'Salary-related contributions (employer`s contribution)': 'Gehaltsabhängige Abgaben (Arbeitgeberanteil)',
		'Show Reports': 'Berichte anzeigen',
		'Option warrant': 'Optionsschein',
		'Course participation certificate': 'Teilnahmebestätigung Skills4Retail',
		'Certificate of completion': 'Abschlusszertifikat',
		'Shareholder certificate template': 'Anteilschein-Vorlage',
		'link to submission': 'link zur Vorlage',
		'link to invoice': 'Link zur Rechnung',
		'link to certificate of participation': 'Link zum Teilnahmezertifikat',
		'to the business report': 'zum Geschäftsbericht',
		'to the certificate': 'zur Urkunde',
		'to the reports': 'zu den Berichten',
		'Welcome !': 'Willkommen!',
		'Here you will find information about upcoming tasks around your company as well as hints about interesting offers and events of our partners.':
			'Du erhältst hier Informationen über anstehende Aufgaben rund um Euer Unternehmen als auch Hinweise auf interessante Angebote und Veranstaltungen unserer Partner.',
		'First enter all relevant information about your company, add further employees, supervising teachers and company experts. Optionally, you can also add a business plan. Do not forget to upload the signed consent of a parent or guardian in your user profile.':
			'Erfasse zunächst alle relevanten Informationen zu Eurem Unternehmen, füge weitere Mitarbeiter:innen, betreuende Lehrer:innen und  Wirtschaftsexpert:innen hinzu. Optional kann auch ein Businessplan beigefügt werden. Vergiss auf keinen Fall die unterzeichnete Einverständnis einer erziehungsberechtigten Person in deinem Benutzerprofil hochzuladen.',
		'Before your company starts business, it must be submitted to JA Austria for verification and activation. After activation you can offer your products, services and shares in your company on the market - for the legitimisation of these activities you will receive a company register extract and the template for issuing warrants.':
			'Bevor Euer Unternehmen die Geschäftstätigkeit aufnimmt muss es zur Überprüfung und Aktivierung an JA Austria eingereicht werden. Nach der Aktivierung könnt Ihr Eure Produkte, Dienstleistungen und Anteile an Eurem Unternehmen am Markt anbieten - für die Legitimation dieser Aktivitäten erhält Ihr dafür einen Firmenbuchauszug und die Vorlage für die Ausstellung von Optionsscheinen.',
		'The financial report provides you with information on the necessary taxes that are usually incurred in the course of business activities.':
			'Der Finanzbericht gibt euch Orientierung über notwendige Abgaben, welche üblicherweise im Rahmen einer Geschäftstätigkeit anfallen.',
		'Good luck for your company': 'Viel Erfolg für Euer Unternehmen',
		Request: 'Anfrage',
		'Open a modal window and confirm or reject the request.':
			'Öffne ein modales Fenster und bestätige oder lehne die Anfrage ab.',
		'Further support teachers': 'Weitere Betreuungslehrkräfte',
		'Final Report uploaded successfully': 'Geschäftsbericht erfolgreich hochgeladen!',
		'Business Plan uploaded successfully': 'Businessplan erfolgreich hochgeladen!',
		'Business Plan removed successfully': 'Geschäftsplan erfolgreich entfernt',
		'Please log out and wait until you are invited by a member of an existing company. After being invited and logging in again, you will be immediately assigned to your joint company as an employee.':
			'Bitte logge dich aus und warte bis du von einem Mitglied eines bestehenden Unternehmens eingeladen wirst. Nach der Einladung und dem erneuten Login wirst du eurem gemeinsamen Unternehmen als Mitarbeiter:in gleich zugewiesen.',
		Direktor: 'Geschäftsführung',
		"Don't forget to submit your company for approval (button in dashboard area)":
			'Vergiss nicht dein Unternehmen zur Genehmigung einzureichen (Button im Dashboard Bereich)',
		'is waiting for an activation check for': 'wartet',
		'days!': 'Tage auf einen Aktivierungscheck',
		'Company activation page.': 'Aktivierungsseite des Unternehmens.',
		Reminder: 'Erinnerung',
		'Business Report': 'Geschäftsbericht',
		'Your business report has been successfully uploaded.': 'Ihr Geschäftsbericht wurde erfolgreich hochgeladen.',
		'Upload Final Report': 'Geschäftsbericht hochladen',
		'Download Final Report': 'Geschäftsbericht herunterladen',
		'Download Business Plan': 'Businessplan herunterladen',
		'Shareholder Share for Junior': 'Aktionärsanteile Junior',
		'Shareholder Share for Junior Compact': 'Aktionärsanteile Compact',
		'Shareholder Share for Junior Basic': 'Aktionärsanteile Basic',
		'Junior Annual report deadline': 'Junior Jahresbericht',
		'Junior Semiannual report deadline': 'Junior Halbjahresbericht',
		'Junior Compact report deadline': 'Junior Compact Bericht',
		'Junior Basic report deadline': 'Junior Basic Bericht',
		'The open invoice from for was paid incompletely. Your company account has a balance of. Please transfer the difference to the account details provided.':
			'Die offene Rechnung vom {{val1}} über {{val2}} wurde unvollständig bezahlt. Euer Unternehmenskonto weist ein Saldo von {{val3}} auf. Bitte überweist die Differenz an die angegebene Kontoverbindung.',
		'New employee invited': 'Neue(r) Mitarbeiter:in eingeladen',
		'has invited to work in the company.': '{{val1}} hat {{val2}} zur Mitarbeit im Unternehmen eingeladen.',
		'has invited the teacher to the enterprise.': '{{val1}} hat die Lehrkraft {{val2}} zum Unternehmen eingeladen.',
		'Teacher invited': 'Lehrkraft eingeladen',
		'has registered as a company expert.': '{{val1}} hat {{val2}} als Wirtschaftsexpert:in eingetragen.',
		'Economic expert added': 'Wirtschaftsexperte hinzugefügt',
		'Business expert agrees with the GDPR.':
			'Wirtschaftsexpert:in {{val1}} ist mit der Verarbeitung der personenbezogenen Daten gemäß DSGVO einverstanden.',
		'Economic expert confirmed': 'Wirtschaftsexperte bestätigt',
		'Market- & Riskanalysis': 'Markt- und Risikoanalyse',
		'Parent/guardian consent': 'Einverständniserklärung',
		'Company under verfication': 'Unternehmen wird geprüft',
		'The parental/guardian consent form of has been verified and confirmed.':
			'Die Einverständniserklärung der Eltern bzw. Erziehungsberechtigten von {{val1}} wurde überprüft und bestätigt.',
		'Consent confirmed': 'Einverständniserklärung bestätigt',
		'Consent rejected': 'Einverständniserklärung abgewiesen',
		'The declaration of consent of the parents or legal guardians of was rejected.':
			'Die Einverständniserklärung der Eltern bzw. Erziehungsberechtigten  von {{val1}} wurde abgewiesen.',
		'has uploaded the course certificate.': 'hat den Kursnachweis hochgeladen.',
		'Course certificate confirmed': 'Kursnachweis bestätigt',
		'The course certificate of has been verified and confirmed.':
			'Der Kursnachweis von {{val1}} wurde überprüft und bestätigt.',
		'Course certificate rejected': 'Kursnachweis abgewiesen',
		'The course certificate of was rejected.': 'Der Kursnachweis von {{val1}} wurde abgewiesen.',
		'Company verified': 'Unternehmen geprüft',
		'Company not approved': 'Unternehmen nicht freigegeben',
		'Financial report reminder': 'Erinnerung Finanzbericht',
		'Financial report rejected': 'Finanzbericht zurückgewiesen',
		'The open invoice from for has been paid.': 'Die offene Rechnung vom {{val1}} über  {{val2}} wurde bezahlt.',
		'Participation certificate': 'Teilnahmeurkunde ausgestellt',
		'Invoice amount paid incompletely': 'Rechnungsbetrag unvollständig bezahlt',
		'Invoice generated': 'Rechnung erstellt',
		'Here you will find information about activities of the companies you support as well as information about interesting offers and events of our partners.':
			'Hier erhalten Sie Informationen über Aktivitäten der von Ihnen betreuten Junior Unternehmen als auch Hinweise auf interessante Angebote und Veranstaltungen unserer Partner.',
		'The JA Austria company has added you as a supervising teacher. You can now follow the details of the assigned companies in the "Companies" section and also have access to their documents such as business plan, shareholder certificates, financial reports and annual report.':
			'Das Junior Unternehmen {{val1}} hat Sie als betreuende Lehrkraft hinzugefügt. Sie können nun die Details der zugeordneten Unternehmen im Bereich "Unternehmen" mitverfolgen und haben außerdem die Einsicht in deren Dokumente wie z.B. Businessplan, Anteilsscheine, Finanzberichte und Geschäftsbericht.',
		'New company': 'Neues Unternehmen',
		'Report submitted': 'Bericht eingereicht',
		'Your report has been submitted successfully':
			'Euer {{val1}} wurde erfolgreich eingereicht und kann jetzt nicht mehr geändert werden.',
		'The company you supervise has filed. You can find the report here':
			'Das von Ihnen betreute Junior Unternehmen {{val1}} hat {{val2}} eingereicht. Den Bericht finden Sie hier',
		'Congratulations! Your company has submitted its financial report and thus successfully completed the JA Austria Programme. For the students involved in the company we have deposited completion certificates in the "Documents" section - the students can download them independently. You can find the business report here ':
			'Gratulation! Das von Ihnen betreute Junior Unternehmen {{val1}} hat den Geschäftsbericht eingereicht und damit erfolgreich das JA Austria Programm abgeschlossen. Für die beteiligten Schüler:innen am Unternehmen haben wir im Bereich "Dokumente" Abschlussurkunden hinterlegt - die Schüler:innen können diese selbständig herunterladen. Den Geschäftsbericht finden Sie hier ',
		'We would also like to thank you very much for your support of the JA Austria programme with a certificate':
			'Wir möchten uns ebenfalls bei Ihnen mit einer Urkunde für Ihre Betreuung des JA Austria Programmes ganz herzlich bedanken ',
		Author: 'Autor',
		Expired: 'Abgelaufen',
		'Valid for {{days}} more days': 'Noch {{days}} Tage gültig',
		'Financial report submitted & certificates have been issued':
			'Geschäftsbericht eingereicht & Urkunden wurden ausgestellt',
		'Attention the following JA Austria companies you are in charge of have not yet submitted their report in our system and therefore cannot successfully complete the programme. Company: ':
			'Achtung folgende Junior Unternehmen, die von Ihnen betreut werden haben ihren Bericht in unserem System noch nicht eingereicht und können somit das Programm nicht erfolgreich abschließen. Unternehmen: ',
		'Congratulations! The company you are in charge of has been checked by JA Austria and activated for further business activities. The students have received an extract from the company register and can now sell shares in the company up to a total value of EUR . The following date(s) have been set for report submission':
			'Gratulation! Das von Ihnen betreute Junior Unternehmen {{val1}} wurde seitens JA Austria geprüft und für die weiteren geschäftlichen Tätigkeiten aktiviert. Die Schüler:innen haben einen Firmenbuchauszug erhalten und können nun auch Unternehmensanteile bis zu einem Gesamtwert von EUR {{val2}} verkaufen. Für Berichtsabgabe wurde(n) folgende(n) Termin(e) festgelegt:',
		'Invoice paid': 'Rechnung bezahlt',
		'Anonimize and clear db': 'Anonymisieren und Löschen der Datenbank',
		'download anonimized database': 'Anonymisierte Daten herunterladen',
		'Clear Database': 'Datenbank löschen',
		From: 'Ab',
		To: 'Bis',
		Target: 'Zielgruppe',
		'Work Area': 'Funktion',
		'Rep.Type': 'Bericht',
		'Semi-annual Invoice': 'Halbjahresrechnung',
		'Annual Invoice': 'Jahresrechnung',
		'Semi-annual Report': 'Halbjahresbericht',
		'Annual Report': 'Jahresbericht',
		'Social Media': 'Soziale Medien',
		'Website & Social Media': 'Website & Social Media',
		Branches: 'Branchen',
		Planned: 'Geplant',
		Draft: 'Entwurf',
		'Set to draft': 'Auf Entwurf setzen',
		'Activate message': 'Aktivieren',
		'The message is now active.': 'Die Nachricht ist jetzt aktiv.',
		'The message was set to draft.': 'Die Nachricht ist jetzt ein Entwurf.',
		'Pin message': 'Oben anheften',
		'Unpin message': 'Anheftung lösen',
		'Pinned to top': 'Oben angeheftet',
		Pinned: 'angeheftet',
		'Not pinned': 'nicht angeheftet',
		'The message is now pinned to the top.': 'Die Nachricht steht jetzt ganz oben.',
		'The message is no longer pinned.': 'Die Anheftung ist gelöst.',
		'Active — visible during the display period': 'Aktiv — im Anzeigezeitraum sichtbar',
		'Draft — visible to the administration only': 'Entwurf — nur für die Verwaltung sichtbar',
		'Draft or active? A draft stays hidden from students and teachers until it is activated.':
			'Entwurf oder aktiv? Ein Entwurf bleibt für Schüler:innen und Lehrer:innen verborgen, bis er aktiviert wird.',
		'Delete employee': 'Mitarbeiter löschen',
		'Delete Invite': 'Einladung löschen',
		C: 'Ü',
		'A teacher from': 'Eine Lehrkraft aus',
		'is interested in your company. Please add': 'ist an eurem Unternehmen interessiert. Bitte füge',
		'to your company in the company profile section.':
			'im Bereich "Unternehmensprofil" zu Eurem Unternehmen hinzu.',
		'Request from a teacher': 'Anfrage einer Lehrkraft',
		'Ready for submission': 'Bereit zur Einreichung',
		'Congratulations you have everything complete. Your company can now be submitted to JA Austria for review.':
			'Gratulation, eure Daten sind nun vollständig. Euer Unternehmen kann nun zur Überprüfung an JA Austria eingereicht werden.',
		'Company submitted for verification and activation.':
			'Unternehmen zur Verifizierung und Aktivierung eingereicht.',
		'Final Report': 'Geschäftsbericht',
		'Please upload your final report via the upload function in the dashboard. Afterwards you will find your participation certificates for the successful completion of the JA Austria programme in the document section.':
			'Bitte ladet noch Euer Geschäftsbericht über die Uploadfunktion im Dashboard hoch. Im Anschluss findet ihr Eure Teilnahmeurkunden für den erfolgreichen Abschluss des JA Austria Programms im Dokumentenbereich.',
		Accept: 'Akzeptieren',
		'Open profile': 'Profil öffnen',
		'Are you sure you wish to delete the economic expert ?':
			'Möchten Sie den Wirtschaftsexperten wirklich löschen?',
		'Are you sure?': 'Sind Sie sicher?',
		'You will not be able to revert this!': 'Der Löschvorgang kann nicht rückgängig gemacht werden.',
		'Yes, delete it!': 'Ja, löschen Sie es!',
		'Type {{word}} to confirm': 'Geben Sie zur Bestätigung „{{word}}" ein:',
		'Input does not match': 'Eingabe stimmt nicht überein',
		'You have new news - click to look details': 'Sie haben neue Neuigkeiten - klicken Sie, um Details anzuzeigen',
		P: 'T',
		and: 'und',
		others: 'andere',
		'read more': 'weiter lesen',
		'Are you sure you want to remove this expert?': 'Are you sure you want to remove this expert({{fullName}})?',
		NEWS: 'Neuigkeit',
		EVENT: 'Veranstaltung',
		'This field must be over 0': 'Dieses Feld muss über 0 sein',
		'Resend request': 'Anfrage wiederausschicken',
		Delete: 'Löschen',
		'Delete the company': 'lösche das Unternehmen',
		'The company successfully deleted': 'Das Unternehmen wurde erfolgreich gelöscht',
		'Upload logo & product images': 'Logo hochladen',
		'Function & working area': 'Funktion und Arbeitsbereich',
		'The company must not be leaderless!': 'Das Unternehmen darf nicht führungslos sein!',
		'First assign your CEO function to another person!':
			'Weise zuerst deine Geschäftsführungs-Funktion (CEO) einer anderen Person zu!',
		'CEO / Managing Director': 'CEO / Geschäftsführung',
		'Add link': 'Link hinzufügen',
		'CEO role can be transferred in the view "Employees" via the 3-point menu':
			'CEO Rolle kann in der Ansicht "Mitarbeiter:innen" über das 3-Punkte Menü übertragen werden',
		'Edit function & working area': 'Funktion und Arbeitsbereich bearbeiten',
		public: 'veröffentlicht',
		private: 'nicht veröffentlicht',
		Explanation: 'Begründung',
		Approved: 'Genehmigt',
		Approval: 'Genehmigung',
		'Approval not possible yet!': 'Genehmigung noch nicht möglich!',
		Requirements: 'Voraussetzungen',
		'Complete company profile & risk analysis': 'Vollständiges Unternehmensprofil & Risikoanalyse',
		'At least 1 business expert': 'Mind. 1 Wirtschaftsexperte/-in',
		'Parental consent from all employees': 'Einverständniserklärung für alle Mitarbeitenden',
		'Not verified': 'Nicht verifiziert',
		Show: 'Anzeigen',
		'Wait for confirmation new employee': 'Warten auf die Einladungsbestätigung des neuen Mitarbeiters',
		'The CEO role must always be assigned to one person. It can be assigned to another person via the 3-point menu in the "Employees" view. CEO name is shown on the company register extract.':
			'Die CEO-Rolle muss stets einer Person zugewiesen sein. Über das 3-Punkte-Menü in der "Mitarbeiter:innen"-Ansicht kann sie einer anderen Person zugeteilt werden. CEO Name wird auf dem Firmenbuchauszug ausgewiesen.',
		'Administrator comment about Company': 'Kommentar des Administrators zum Unternehmen',
		'Type social media title': 'Titel für soziale Medien eingeben',
		'Final report removed successfully': 'Abschlussbericht erfolgreich entfernt',
		'Business report': 'Geschäftsbericht',
		'You can change the logo on the "Company Profile" page':
			'Sie können das Logo auf der Seite "Unternehmensprofil" ändern',
		'Every employee must have a function & working area':
			'Jeder Mitarbeiter muss ein/e Arbeitsbereich/Funktion haben',
		'Switch to student view': 'In die Schüler:innen Ansicht wechseln',
		'view mode as Student': 'Ansichtsmodus als Schüler:in',
		// Ansichtsmodus der Verwaltung als Lehrkraft (02.11.2026) und die
		// Erklärzeilen im Reiter „Handlungen" des Benutzer:innenprofils.
		'view mode as Teacher': 'Ansichtsmodus als Lehrkraft',
		viewModeBannerTeacher: 'Sie sehen die Plattform derzeit als Lehrkraft {{name}} – nur lesend',
		'Exit view mode': 'Ansicht verlassen',
		'Mark parental consent as reviewed': 'Elternbestätigung als geprüft bestätigen',
		actionHintViewMode: 'Die Plattform so sehen, wie diese Person sie sieht – nur lesend, ohne etwas zu ändern.',
		actionHintDownloadParental: 'Das hochgeladene Dokument als Datei speichern.',
		actionHintParentalMissing: 'Noch nicht hochgeladen.',
		actionHintReviewParental: 'Nach der Durchsicht bestätigen – erst dann zählt sie in der Checkliste.',
		actionHintParentalReviewed: 'Bereits geprüft und bestätigt.',
		actionHintMergeTeacher: 'Doppeltes Konto auflösen: Dieses Konto geht in einem anderen auf, betreute Junior Companies wandern mit.',
		actionHintVerifyTeacher: 'Konto als echte Lehrkraft freischalten.',
		actionHintTeacherVerified: 'Bereits bestätigt.',
		actionHintDeleteAccount: 'Endgültig – lässt sich nicht rückgängig machen.',
		years: 'Jahre',
		'A working area has to be selected. Please assign for a working area':
			'Es muss ein Hauptaufgabenbereich ausgewählt sein. Bitte weisen Sie einen Hauptaufgabenbereich zu',
		'Gross salaries may not be EUR 0 in both semesters':
			'Bruttogehälter dürfen nicht in beiden Semestern EUR 0,- betragen.',
		'Remove employee.': 'Mitarbeiter:in entfernen.',
		'No working area': 'Kein Arbeitsbereich',
		'The company must consist of at least two employees':
			'Das Unternehmen muss aus mindestens zwei Mitarbeitern bestehen',
		"You are currently in a student's view": 'Sie befinden sich derzeit in der Schüler:innen Ansicht',
		'Test environment': 'Testumgebung',
		'Collective mailbox (MailHog)': 'Sammel-Postfach (MailHog)',
		'This platform does not use cookies or tracking services. Only technically necessary data (login, language selection) is stored locally in your browser.':
			'Diese Plattform verwendet keine Cookies und keine Tracking-Dienste. Es werden nur technisch notwendige Daten (Anmeldung, Sprachwahl) lokal in Ihrem Browser gespeichert.',
		'Privacy notice': 'Datenschutzhinweis',
		'Got it': 'Verstanden',
		'Required field': 'Pflichtfeld',
		'Invalid email': 'Ungültige E-Mail-Adresse',
		Done: 'Fertig',
		inviteExpertSentTo: 'Die Einladung an {{name}} ({{email}}) ist verschickt.',
		expertInviteResent: 'Einladung erneut verschickt',
		inviteExpertAlreadyInvited:
			'{{name}} war von euch schon am {{date}} eingeladen und hat die Einladung noch nicht angenommen. Wir haben sie mit einem neuen Link noch einmal verschickt — der alte Link gilt nicht mehr.',
		pendingInvitationsTitle: 'Offene Einladungen',
		pendingInvitationsHint:
			'Diese Personen habt ihr eingeladen; sie haben die Einladung noch nicht angenommen. Sobald sie ihr Profil aktivieren, stehen sie unter „Unsere Expert:innen“.',
		pendingInvitationSent: 'eingeladen am {{date}}',
		pendingInvitationSentBy: 'eingeladen am {{date}} von {{name}}',
		pendingInvitationValidUntil: 'Link gültig bis {{date}}',
		pendingInvitationExpired: 'Link abgelaufen – bitte erneut senden',
		pendingInvitationResend: 'Erneut senden',
		pendingInvitationResent: 'Die Einladung an {{name}} ist erneut verschickt.',
		pendingInvitationWithdraw: 'Zurückziehen',
		pendingInvitationWithdrawTitle: 'Einladung zurückziehen?',
		pendingInvitationWithdrawText:
			'Die Einladung an {{name}} ({{email}}) wird gelöscht. Der Link in der verschickten E-Mail funktioniert danach nicht mehr.',
		pendingInvitationWithdrawn: 'Die Einladung ist zurückgezogen.',
		inviteExpertNotSent:
			'Die Einladung an {{name}} ist angelegt, die E-Mail konnte aber nicht verschickt werden. Bitte geben Sie den Link selbst weiter.',
		inviteShareTitle: 'Einladungslink selbst weitergeben',
		inviteShareHint:
			'Die Einladung kommt von Junior Achievement und landet manchmal im Spam. Schicken Sie den Link zusätzlich selbst – von Ihrer eigenen Adresse oder per Messenger kommt er sicher an.',
		inviteShareCopy: 'Link kopieren',
		inviteShareCopied: 'Kopiert',
		inviteShareMail: 'Im eigenen E-Mail-Programm öffnen',
		inviteShareSubject: 'Einladung: Unterstützer:in bei Junior Achievement',
		inviteShareSubjectCompany: 'Einladung der Junior Company „{{company}}“',
		inviteShareGreeting: 'Hallo {{name}},',
		inviteShareGreetingPlain: 'Hallo,',
		inviteShareBody:
			'wie besprochen hier der Link, mit dem Sie Ihr Profil als Unterstützer:in bei Junior Achievement anlegen:',
		inviteShareBodyCompany:
			'unsere Junior Company „{{company}}“ würde sich freuen, wenn Sie uns als Wirtschaftsexpert:in unterstützen. Über diesen Link legen Sie Ihr Profil an:',
		inviteShareBodyValidity:
			'Der Link gilt {{days}} Tage. Eine E-Mail von Junior Achievement mit demselben Link ist ebenfalls unterwegs – falls Sie sie nicht finden, sehen Sie bitte im Spam-Ordner nach.',
		inviteShareClosing: 'Viele Grüße\n{{name}}',
		inviteShareClosingPlain: 'Viele Grüße',
		invitedOnColumn: 'Eingeladen am',
		invitationExpiredShort: 'abgelaufen',
		invitationDayLeft: 'noch {{count}} Tag',
		invitationDaysLeft: 'noch {{count}} Tage',
		invitationRemindedTimes: '{{count}}× erinnert',
		invitationReminders: 'Erinnerungen',
		invitationRemindersNone: 'noch keine',
		invitationRemindersCount: '{{count}}×, zuletzt am {{date}}',
		supporterInvitationExpired:
			'Diese Einladung ist abgelaufen. Bitte wenden Sie sich an die Person, die Sie eingeladen hat, oder an Junior Achievement: Die Einladung lässt sich jederzeit neu verschicken.',
		'This invitation link is invalid or has already been used':
			'Dieser Einladungslink ist ungültig oder wurde bereits verwendet',
		Imprint: 'Impressum',
		'Privacy policy': 'Datenschutzerklärung',
		'Terms of use': 'Nutzungsbedingungen',
		Accessibility: 'Barrierefreiheit',
		'Legal information': 'Rechtliches',
		'Back to home page': 'Zurück zur Startseite',
		'The Junior Companies of Junior Achievement Austria': 'Die Schülerfirmen von Junior Achievement Austria',
		'Please note the URL syntax e.g. https://www.junior.cc':
			'Bitte beachten Sie die URL-Syntax, z.B. https://www.junior.cc',
		'The invitation to join the company has been revoked. Begin your registration in the system without the invitation link to create your own company.':
			' Die Einladung, der Company beizutreten, wurde rückgängig gemacht. Starten Sie Ihre Registrierung im System ohne den Einladungslink, um eine eigene Company anzulegen.',
		Export: 'Exportieren',
		'Download report': 'Bericht herunterladen',
		invoice: 'Rechnung',
		'We have created an': 'Auf Basis eures Berichts haben wir eine',
		'based on your report. Please pay it by': 'erstellt. Bitte begleicht diese bis zum',
		'based on your report.': 'erstellt.',
		'You can find the invoice in the': 'Die Rechnung findet ihr im Bereich',
		// Erinnerung an den Finanzbericht. Bewusst je ein eigener Schlüssel statt
		// i18next-Pluralformen: Diese Fassung (i18next 20) kennt noch die alte
		// Schreibweise mit "_plural", nicht "_one"/"_other".
		'The financial report is overdue by one day.': 'Euer Finanzbericht ist seit einem Tag überfällig.',
		'The financial report is overdue by several days.': 'Euer Finanzbericht ist seit {{days}} Tagen überfällig.',
		'The financial report is due tomorrow.': 'Euer Finanzbericht ist morgen fällig.',
		'The financial report is due in several days.': 'Euer Finanzbericht ist in {{days}} Tagen fällig.',
		'The financial report is due today.': 'Euer Finanzbericht ist heute fällig.',
		'Please do not forget to submit your financial report.':
			'Bitte vergesst nicht die rechtzeitige Abgabe eures Finanzberichts.',
		'Half-year report': 'Halbjahresbericht',
		'annual report': 'Jahresbericht',
		'Select the status of companies to be displayed': 'Wählen Sie den Status der anzuzeigenden Unternehmen',
		'Company Presentation Status': 'Unternehmenspräsentation Status',
		Content: 'Inhalt',
		Stateadmin: 'Landesadmin',
		Federaladmin: 'Bundesadmin',
		ADMINISTRATOR: 'Landesadmin',
		FEDERAL_ADMINISTRATOR: 'Bundesadmin',
		'Manage State Admins': 'Verwaltung Landesadmins',
		'Manage Federal Admins': 'Verwaltung Bundesadmins',
		'Manage Database Reset': 'Verwaltung Datenbank Reset',
		'Admin roles': 'Rolle',
		'Select admin role': 'Rolle auswählen',
		'State admin for one federal state, federal admin Austria-wide.':
			'Landesadmin für ein Bundesland, Bundesadmin österreichweit.',
		'Edit administrator': 'Administrator bearbeiten',
		'Role and additional functions': 'Rolle und Zusatzfunktionen',
		Person: 'Person',
		'Role and rights': 'Rolle & Rechte',
		Responsibility: 'Zuständigkeit',
		'A state admin looks after one federal state and sees only its data.':
			'Ein Landesadmin betreut ein Bundesland und sieht nur dessen Daten.',
		'A federal admin works Austria-wide and can additionally be given the functions below.':
			'Ein Bundesadmin arbeitet österreichweit und kann zusätzlich die untenstehenden Funktionen bekommen.',
		'Responsible Austria-wide — no federal state.': 'Österreichweit zuständig — kein Bundesland.',
		'Additional functions only exist for federal admins. Without a tick the person sees the administration, but changes nothing there.':
			'Zusatzfunktionen gibt es nur für Bundesadmins. Ohne Häkchen sieht die Person die Administration, ändert dort aber nichts.',
		'May create, edit and delete state admins.': 'Darf Landesadmins anlegen, bearbeiten und löschen.',
		'May create, edit and delete federal admins — and may choose the role when creating an administrator.':
			'Darf Bundesadmins anlegen, bearbeiten und löschen — und beim Anlegen die Rolle wählen.',
		'Unlocks the school year reset under Settings › System: the data is exported and cleared. Teachers, administrators, supporters, school master data and all settings are kept.':
			'Schaltet den Schuljahres-Reset unter Einstellungen › System frei: Der Datenbestand wird als Datei ausgegeben und geleert. Lehrkräfte, Admins, Unterstützer:innen, Schulstammdaten und sämtliche Einstellungen bleiben erhalten.',
		'Administrators at a glance': 'Administratoren auf einen Blick',
		'By role': 'Nach Rolle',
		'By state': 'Nach Bundesland',
		'Without federal state': 'Ohne Bundesland',
		'Last sign-in': 'Letzte Anmeldung',
		'Signed in within {{days}} days': 'Anmeldung in den letzten {{days}} Tagen',
		'Last sign-in has been recorded since 06.08.2026 — earlier sign-ins are unknown.':
			'Die letzte Anmeldung wird seit 06.08.2026 aufgezeichnet — frühere Anmeldungen sind nicht bekannt.',
		'Filter the list by {{label}}': 'Liste nach {{label}} filtern',
		'Filtered by': 'Gefiltert nach',
		'Remove the filter {{label}}': 'Filter {{label}} entfernen',
		'{{shown}} of {{all}} administrators': '{{shown}} von {{all}} Administratoren',
		'No administrator matches this filter.': 'Kein Administrator entspricht diesem Filter.',
		'Accounts without a sign-in since then: {{amount}}': 'Zugänge ohne Anmeldung seitdem: {{amount}}',
		Verify_company_email_btn: 'E-Mail verifizieren',
		Verify_company_email_sending_successfully: 'Bestätigungs-E-Mail versendet',
		Verify_company_email_sent_to:
			'Bestätigungs-E-Mail an {{email}} versendet. Bitte auch im Spam-Ordner nachsehen – der Link gilt eine Stunde.',
		"This icon means that the company's email verification has not yet been completed.":
			'Dieses Symbol bedeutet, dass die E-Mail-Verifizierung des Unternehmens noch nicht abgeschlossen ist.',
		// Seite hinter dem Knopf aus der Bestaetigungsmail (pages/CompanyEmailVerifyPage)
		'Confirming email address …': 'E-Mail-Adresse wird bestätigt …',
		'Email address confirmed': 'E-Mail-Adresse bestätigt',
		'Email address could not be confirmed': 'E-Mail-Adresse konnte nicht bestätigt werden',
		'The company email address is now confirmed. This is one of the requirements for submitting your company for approval.':
			'Die Firmen-E-Mail-Adresse ist jetzt bestätigt. Das ist eine der Voraussetzungen für die Einreichung des Unternehmens zur Genehmigung.',
		'This email address was already confirmed. Nothing else to do.':
			'Diese E-Mail-Adresse war bereits bestätigt. Es ist nichts weiter zu tun.',
		'The company email address has been confirmed.': 'Die Firmen-E-Mail-Adresse wurde bestätigt.',
		'You will be forwarded in a moment …': 'Weiterleitung in wenigen Sekunden …',
		'To the dashboard': 'Zum Dashboard',
		'The confirmation link is incomplete. Please open it again from the email.':
			'Der Bestätigungslink ist unvollständig. Bitte den Link noch einmal in der E-Mail öffnen.',
		'This confirmation link has expired or is invalid. A new confirmation email can be requested in the company profile.':
			'Der Bestätigungslink ist abgelaufen oder ungültig. Im Unternehmensprofil lässt sich eine neue Bestätigungs-E-Mail anfordern.',
		'There is no Junior Company for this email address. Has the address been changed in the meantime?':
			'Zu dieser E-Mail-Adresse gibt es keine Junior Company. Wurde die Adresse zwischenzeitlich geändert?',
		'The email address could not be confirmed. Please try again later.':
			'Die E-Mail-Adresse konnte nicht bestätigt werden. Bitte später noch einmal versuchen.',
		verifyingCompany: 'Bestätigung der Firmen-E-Mail',
		'Update Email': 'E-Mail aktualisieren',
		'Mail successfully changed': 'E-Mail erfolgreich geändert',
		'No company with such an old email was found':
			'Es wurde kein Unternehmen mit einer so alten E-Mail-Adresse gefunden',
		day: 'Tag',
		month: 'Monat',
		year: 'Jahr',
		dd: 'TT',
		mm: 'MM',
		yyyy: 'JJJJ',
		'Name successfully changed': 'Firmenname erfolgreich geändert',
		'No company with such an old name was found': 'Es wurde kein Unternehmen mit einem so alten Namen gefunden.',
		'Verify your company email address': 'Bestätigen Sie Ihre Firmen-E-Mail-Adresse',
		'Checklist for approval': 'Checkliste für die Genehmigung',
		'Company profile & risk analysis completed': 'Unternehmensprofil & Risikoanalyse ausgefüllt',
		'Minimum of 2 employees in the team': 'Mindestens 2 Mitarbeiter:innen im Team',
		'Min. 1 business expert assigned': 'Mind. 1 Wirtschaftsexpert:in zugewiesen',
		'Parental/guardian consent form uploaded and checked':
			'Einverständniserklärung Elternteil / Erziehungsberechtigte(r) hochgeladen und geprüft',
		'No employees remaining on the waiting list': 'Keine Mitarbeiter:innen mehr auf der Warteliste',
		'A function assigned to all employees': 'Allen Mitarbeiter:innen eine Funktion zugewiesen',
		'Company email address verified': 'E-Mail-Adresse der Firma verifiziert',
		'The company profile and risk analysis must be fully completed':
			'Das Unternehmensprofil und die Risikoanalyse müssen vollständig ausgefüllt werden',
		'Your company requires a minimum of two registered student employees':
			'Ihr Unternehmen benötigt mindestens zwei registrierte Schüler:innen als Mitarbeiter:innen',
		'An external business expert must be assigned to your team':
			'Ihrem Team muss ein externer Wirtschaftsexperte zugewiesen werden',
		'All signed parental consent forms must be available':
			'Alle unterschriebenen Einverständniserklärungen der Eltern müssen vorliegen',
		'The official email address of your student company must be confirmed':
			'Die offizielle E-Mail-Adresse Ihres Junior Unternehmens muss bestätigt werden',
		'Working area assigned': 'Allen Mitarbeiter:innen einen Arbeitsbereich zugewiesen',
		'Delete invitation': 'Einladung löschen',
		'Resend invitation': 'Einladung erneut senden',
		'Invitation resent successfully': 'Einladung wurde erneut gesendet',
		'Add work area': 'Arbeitsbereich hinzufügen',
		'Managing Director updated': 'Geschäftsführung aktualisiert',
		'Saved successfully': 'Erfolgreich gespeichert',
		'Reason for rejecting the parental confirmation': 'Begründung für die Ablehung der Elternbestätigung',
		'Reason for rejecting the course certificate': 'Begründung für die Ablehnung des Kursnachweises',
		Elternbestätigung: 'Elternbestätigung',
		Kursnachweis: 'Kursnachweis',
		'Send to student': 'Nachricht Schüler:In senden',
		'Reason for rejection to the entire team': 'Begründung für die Ablehung an das gesamte Team',
		'Send to the team': 'An das Team senden',
		Next_SignUp: 'Weiter',
		'Back to registration': 'Zurück zur Registrierung',
		Login: 'Anmelden',

		/*
		 * Fehlermeldungen. Sie werden angezeigt, wenn der Server nichts
		 * Verständliches sagt — siehe shared/errorMessage.js. Bewusst ohne
		 * Statuscode: Wer die Anwendung benutzt, kann damit nichts anfangen.
		 */
		'Something went wrong. Please try again.': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
		'No connection to the server. Please check your internet connection and try again.':
			'Keine Verbindung zum Server. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
		'The server did not respond in time. Please try again.':
			'Der Server hat nicht rechtzeitig geantwortet. Bitte versuchen Sie es erneut.',
		'Please check your entries and try again.': 'Bitte prüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
		'Your session has expired. Please sign in again.':
			'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.',
		'You do not have permission to do this.': 'Dafür fehlt Ihnen die Berechtigung.',
		'This entry no longer exists. It may have been deleted in the meantime.':
			'Dieser Eintrag ist nicht mehr vorhanden. Möglicherweise wurde er inzwischen gelöscht.',
		'This does not work because there is already an entry for it.':
			'Das geht nicht, weil es dazu bereits einen Eintrag gibt.',
		'The file is too large.': 'Die Datei ist zu groß.',
		'This file format is not supported.': 'Dieses Dateiformat wird nicht unterstützt.',
		'Too many requests in a short time. Please wait a moment and try again.':
			'Zu viele Anfragen in kurzer Zeit. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
		'Something went wrong on the server. Please try again later.':
			'Auf dem Server ist etwas schiefgelaufen. Bitte versuchen Sie es später erneut.',
		'The server cannot be reached at the moment. Please try again in a few minutes.':
			'Der Server ist gerade nicht erreichbar. Bitte versuchen Sie es in ein paar Minuten erneut.',
		'Basic Information': 'Basisinformationen',
		'Contact Details': 'Kontaktdaten',
		'Registration date': 'Anmeldedatum',
		'Submitted for review on': 'Eingereicht am',
		Logo: 'Logo',
		'No logo yet': 'Noch kein Logo hinterlegt',
		Website: 'Website',
		// Zustand einer Junior Company im Firmenprofil der Verwaltung
		Status: 'Status',
		'Company status active': 'Aktiviert',
		'Company status in review': 'Zur Prüfung eingereicht',
		'Company status not activated': 'Noch nicht aktiviert',
		// Reiter „Weg zur Expert:in": Stand dieser Junior Company
		'Connected experts': 'Verbundene Unterstützer:innen',
		'Connected experts hint':
			'Anfragen dieser Junior Company, die angenommen wurden oder noch offen sind. Angefragt wird von den Schüler:innen.',
		'Matching supporters': 'Passende Unterstützer:innen',
		'Matching experts hint':
			'Wer laut Zielgruppe zu dieser Junior Company passt (Bundesland, Branche, Schultyp) und offen für neue Anfragen ist.',
		'Own economic experts': 'Eingetragene Wirtschaftsexpert:innen',
		'Own economic experts hint':
			'Altbestand: von der Junior Company selbst eingetragen, neue Einträge sind nicht mehr möglich. Für die Aktivierung zählen auch die verbundenen Unterstützer:innen darunter.',
		// Warum hier zwei verschiedene Zahlen stehen. Ohne diesen Satz liest sich
		// „1" neben „3" wie ein Fehler.
		'Two expert registers':
			'Zwei getrennte Verzeichnisse: Oben stehen die Wirtschaftsexpert:innen, die die Junior Company selbst eingetragen hat — eigene Einträge ohne Profil im Bereich Unterstützer:innen. Darunter stehen die Unterstützer:innen aus dem Verzeichnis von Junior Achievement, mit denen die Junior Company verbunden ist. Die beiden Zahlen sind deshalb unabhängig voneinander.',
		'No connected experts yet': 'Diese Junior Company hat noch keine Unterstützer:in angefragt.',
		'Experts could not be loaded': 'Die Expert:innen konnten nicht geladen werden.',
		'More in the supporters module': 'Weitere {{rest}} stehen im Bereich',
		Complete: 'Vollständig',
		Incomplete: 'Unvollständig',
		'Still open': 'Noch offen',
		'An activated company needs at least one business expert.':
			'Diese Junior Company ist aktiviert und braucht mindestens eine:n Wirtschaftsexpert:in.',
		'This person is not part of your company.': 'Diese Person gehört nicht zu eurem Unternehmen.',
		'The company profile could not be loaded.': 'Das Unternehmensprofil konnte nicht geladen werden.',
		'Try again': 'Erneut versuchen',
		'The risk analysis could not be loaded.': 'Die Risikoanalyse konnte nicht geladen werden.',
		Invite: 'Einladen',
		List: 'Liste',
		Tiles: 'Kacheln',
		View: 'Ansicht',
		'Teacher invite hint':
			'Lehrkräfte lassen sich über die Personensuche zuweisen oder per E-Mail einladen. Für Mitarbeiter:innen und Wirtschaftsexpert:innen führt der Weg weiterhin über das Unternehmen selbst.',
		'Market and risk analysis hint': 'Die Markt- und Risikoanalyse öffnet sich in einem eigenen Fenster.',
		'No employees yet': 'Noch keine Mitarbeiter:innen',
		'No economic experts yet': 'Noch keine Wirtschaftsexpert:innen',
		'No company certificate yet': 'Noch kein Firmenbuchauszug hinterlegt',
		'Company certificate is created on activation':
			'Der Firmenbuchauszug entsteht bei der Aktivierung des Unternehmens.',
		'Final report': 'Abschlussbericht',
		'No final report yet': 'Noch kein Abschlussbericht hinterlegt',
		'Final report becomes relevant after activation':
			'Der Abschlussbericht wird erst nach der Aktivierung des Unternehmens gebraucht.',
		'Final report uploaded successfully': 'Abschlussbericht erfolgreich hochgeladen',
		'Open document': 'Öffnen',
		Replace: 'Ersetzen',
		Upload: 'Hochladen',
		'New entry': 'Neuer Eintrag',
		'Comment on this company': 'Kommentar zu diesem Unternehmen',
		'Also send to': 'Zusätzlich senden an',
		Delivery: 'Informationsübermittlung über',
		'Internal message': 'Interne Nachricht',
		'Comment stays internal': 'Bleibt in der Verwaltung sichtbar.',
		'Pick at least one channel': 'Bitte einen Weg auswählen.',
		'Entry saved': 'Eintrag gespeichert',
		'No entries yet': 'Noch keine Einträge',
		Comment: 'Kommentar',
		'Internal only': 'Nur intern',
		'Company submitted for review': 'Unternehmen zur Prüfung eingereicht',
		'Company activated': 'Unternehmen aktiviert',
		'Company rejected': 'Unternehmen nicht freigegeben',
		'Company certificate created': 'Firmenbuchauszug erstellt',
		'Company certificate regenerated': 'Firmenbuchauszug neu erzeugt',
		'Business plan uploaded': 'Businessplan hochgeladen',
		'Final report uploaded': 'Abschlussbericht hochgeladen',
		Comments: 'Kommentare',
		// Reiter mit den Handlungen zu einem Datensatz (Profilfenster).
		Actions: 'Handlungen',
		'Change history': 'Änderungsverlauf',
		'Type a comment': 'Kommentar eingeben',
		'Comments stay internal': 'Kommentare bleiben in der Verwaltung sichtbar.',
		'Comments are available once the record is saved': 'Kommentare gibt es, sobald der Datensatz gespeichert ist.',
		'School created': 'Schule angelegt',
		'School approved': 'Schule freigegeben',
		'Master data changed': 'Stammdaten geändert',
		'School merged in': 'Schule hereingeführt',
		'Profile changed': 'Profil geändert',
		'Account merged in': 'Konto hereingeführt',
		'Parental confirmation reviewed': 'Elternbestätigung geprüft',
		'Parental confirmation rejected': 'Elternbestätigung abgewiesen',
		'Course certificate reviewed': 'Kursnachweis geprüft',
		'Invoice created': 'Rechnung erstellt',
		'Partial payment recorded': 'Teilzahlung verbucht',
		'Payment reminder sent': 'Zahlungserinnerung verschickt',
		'Invoice cancelled': 'Rechnung storniert',
		'Report returned': 'Bericht zurückgewiesen',
		'Expert added': 'Expert:in angelegt',
		'Details changed': 'Angaben geändert',
		'Expert confirmed': 'Expert:in bestätigt',
		'Expert confirmation withdrawn': 'Bestätigung zurückgenommen',
		// Zusammenarbeit mit einer Expert:in, aus der Sicht der Junior Company
		'Request sent': 'Anfrage gestellt',
		'Request accepted': 'Anfrage angenommen',
		'Request declined': 'Anfrage abgelehnt',
		'Request expired without an answer': 'Anfrage ohne Antwort abgelaufen',
		'Collaboration ended by the Junior Company': 'Zusammenarbeit von der Junior Company beendet',
		'Collaboration ended by the expert': 'Zusammenarbeit von der Expert:in beendet',
		'Semiannual report submitted': 'Halbjahresbericht abgegeben',
		'Annual report submitted': 'Jahresbericht abgegeben',
		'Semiannual report returned': 'Halbjahresbericht zurückgewiesen',
		'Annual report returned': 'Jahresbericht zurückgewiesen',
		'Company name changed': 'Firmenname geändert',
		'Company email changed': 'E-Mail-Adresse geändert',
		'Message from the administration': 'Nachricht der Administration',
		'Message from the administration about {{val1}}': 'Nachricht der Administration zu {{val1}}',
		// Der Stand eines Nachweises, wenn er nur zu lesen ist (Sicht der
		// Lehrkraft im Unternehmensprofil).
		'Document reviewed': 'Geprüft',
		'Not reviewed yet': 'Noch nicht geprüft',
		'Open message history': 'Nachrichtenverlauf öffnen',
		'Messages from the administration': 'Nachrichten der Administration',
		'Messages from the administration about {{val1}}': 'Nachrichten der Administration zu {{val1}}',
		'No messages yet': 'Noch keine Nachrichten',
		'Update Name': 'Name ändern',
		'Company Name successfully changed': 'Firmenname erfolgreich geändert',
		'REGENERATED COMPANY CERTIFICATE': 'Firmenbuchauszug wurde neu erzeugt',
		'zu prüfen': 'zu prüfen',
		'Comment on the activation (optional)': 'Kommentar zur Aktivierung (freiwillig)',
		'No sales forecast yet': 'Noch keine Umsatzprognose',
		'No risks recorded yet': 'Noch keine Risiken erfasst',
		'Estimated annual sales, total': 'Geschätzter Jahresumsatz gesamt',
		'School and teachers': 'Schule & Lehrkräfte',
		location: 'Adresse',
		'How a company gets an expert': 'Wie ein Unternehmen zu Wirtschaftsexpert:innen kommt',
		'Quick guide': 'Kurzanleitung',
		'Expert flow badge': 'Keine Zuweisung möglich',
		'Expert flow route one': 'Weg 1 · Bestehende Expert:innen anfragen',
		'Expert flow new people': 'Weg 2 · Neue Personen einladen',
		'Expert step request title': 'Anfrage',
		'Expert step notified title': 'Benachrichtigung',
		'Expert step decision title': 'Entscheidung',
		'Expert step connected title': 'Verbunden',
		'Expert connection intro':
			'Die Verwaltung kann hier niemanden zuweisen. Eine Verbindung entsteht nur, wenn das Unternehmen selbst anfragt und die Expert:in zusagt.',
		'Expert step request':
			'Eine Schüler:in oder Lehrkraft öffnet ein Expert:innenprofil und wählt „Expert:in anfragen" — eine Begleitnachricht ist möglich.',
		'Expert step notified':
			'Die Anfrage erscheint bei der Expert:in unter „Meine Verbindungen"; zusätzlich geht eine E-Mail hinaus.',
		'Expert step decision': 'Die Expert:in nimmt an oder lehnt ab. Beide Seiten werden per E-Mail informiert.',
		'Expert step connected':
			'Erst ab „Verbunden" sind die Kontaktdaten für das Unternehmen sichtbar. Beide Seiten können die Zusammenarbeit jederzeit wieder beenden.',
		'Expert invite anyone':
			'Schüler:innen und Lehrkräfte laden Expert:innen selbst ein — meist Bekannte oder Familie, ohne Freigabe durch Junior Achievement. Die eingeladene Person ist danach zunächst nur für diese Junior Company sichtbar. Die Verwaltung legt neue Profile unter',
		Available: 'hinterlegt',
		Missing: 'fehlt',
		'Company certificate renewed': 'Firmenbuchauszug neu erzeugt',
		'Company certificate renewed details':
			'Der Firmenname wurde geändert. Weil das Unternehmen aktiviert ist, wurde der Firmenbuchauszug sofort neu erzeugt — Sie finden ihn im Reiter <b>Dokumente</b>.<br><br>Der bisherige Auszug verliert damit seine Gültigkeit und sollte nicht weiter verwendet werden.',
		Understood: 'Verstanden',
		'Company profile': 'Firmenprofil',
		'Not available': 'Nicht verfügbar',
		'Something went wrong': 'Etwas ist schiefgelaufen',

		// Listen und Vorschau
		Download: 'Herunterladen',
		'Previous file': 'Vorherige Datei',
		'Next file': 'Nächste Datei',
		'Use the arrow keys to page through.': 'Mit den Pfeiltasten blättern.',
		'The file could not be opened.': 'Die Datei konnte nicht geöffnet werden.',
		'This file type cannot be shown here.': 'Dieses Dateiformat lässt sich hier nicht anzeigen.',
		'Confirmation pending': 'Bestätigung ausstehend',
		'Teacher activated': 'Lehrkraft freigegeben',
		'Only companies without reports can be deleted.':
			'Löschen ist nur bei Companies ohne Berichte und ohne Aktivierung möglich.',
		'Rejection is only possible until the first report.':
			'Ablehnen ist nur bis zum ersten abgegebenen Bericht möglich. Danach hängen Rechnung, Anteile und Bericht an diesem Unternehmen.',

		// Rueckfrage vor dem Verwerfen (UI/ConfirmDialog)
		'Discard unsaved changes?': 'Änderungen verwerfen?',
		'This window contains changes that have not been saved yet.':
			'In diesem Fenster stehen Änderungen, die noch nicht gespeichert sind.',
		'Discard changes': 'Verwerfen',
		'Continue editing': 'Weiter bearbeiten',

		// Dashboard: was als Naechstes zu tun ist (views/common/CompanySteps)
		'Checklist up to activation': 'Checkliste bis zur Aktivierung',
		'Checklist up to the certificate': 'Checkliste bis zur Urkunde',
		// Fortschrittsbalken (UI/CompanyProgress)
		'Company progress': 'Fortschritt des Unternehmens',
		'Current step': 'Jetzt an der Reihe',
		'All steps done': 'Alle Schritte erledigt',
		// Balken und Checkliste zeigen einander (shared/companyStepLink)
		'Show the matching item in the checklist': 'Den passenden Punkt in der Checkliste hervorheben',
		'Show the matching step in the progress bar': 'Den passenden Schritt im Fortschrittsbalken hervorheben',
		done: 'erledigt',
		Add: 'Hinzufügen',
		'Go there': 'Öffnen',
		'Open link': 'Link öffnen',
		'overdue by {{days}} days': 'überfällig seit {{days}} Tagen',
		'Optional — you can upload the business plan of your Junior Company here.':
			'Freiwillig — hier könnt ihr den Businessplan eurer Junior Company hinterlegen.',
		'Sell shares': 'Anteilscheine verkaufen',
		'Issue share certificates to your shareholders.': 'Anteilscheine an die Anteilseigner:innen ausgeben.',
		'Financial Report': 'Finanzbericht',
		'Fill in the report and submit it.': 'Bericht ausfüllen und abgeben.',
		'The invoice is in your documents as soon as the report has been submitted.':
			'Die Rechnung liegt in den Dokumenten, sobald der Bericht abgegeben ist.',
		'Upload your business report.': 'Den Geschäftsbericht hochladen.',
		'Possible as soon as the financial reports have been submitted.':
			'Möglich, sobald die Finanzberichte abgegeben sind.',
		// Das Konzept, wo es den ersten Finanzbericht sperrt statt der Aktivierung
		'Required before the first financial report can be submitted':
			'Muss erledigt sein, bevor der erste Finanzbericht abgegeben werden kann',
		// Kurzform im Fortschrittsbalken — die Checkliste nennt den Punkt ausführlich
		Skills4Retail: 'Skills4Retail',
		// Die eigene Spur des Konzepts über dem Fortschrittsbalken (#209)
		'Skills4Retail – can be worked on at any time': 'Skills4Retail – jederzeit bearbeitbar',
		'Skills4Retail submission': 'Abgabe',
		'Skills4Retail due by {{date}}': 'bis {{date}}',
		'Skills4Retail due before the review': 'vor der Prüfung',
		'Skills4Retail due before the first report': 'vor dem ersten Bericht',
		'Skills4Retail submitted': 'erledigt',
		// Der letzte Schritt: die Urkunden
		Certificates: 'Urkunden',
		'Your certificates are in your documents.': 'Eure Urkunden liegen in den Dokumenten.',
		'The certificates are issued once the business report is uploaded and all invoices are paid.':
			'Die Urkunden werden ausgestellt, sobald der Geschäftsbericht hochgeladen und alle Rechnungen bezahlt sind.',

		// Dashboard der Lehrkraft: welche betreute Junior Company gemeint ist
		'Switch Junior Company': 'Junior Company wechseln',
		'You supervise {{total}} Junior Companies': 'Sie betreuen {{total}} Junior Companies',
		'Currently shown': 'Wird gerade angezeigt',
		'You are not supervising any Junior Company yet.': 'Sie betreuen noch keine Junior Company.',
		// Mitarbeiter:innen der Junior Company: Liste, Detailfenster, Einladungen
		'Show details': 'Details anzeigen',
		'Make CEO': 'Geschäftsführung (CEO) zuweisen',
		'Managing director (CEO)': 'Geschäftsführung (CEO)',
		'The CEO function is transferred to {{name}}. The current CEO loses it.':
			'Die Geschäftsführung (CEO) geht an {{name}} über. Die bisherige Geschäftsführung gibt sie damit ab.',
		Invitation: 'Einladung',
		Validity: 'Gültigkeit',
		'Invitation deleted': 'Einladung gelöscht',
		'The invitation will be withdrawn.': 'Die Einladung wird zurückgezogen.',
		'The invitation to {{email}} will be withdrawn.': 'Die Einladung an {{email}} wird zurückgezogen.',
		'An invitation has been sent — the account does not exist yet.':
			'Die Einladung ist unterwegs — ein Zugang besteht noch nicht.',
		'Invited by': 'Eingeladen von',
		'Invited on': 'Eingeladen am',
		'The person receives an email with a registration link. Until they have registered, the invitation is shown in the employee list.':
			'Die Person bekommt eine E-Mail mit einem Link zur Anmeldung. Bis sie sich angemeldet hat, steht die Einladung in der Mitarbeiter:innenliste.',
		// Lebensmittelhygiene und Allergeninformation (Anforderung #96)
		'Note on food hygiene and allergen information': 'Hinweis zu Lebensmittelhygiene und Allergeninformation',
		'Statutory requirements apply to the production, processing, sale and labelling of food as well as products and services applied to the body. If the hygiene and allergen training is not covered in the curriculum, it must be completed before production begins. All information and the courses can be found at':
			'Für die Herstellung, Verarbeitung, Abgabe und Kennzeichnung von Lebensmitteln sowie körpernahen Produkten und Dienstleistungen gelten gesetzliche Anforderungen. Wenn die Hygiene- und Allergenschulung nicht im Lehrplan abgedeckt ist, muss sie vor Beginn der Herstellung absolviert werden. Alle Informationen und die Kurse findet ihr unter',
		'These requirements apply regardless of whether the sale is made for payment, within the school context or only occasionally. Please clarify with your teacher before production begins how these contents are covered in your Junior Company, and confirm this below.':
			'Diese Anforderungen gelten unabhängig davon, ob die Abgabe entgeltlich, im schulischen Rahmen oder nur gelegentlich erfolgt. Bitte klärt vor Beginn der Herstellung gemeinsam mit eurer Lehrkraft, wie diese Inhalte in eurer Junior Company abgedeckt sind, und gebt unten die Bestätigung ab.',
		'The information is a self-declaration of the Junior Company. Junior Achievement Austria only provides the platform for documentation, does not carry out any review and does not give legal advice. The school, the school authority and the supervising teacher are responsible for complying with the applicable regulations. This entry does not replace any officially required certificates or approvals.':
			'Die Angaben sind eine Selbstauskunft der Junior Company. Junior Achievement Austria stellt lediglich die Plattform zur Dokumentation bereit, nimmt keine Prüfung vor und erteilt keine Rechtsauskunft. Für die Einhaltung der jeweils geltenden Vorschriften sind die Schule, der Schulerhalter und die betreuende Lehrkraft verantwortlich. Behördlich vorgeschriebene Nachweise oder Bewilligungen werden durch diese Angabe nicht ersetzt.',
		'Show less': 'Weniger anzeigen',
		'The contents on food hygiene and allergen information are integrated into the curriculum.':
			'Die Inhalte zur Lebensmittelhygiene und Allergeninformation sind im Lehrplan integriert.',
		'Food hygiene and allergen training completed.': 'Lebensmittelhygiene- und Allergenschulung abgeschlossen.',
		'Contents are integrated into the curriculum.': 'Inhalte im Lehrplan integriert.',
		'Please select the employees who completed the training.':
			'Bitte die Mitarbeiter:innen auswählen, die die Schulung absolviert haben.',
		Participants: 'Beteiligte Mitarbeiter:innen',
		'Date of training': 'Datum der Schulung',
		'Confirmed by': 'Bestätigt von',
		'No employees yet.': 'Noch keine Mitarbeiter:innen.',
		Confirm: 'Bestätigen',
		'Confirm again': 'Erneut bestätigen',
		'Confirmation saved.': 'Bestätigung gespeichert.',
		'Please select one of the two statements.': 'Bitte eine der beiden Angaben auswählen.',
		'Please save the branch first — the confirmation belongs to the saved branch.':
			'Bitte zuerst die Branche speichern — die Bestätigung gehört zur gespeicherten Branche.',
		'A completed training cannot be withdrawn.': 'Eine abgeschlossene Schulung lässt sich nicht zurücknehmen.',
		'No confirmation has been submitted yet.': 'Es wurde noch keine Bestätigung abgegeben.',
		'The supervising teacher has objected to this confirmation.':
			'Die betreuende Lehrkraft hat dieser Bestätigung widersprochen.',
		'Object to this confirmation': 'Dieser Bestätigung widersprechen',
		Object: 'Widersprechen',
		'Objection saved.': 'Widerspruch gespeichert.',
		'Please state briefly why the confirmation is not correct.':
			'Bitte kurz angeben, warum die Bestätigung nicht zutrifft.',
		'Skills4Retail concept completed and assessed': 'Skills4Retail-Konzept abgeschlossen und bewertet',
		'Your concept must be submitted and assessed by your teacher':
			'Euer Konzept muss abgegeben und von der Lehrkraft bewertet sein',
		'To the concept': 'Zum Konzept',
		'Food hygiene and allergen information confirmed': 'Bestätigung zur Lebensmittelhygiene abgegeben',
		'Confirm how food hygiene and allergen information is covered in your company':
			'Bestätigt, wie Lebensmittelhygiene und Allergeninformation in eurer Junior Company abgedeckt sind',
		'To the business activity': 'Zur Geschäftstätigkeit',
		'Food hygiene: confirmation submitted': 'Lebensmittelhygiene: Bestätigung abgegeben',
		'Course completed — congratulations!': 'Geschafft! Die Lernstrecke ist abgeschlossen',
		'You have passed every chapter of the Skills4Retail course.':
			'Du hast alle Kapitel der Lernstrecke Skills4Retail bestanden.',
		'{{val1}} of {{val2}} required completions are done.':
			'Damit sind {{val1}} von {{val2}} nötigen Abschlüssen erreicht.',
		'Everyone in the Junior Company has finished.': 'Alle in der Junior Company sind fertig.',
		'One person has not finished yet.': 'Eine Person ist noch nicht fertig.',
		'{{val1}} people have not finished yet.': '{{val1}} Personen sind noch nicht fertig.',
		'Next, your teacher assesses the concept — only then can the company be activated.':
			'Als Nächstes bewertet eure Lehrkraft das Konzept — erst danach kann das Unternehmen aktiviert werden.',
		'Next, your teacher assesses the concept — only then can you submit the financial report.':
			'Als Nächstes bewertet eure Lehrkraft das Konzept — erst danach könnt ihr den Finanzbericht einreichen.',
		'The concept is currently not required for your Junior Company — you can still fetch your certificate.':
			'Für eure Junior Company wird das Konzept zurzeit nicht verlangt — eure Teilnahmebestätigung könnt ihr euch trotzdem holen.',
		'Next, your teacher assesses the concept.': 'Als Nächstes bewertet eure Lehrkraft das Konzept.',
		'{{val1}} has completed the course': '{{val1}} hat die Lernstrecke abgeschlossen',
		'A student': 'Eine Schüler:in',
		'In the Junior Company {{val1}}:': 'In der Junior Company {{val1}}:',
		'Concept awaiting your assessment': 'Konzept wartet auf Ihre Bewertung',
		'The Junior Company {{val1}} has completed its concept on e-commerce and digital marketing. Please assess the fifteen fields with 0 to 10 points each.':
			'Die Junior Company {{val1}} hat ihr Konzept „Marketing & E-Commerce“ abgeschlossen. Bitte bewerten Sie die fünfzehn Felder mit je 0 bis 10 Punkten.',
		'{{val1}} has returned your concept for revision. You can edit it again.':
			'{{val1}} hat euer Konzept zur Überarbeitung zurückgegeben. Ihr könnt es jetzt wieder bearbeiten.',
		'Concept assessed': 'Konzept bewertet',
		'{{val1}} has assessed your concept: {{val2}} out of {{val3}} points.':
			'{{val1}} hat euer Konzept bewertet: {{val2}} von {{val3}} Punkten.',
		'Concept assessment still pending': 'Bewertung des Konzepts steht noch aus',
		'The concept of the Junior Company {{val1}} has been waiting {{val2}} days for your assessment.':
			'Das Konzept der Junior Company {{val1}} wartet seit {{val2}} Tagen auf Ihre Bewertung.',
		'to the concept': 'zum Konzept',
		'The Junior Company {{val1}} operates in a sensitive branch ({{val2}}) and has confirmed: {{val3}}':
			'Die Junior Company {{val1}} ist in der Branche {{val2}} tätig und hat bestätigt: {{val3}}',
		'to the dashboard': 'zum Dashboard',
		'Food hygiene: objection by your teacher': 'Lebensmittelhygiene: Widerspruch der Lehrkraft',
		'{{val1}} has objected to your confirmation on food hygiene and allergen information. Please clarify it together and confirm again.':
			'{{val1}} hat eurer Bestätigung zur Lebensmittelhygiene und Allergeninformation widersprochen. Bitte klärt das gemeinsam und bestätigt danach neu.',
		'Download your documents before the annual reset': 'Unterlagen vor dem Jahresreset herunterladen',
		'On {{val1}} all Junior Companies and student accounts will be deleted. Please download everything you want to keep beforehand — certificates, reports and documents.':
			'Am {{val1}} werden alle Junior Companies und die Konten der Schüler:innen gelöscht. Ladet vorher alles herunter, was ihr behalten wollt — Urkunden, Berichte und Dokumente.',
		'To the documents': 'Zu den Dokumenten',
		'Food hygiene training still open': 'Hygieneschulung noch offen',
		'For {{val1}} the food hygiene and allergen training has not been completed yet. It must be completed before production begins.':
			'Für {{val1}} steht die Lebensmittelhygiene- und Allergenschulung noch aus. Sie ist vor Beginn der Herstellung zu absolvieren.',
		'Food hygiene confirmation submitted': 'Bestätigung zur Lebensmittelhygiene abgegeben',
		'Concept submitted for assessment': 'Konzept zur Bewertung abgeschlossen',
		'Concept returned for revision': 'Konzept zur Überarbeitung zurückgegeben',
		'Concept fully assessed': 'Konzept vollständig bewertet',
		'Exempted from the concept quizzes': 'Von der Quizpflicht des Konzepts befreit',
		'Quiz exemption revoked': 'Befreiung von der Quizpflicht aufgehoben',
		'Concept requirement waived by the administration': 'Konzept von der Administration freigegeben',
		'Objection to the food hygiene confirmation': 'Widerspruch zur Hygiene-Bestätigung',
		'Leave company': 'Aus dem Unternehmen austreten',
		'You will be removed from this Junior Company and logged out.':
			'Du wirst aus dieser Junior Company entfernt und abgemeldet.',
		'Leaving is not possible.': 'Ein Austritt ist nicht möglich.',
		'An activated company needs at least two employees.':
			'Ein aktiviertes Unternehmen braucht mindestens zwei Mitarbeiter:innen.',
		Proofs: 'Nachweise',
		'Assigned to': 'Zugehörig zu',
		'No document uploaded yet': 'Noch kein Dokument hochgeladen',
		'Upload document': 'Dokument hochladen',
		'Replace document': 'Dokument ersetzen',
		'Uploading…': 'Wird hochgeladen …',
		'Document uploaded': 'Dokument hochgeladen',
		'The file is too large. Maximum 10 MB.': 'Die Datei ist zu groß. Höchstens 10 MB.',
		'You can upload the required documents on behalf of this student. The document stays assigned to the student.':
			'Du kannst die benötigten Nachweise an Stelle dieser Schüler:in hochladen. Das Dokument bleibt der Schüler:in zugeordnet.',
		'Uploading on behalf of students is not enabled for this company type.':
			'Für diese Unternehmensform ist der Upload durch die Lehrkraft nicht freigegeben.',
		'Einverständniserklärung der Erziehungsberechtigten — Upload durch die Lehrkraft':
			'Einverständniserklärung der Erziehungsberechtigten — Upload durch die Lehrkraft',
		'Parental confirmation uploaded by the teacher': 'Einverständniserklärung durch die Lehrkraft hochgeladen',
		'Course certificate uploaded by the teacher': 'Kursnachweis durch die Lehrkraft hochgeladen',
		Reason: 'Begründung',
		'Please give a reason.': 'Bitte eine Begründung angeben.',
		'Object to this document?': 'Nachweis beanstanden?',
		'The student is informed and can upload a replacement. The file stays and can still be viewed.':
			'Die Schüler:in wird benachrichtigt und kann eine neue Datei hochladen. Die Datei bleibt liegen und lässt sich weiter ansehen.',
		'e.g. signature is missing': 'z. B. Unterschrift fehlt',
		'Delete this document?': 'Nachweis löschen?',
		'The file is deleted for good. The student is informed and has to upload a new one.':
			'Die Datei wird endgültig gelöscht. Die Schüler:in wird benachrichtigt und muss eine neue hochladen.',
		'e.g. wrong file uploaded': 'z. B. falsche Datei hochgeladen',
		'Document objected to': 'Nachweis beanstandet',
		'Document deleted': 'Nachweis gelöscht',
		'Document removed': 'Nachweis entfernt',
		'The document': 'Der Nachweis',
		'{{val1}} was removed by your teacher. Please upload the correct file again.':
			'{{val1}} wurde von deiner Lehrkraft entfernt. Bitte lade die richtige Datei erneut hoch.',
		'This company is activated. This document is a requirement for activation and can no longer be replaced, objected to or deleted.':
			'Diese Junior Company ist aktiviert. Dieser Nachweis ist eine Voraussetzung der Aktivierung und lässt sich nicht mehr ersetzen, beanstanden oder löschen.',
		'Object to document': 'Beanstanden',
		'Parental confirmation objected to by the teacher': 'Einverständniserklärung durch die Lehrkraft beanstandet',
		'Course certificate objected to by the teacher': 'Kursnachweis durch die Lehrkraft beanstandet',
		'Parental confirmation removed by the teacher': 'Einverständniserklärung durch die Lehrkraft entfernt',
		'Previous month': 'Voriger Monat',
		'Next month': 'Nächster Monat',
		Month: 'Monat',
		Year: 'Jahr',
		Added: 'Neu seit',
		'Last 24 hours': 'Letzte 24 Stunden',
		'Last 7 days': 'Letzte 7 Tage',
		'Last 30 days': 'Letzte 30 Tage',
		'All Junior Companies on record.': 'Alle Junior Companies im Bestand.',
		'Created in the last 24 hours.': 'In den letzten 24 Stunden angelegt.',
		'Submitted for review — waiting to be activated by the administration.':
			'Zur Prüfung eingereicht — wartet auf die Aktivierung durch die Verwaltung.',
		'Registered and not yet activated.': 'Registriert und noch nicht aktiviert.',
		'Activated Junior Companies.': 'Aktivierte Junior Companies.',
		'All students on record.': 'Alle Schüler:innen im Bestand.',
		'Parental confirmation uploaded and not yet checked.':
			'Elternbestätigung liegt hochgeladen vor und ist noch nicht geprüft.',
		'Parental confirmation checked.': 'Elternbestätigung geprüft.',
		'Neither uploaded nor checked yet.': 'Weder hochgeladen noch geprüft.',
		'All teachers on record.': 'Alle Lehrkräfte im Bestand.',
		'Not yet released — waiting to be confirmed by the administration.':
			'Noch nicht freigeschaltet — wartet auf die Bestätigung durch die Verwaltung.',
		'Released teachers.': 'Freigeschaltete Lehrkräfte.',
		'All invoices except the cancelled ones.': 'Alle Rechnungen ohne die stornierten.',
		'Issued in the last 24 hours.': 'In den letzten 24 Stunden gestellt.',
		'Issued and not yet paid.': 'Gestellt und noch nicht bezahlt.',
		'Paid invoices.': 'Bezahlte Rechnungen.',
		'Overdue invoices.': 'Überfällige Rechnungen.',
		'Invoices in credit.': 'Rechnungen mit Guthaben.',
		'Cancelled invoices.': 'Stornierte Rechnungen.',
		'All submitted reports.': 'Alle eingereichten Berichte.',
		'Submitted in the last 24 hours.': 'In den letzten 24 Stunden eingereicht.',
		'This figure is currently not collected.': 'Diese Zahl wird derzeit nicht erhoben.',
		'Course certificate removed by the teacher': 'Kursnachweis durch die Lehrkraft entfernt',
		// Handbuch zur Lernstrecke Skills4Retail (Anforderung #187)
		'Skills4Retail handbook': 'Handbuch Skills4Retail',
		'Opens the handbook on the Skills4Retail course and the concept as a PDF in a new tab.':
			'Öffnet das Handbuch zur Lernstrecke Skills4Retail und zur Konzepterstellung als PDF in einem neuen Tab.',
		'The handbook is loading …': 'Das Handbuch wird geladen …',
		// Anforderung #182: fehlende Dokumente, Vorlagen für Lehrkräfte
		'All documents have been uploaded.': 'Alle Dokumente sind hochgeladen.',
		'One document is still missing.': 'Es fehlt noch 1 Dokument.',
		'Several documents are still missing.': 'Es fehlen noch {{count}} Dokumente.',
		'You will find the templates to download and the upload field directly with each document below.':
			'Die Vorlagen zum Herunterladen und das Feld zum Hochladen finden Sie direkt bei den Dokumenten unten.',
		'Documents are still missing': 'Es fehlen noch Dokumente',
		'Templates for your students': 'Vorlagen für Ihre Schüler:innen',
		'Looking for the consent form template for your students?': 'Sie suchen die Vorlage der Einverständniserklärung für Ihre Schüler:innen? Sie finden sie unter',
		'in „My profile“.': 'in „Mein Profil“.',
		'Every student needs the consent form signed by a parent or guardian. Download the template for each Junior Company here — your students also find it in their own profile under „Documents“.':
			'Jede Schüler:in braucht die Einverständniserklärung der Erziehungsberechtigten. Hier laden Sie die Vorlage je Junior Company herunter – Ihre Schüler:innen finden sie auch selbst in ihrem Profil im Reiter „Dokumente“.',
		'As soon as you supervise a Junior Company, you will find the consent form template for its students here.':
			'Sobald Sie eine Junior Company betreuen, finden Sie hier die Vorlage der Einverständniserklärung für deren Schüler:innen.',
		'The Junior Companies could not be loaded.': 'Die Junior Companies konnten nicht geladen werden.',
		// Hinweis nach dem Herunterladen der Teilnahmeurkunde (JC/JCC, Anforderung #212)
		'Your journey continues': 'Dein Weg geht weiter',
		SupporterInvitationText:
			'Dein Weg in der Entrepreneurship-Szene kann weitergehen. Melde dich <signup>hier</signup> als Unterstützer:in an und verpasse keine neuen Events oder unterstütze neue Junior Companies mit deiner Expertise.'
	}
}

export default ger
